/**
 * DataGridXL
 * v1.20.10.01
 * (c) Vanilla Components
 * https://datagridxl.com/buy
 */

!(function (t, e) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = e())
    : "function" == typeof define && define.amd
    ? define(e)
    : ((t = t || self).DataGridXL = e());
})(this, function () {
  "use strict";
  var t = function (t) {
    (this.events = {}), (this._anyEvent = "any"), (this._context = t);
  };
  function e() {
    return navigator.platform.indexOf("Mac") > -1;
  }
  (t.prototype.on = function (t, e) {
    return (
      "function" == typeof e &&
      "string" == typeof t &&
      (void 0 === this.events[t] && (this.events[t] = { listeners: [] }),
      !(this.events[t].listeners.indexOf(e) > -1) &&
        void this.events[t].listeners.push(e))
    );
  }),
    (t.prototype.off = function (t, e) {
      if (void 0 === this.events[t]) return !1;
      this.events[t].listeners = this.events[t].listeners.filter(function (t) {
        return t !== e;
      });
    }),
    (t.prototype.dispatch = function (t, e, o) {
      var i = this;
      if (
        (void 0 === e && (e = {}),
        void 0 === o && (o = t),
        t != this._anyEvent && this.dispatch(this._anyEvent, e, t),
        void 0 === this.events[t])
      )
        return !0;
      var s = [];
      this.events[t].listeners.forEach(function (t) {
        s.push(t.call(i._context, e, o));
      });
      for (var l = 0; l < s.length; l++) if (!1 === s[l]) return !1;
      return !0;
    });
  var o = function (t) {
    (this._actionKeys = {
      backspace: 8,
      tab: 9,
      enter: 13,
      break: 19,
      pause: 19,
      esc: 27,
      escape: 27,
      space: 32,
      pageup: 33,
      pagedown: 34,
      end: 35,
      home: 36,
      left: 37,
      up: 38,
      right: 39,
      down: 40,
      ins: 45,
      insert: 45,
      del: 46,
      delete: 46,
      plus: 61,
    }),
      (this._alphanumericKeys = i()),
      (this._modifierKeys = {
        shift: "shiftKey",
        ctrl: e() ? "metaKey" : "ctrlKey",
        alt: "altKey",
      }),
      (this._nonInputKeyCodes = [
        8, 9, 13, 16, 17, 18, 19, 20, 27, 33, 34, 35, 36, 37, 38, 39, 40, 44,
        45, 46, 91, 92, 93, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121,
        122, 123, 144, 145, 182, 183,
      ]),
      (this._modifierKeyCodes = [16, 17, 18, 91, 93]),
      (this._metaKeyCodes = [91, 93]),
      (this._context = t),
      (this.trackedActionKeys = []),
      (this.trackedAlphanumericKeys = []),
      (this.trackedModifierKeys = []),
      (this.pressedActionKeys = {}),
      (this.pressedAlphanumericKeys = {}),
      (this.pressedModifierKeys = {}),
      (this.identifyKeyActionTimeout = null),
      (this._keyRanges = {
        "range:input": function (t) {
          return (
            -1 == this._nonInputKeyCodes.indexOf(t.which || t.keyCode) &&
            !t.ctrlKey &&
            !t.altKey &&
            !t.metaKey
          );
        },
        "range:ctrl": function (t) {
          return t.ctrlKey || t.metaKey || 17 == (t.which || t.keyCode);
        },
      }),
      (this.keysToPrevent = {}),
      (this.trackedKeyRanges = []),
      (this.prevKeyAction = null),
      (this.keyActions = []),
      (this.keys = {}),
      (this.keyHoldDelay = 350),
      (this.keyHoldInterval = 60),
      (this._isSuspended = !1),
      (this._keyDownListener = s.bind(this)),
      (this._keyUpListener = l.bind(this)),
      (this._identifyKeyAction = r.bind(this)),
      document.addEventListener("keydown", this._keyDownListener),
      document.addEventListener("keyup", this._keyUpListener);
  };
  (o.prototype.on = function (t, e, o) {
    void 0 === o && (o = !0);
    var i = !1,
      s = !1,
      l = "";
    if (t.trim() in this._keyRanges) (i = !0), (s = !0), (l = t.trim());
    else {
      for (
        var n = [], r = [], c = [], d = ((t = t.split("+")), []), a = 0;
        a < t.length;
        a++
      ) {
        var u = t[a].trim();
        u in this._modifierKeys
          ? n.push(u)
          : u in this._actionKeys
          ? r.push(u)
          : u in this._alphanumericKeys && c.push(u),
          d.push(u);
      }
      h({ modifierKeys: n, actionKeys: r, alphanumericKeys: c }) &&
        ((i = !0), (s = !1), (l = d.join("+")));
    }
    if (i) {
      if (void 0 === this.keys[l] && ((this.keys[l] = { actions: [] }), !s)) {
        this.keyActions.push({
          actionKeys: r,
          alphanumericKeys: c,
          modifierKeys: n,
          keyString: l,
        });
        for (a = 0; a < r.length; a++)
          this._actionKeys[r[a]] in this.keysToPrevent ||
            (this.keysToPrevent[this._actionKeys[r[a]]] = []),
            this.keysToPrevent[this._actionKeys[r[a]]].push(l);
      }
      for (a = 0; a < this.keys[l].actions.length; a++)
        if (
          this.keys[l].actions[a].callback == e &&
          this.keys[l].actions[a].repeatable == o
        )
          return;
      if ((this.keys[l].actions.push({ callback: e, repeatable: o }), !s)) {
        var p = null;
        for (a = 0; a < d.length; a++)
          d[a] in this._modifierKeys
            ? -1 ==
                this.trackedModifierKeys.indexOf(this._modifierKeys[d[a]]) &&
              this.trackedModifierKeys.push(this._modifierKeys[d[a]])
            : d[a] in this._actionKeys
            ? ((p = this._actionKeys[d[a]]),
              -1 == this.trackedActionKeys.indexOf(p) &&
                this.trackedActionKeys.push(p))
            : d[a] in this._alphanumericKeys &&
              ((p = this._alphanumericKeys[d[a]]),
              -1 == this.trackedAlphanumericKeys.indexOf(p) &&
                this.trackedAlphanumericKeys.push(p));
      }
    }
  }),
    (o.prototype.off = function (t, e) {
      for (
        var o = [], i = [], s = [], l = ((t = t.split("+")), []), n = 0;
        n < t.length;
        n++
      ) {
        var r = t[n].trim();
        r in this._modifierKeys
          ? s.push(r)
          : r in this._actionKeys
          ? o.push(r)
          : r in this._alphanumericKeys && i.push(r),
          l.push(r);
      }
      if (h({ modifierKeys: s, actionKeys: o, alphanumericKeys: i })) {
        var c = l.join("+");
        if (
          void 0 !== this.keys[c] &&
          ((this.keys[c].actions = this.keys[c].actions.filter(function (t) {
            return t.callback !== e;
          })),
          !this.keys[c].actions.length)
        ) {
          delete this.keys[c];
          for (n = 0; n < this.keyActions.length; n++)
            if (this.keyActions[n].keyString == c) {
              for (var d = 0; d < this.keyActions[n].actionKeys.length; d++)
                if (
                  this._actionKeys[this.keyActions[n].actionKeys[d]] in
                  this.keysToPrevent
                ) {
                  var a =
                    this.keysToPrevent[
                      this._actionKeys[this.keyActions[n].actionKeys[d]]
                    ].indexOf(c);
                  a > -1 &&
                    this.keysToPrevent[
                      this._actionKeys[this.keyActions[n].actionKeys[d]]
                    ].splice(a, 1),
                    this.keysToPrevent[
                      this._actionKeys[this.keyActions[n].actionKeys[d]]
                    ].length ||
                      delete this.keysToPrevent[
                        this._actionKeys[this.keyActions[n].actionKeys[d]]
                      ];
                }
              this.keyActions.splice(n, 1);
              break;
            }
        }
      }
    }),
    (o.prototype.suspend = function () {
      document.removeEventListener("keydown", this._keyDownListener),
        document.removeEventListener("keyup", this._keyUpListener);
    }),
    (o.prototype.resume = function () {
      document.addEventListener("keydown", this._keyDownListener),
        document.addEventListener("keyup", this._keyUpListener);
    });
  var i = function () {
      for (
        var t = {},
          e = [
            { startIndex: 65, series: "abcdefghijklmnopqrstuvwxyz" },
            { startIndex: 48, series: "0123456789" },
          ],
          o = 0;
        o < e.length;
        o++
      )
        for (var i = 0; i < e[o].series.length; i++)
          t[e[o].series[i]] = e[o].startIndex + i;
      return t;
    },
    s = function (t) {
      var e = this,
        o = t.which || t.keyCode;
      if (
        "input" != t.target.tagName.toLowerCase() &&
        (o in this.keysToPrevent && t.preventDefault(),
        !(
          this._modifierKeyCodes.indexOf(o) > -1 &&
          null === this.identifyKeyActionTimeout
        ))
      ) {
        for (var i in this._keyRanges)
          i in this.keys &&
            this._keyRanges[i].call(this, t) &&
            this.keys[i].actions.forEach(function (t) {
              t.callback.call(e._context);
            });
        for (var s = 0; s < this.trackedModifierKeys.length; s++) {
          var l = this.trackedModifierKeys[s];
          l in t && 1 == t[l]
            ? (this.pressedModifierKeys[l] = !0)
            : l in this.pressedModifierKeys &&
              delete this.pressedModifierKeys[l];
        }
        this.trackedActionKeys.indexOf(o) > -1 &&
          !this.pressedActionKeys[o] &&
          (this.pressedActionKeys[o] = !0),
          this.trackedAlphanumericKeys.indexOf(o) > -1 &&
            !this.pressedAlphanumericKeys[o] &&
            (this.pressedAlphanumericKeys[o] = !0),
          null === this.identifyKeyActionTimeout && r.call(this, t);
      }
    },
    l = function (t) {
      var e = t.which || t.keyCode;
      this.pressedActionKeys[e] && delete this.pressedActionKeys[e],
        this.pressedAlphanumericKeys[e] &&
          delete this.pressedAlphanumericKeys[e],
        this._metaKeyCodes.indexOf(e) > -1 &&
          ((this.pressedAlphanumericKeys = {}), (this.pressedActionKeys = {})),
        0 == Object.keys(this.pressedActionKeys).length &&
          0 == Object.keys(this.pressedAlphanumericKeys).length &&
          n.call(this);
    },
    n = function () {
      clearTimeout(this.identifyKeyActionTimeout),
        (this.identifyKeyActionTimeout = null),
        (this.pressedActionKeys = {}),
        (this.pressedAlphanumericKeys = {}),
        (this.pressedModifierKeys = {}),
        (this.prevKeyAction = null);
    },
    r = function (t) {
      var o = this;
      if (document.hasFocus()) {
        for (var i = [], s = 0; s < this.keyActions.length; s++) {
          for (
            var l = 0, n = 0;
            n < this.keyActions[s].modifierKeys.length;
            n++
          )
            this.pressedModifierKeys[
              this._modifierKeys[this.keyActions[s].modifierKeys[n]]
            ] && l++;
          for (n = 0; n < this.keyActions[s].actionKeys.length; n++)
            this.pressedActionKeys[
              this._actionKeys[this.keyActions[s].actionKeys[n]]
            ] && l++;
          for (n = 0; n < this.keyActions[s].alphanumericKeys.length; n++)
            this.pressedAlphanumericKeys[
              this._alphanumericKeys[this.keyActions[s].alphanumericKeys[n]]
            ] && l++;
          l > 0 &&
            l ==
              this.keyActions[s].actionKeys.length +
                this.keyActions[s].alphanumericKeys.length +
                this.keyActions[s].modifierKeys.length &&
            i.push(this.keyActions[s]);
        }
        if (
          (i.length > 1 &&
            i.sort(function (t, e) {
              return (
                e.actionKeys.length +
                e.modifierKeys.length -
                (t.actionKeys.length + t.modifierKeys.length)
              );
            }),
          i.length
            ? (i[0] == this.prevKeyAction
                ? this.keyActionRepeatCounter++
                : (this.keyActionRepeatCounter = 0),
              this.keys[i[0].keyString].actions.forEach(function (t) {
                (1 != t.repeatable && 0 != o.keyActionRepeatCounter) ||
                  t.callback.call(o._context);
              }),
              e() &&
                i[0].modifierKeys.indexOf("ctrl") > -1 &&
                ((this.pressedAlphanumericKeys = {}),
                (this.pressedActionKeys = {})),
              (this.prevKeyAction = i[0]))
            : ((this.keyActionRepeatCounter = 0), (this.prevKeyAction = null)),
          0 == this.keyActionRepeatCounter)
        )
          var r = this.keyHoldDelay;
        else r = this.keyHoldInterval;
        this.identifyKeyActionTimeout = setTimeout(this._identifyKeyAction, r);
      }
    },
    h = function (t) {
      var e = !0;
      return (
        "keyRange" in t ||
          (((t.modifierKeys.length &&
            !t.actionKeys.length &&
            !t.alphanumericKeys.length) ||
            (!t.modifierKeys.length &&
              !t.actionKeys.length &&
              t.alphanumericKeys.length) ||
            (t.actionKeys.length && t.alphanumericKeys.length)) &&
            (e = !1)),
        e
      );
    },
    c = function (t) {
      (this.commands = []),
        (this.index = -1),
        (this.limit = 0),
        (this.isExecuting = !1),
        this.callback,
        (this._context = t);
    };
  (c.prototype.add = function (t) {
    return this.isExecuting
      ? this
      : (this.commands.splice(
          this.index + 1,
          this.commands.length - this.index
        ),
        this.commands.push(t),
        this.limit &&
          this.commands.length > this.limit &&
          a(this.commands, 0, -(this.limit + 1)),
        (this.index = this.commands.length - 1),
        this.callback && this.callback(),
        this);
  }),
    (c.prototype.setCallback = function (t) {
      this.callback = t;
    }),
    (c.prototype.undo = function () {
      var t = this.commands[this.index];
      return t && this._context.events.dispatch("beforeundo", { command: t })
        ? (d.call(this, t, "undo"),
          (this.index -= 1),
          this._context.events.dispatch("undo", { command: t }),
          this.callback && this.callback(),
          this)
        : this;
    }),
    (c.prototype.redo = function () {
      var t = this.commands[this.index + 1];
      return t && this._context.events.dispatch("beforeredo", { command: t })
        ? (d.call(this, t, "redo"),
          (this.index += 1),
          this._context.events.dispatch("redo", { command: t }),
          this.callback && this.callback(),
          this)
        : this;
    }),
    (c.prototype.clear = function () {
      var t = this.commands.length;
      (this.commands = []),
        (this.index = -1),
        this.callback && t > 0 && this.callback();
    }),
    (c.prototype.hasUndo = function () {
      return -1 !== this.index;
    }),
    (c.prototype.hasRedo = function () {
      return this.index < this.commands.length - 1;
    }),
    (c.prototype.getCommands = function () {
      return this.commands;
    }),
    (c.prototype.getIndex = function () {
      return this.index;
    }),
    (c.prototype.setLimit = function (t) {
      this.limit = t;
    });
  var d = function (t, e) {
      return t && "function" == typeof t[e]
        ? ((this.isExecuting = !0),
          t[e].call(this._context),
          (this.isExecuting = !1),
          this)
        : this;
    },
    a = function (t, e, o) {
      return (
        t.splice(
          e,
          !o || 1 + o - e + (!((o < 0) ^ (e >= 0)) && (o < 0 || -1) * t.length)
        ),
        t.length
      );
    };
  function u() {
    var t = window.navigator.userAgent,
      e = t.indexOf("MSIE ");
    if (e > 0) return parseInt(t.substring(e + 5, t.indexOf(".", e)), 10);
    if (t.indexOf("Trident/") > 0) {
      var o = t.indexOf("rv:");
      return parseInt(t.substring(o + 3, t.indexOf(".", o)), 10);
    }
    return !1;
  }
  var p = {
      copy: {
        label: "Copy",
        method: function () {
          this.copy();
        },
        shortcut: "Ctrl+C",
        shortcutMac: "⌘C",
        include: function () {
          return this.allowCopy;
        },
      },
      cut: {
        label: "Cut",
        method: function () {
          this.cut();
        },
        shortcut: "Ctrl+X",
        shortcutMac: "⌘X",
        include: function () {
          return this.allowCut;
        },
      },
      paste: {
        label: "Paste",
        method: function () {
          this.paste();
        },
        shortcut: "Ctrl+V",
        shortcutMac: "⌘V",
        include: function () {
          return this.allowPaste;
        },
      },
      delete_rows: {
        label: "Delete Row(s)",
        method: function () {
          this.deleteRows(this.getRowSelection());
        },
        disabled: function () {
          return null == this.getRowSelection();
        },
        include: function () {
          return this.allowRowDelete;
        },
      },
      insert_rows_up: {
        label: "Insert Row(s) (up)",
        method: function () {
          this.insertRows(1, this.getNormalizedRowSelection()[0]);
        },
        disabled: function () {
          return null == this.getRowSelection();
        },
        include: function () {
          return this.allowRowInsert;
        },
      },
      insert_rows_down: {
        label: "Insert Row(s) (down)",
        method: function () {
          this.insertRows(1, this.getNormalizedRowSelection()[1] + 1);
        },
        disabled: function () {
          return null == this.getRowSelection();
        },
        include: function () {
          return this.allowRowInsert;
        },
      },
      delete_cols: {
        label: "Delete Column(s)",
        method: function () {
          this.deleteCols(this.getColSelection());
        },
        disabled: function () {
          return null == this.getColSelection();
        },
        include: function () {
          return this.allowColDelete;
        },
      },
      insert_cols_up: {
        label: "Insert Column(s) (left)",
        method: function () {
          this.insertCols(1, this.getNormalizedColSelection()[0]);
        },
        disabled: function () {
          return null == this.getColSelection();
        },
        include: function () {
          return this.allowColInsert;
        },
      },
      insert_cols_down: {
        label: "Insert Column(s) (right)",
        method: function () {
          this.insertCols(1, this.getNormalizedColSelection()[1] + 1);
        },
        disabled: function () {
          return null == this.getColSelection();
        },
        include: function () {
          return this.allowColInsert;
        },
      },
      sort_asc: {
        label: "Sort A to Z",
        method: function () {
          this.sort(this.getCellCursorPosition().x, "asc");
        },
        disabled: function () {
          return null == this.getColSelection();
        },
        include: function () {
          return this.allowSort;
        },
      },
      sort_desc: {
        label: "Sort Z to A",
        method: function () {
          this.sort(this.getCellCursorPosition().x, "desc");
        },
        disabled: function () {
          return null == this.getColSelection();
        },
        include: function () {
          return this.allowSort;
        },
      },
    },
    _ = {
      copy: {
        label: "Copy",
        method: function () {
          this.copy();
        },
      },
      cut: {
        label: "Cut",
        method: function () {
          this.cut();
        },
      },
      deselect: {
        label: "Deselect",
        method: function () {
          this.deselectAll();
        },
        include: function () {
          return !this.constructor.areCoordsEqual(
            this.getCellSelection()[0],
            this.getCellSelection()[1]
          );
        },
      },
    },
    g = [
      "copy",
      "cut",
      "paste",
      "delete_rows",
      "insert_rows_up",
      "insert_rows_down",
      "delete_cols",
      "insert_cols_up",
      "insert_cols_down",
      "sort_asc",
      "sort_desc",
    ],
    f = ["copy", "deselect"],
    m = {
      tab_navigateNext: {
        keys: "tab",
        action: function () {
          this.moveCellCursorInside({ x: 1, y: 0 });
        },
        repeat: !0,
      },
      shiftTab_navigatePrev: {
        keys: "shift+tab",
        action: function () {
          this.moveCellCursorInside({ x: -1, y: 0 });
        },
        repeat: !0,
      },
      enter_navigateNext: {
        keys: "enter",
        action: function () {
          this.moveCellCursorInside({ x: 0, y: 1 });
        },
        repeat: !0,
      },
      shiftEnter_navigatePrev: {
        keys: "shift+enter",
        action: function () {
          this.moveCellCursorInside({ x: 0, y: -1 });
        },
        repeat: !0,
      },
      ctrlEnter_saveEditor: {
        keys: "ctrl+enter",
        action: function () {
          this.closeEditorAndSave();
        },
        repeat: !1,
        active: function () {
          return this.allowCellEdit;
        },
      },
      enter_openEditor: {
        keys: "enter",
        action: function () {
          this.openEditor("opened");
        },
        repeat: !1,
        active: function () {
          return this.allowCellEdit;
        },
      },
      pageDown_moveCellCursorOneViewportDown: {
        keys: "pagedown",
        action: function () {
          this.moveCellCursorOneViewportDown();
        },
        repeat: !0,
      },
      pageUp_moveCellCursorOneViewportUp: {
        keys: "pageup",
        action: function () {
          this.moveCellCursorOneViewportUp();
        },
        repeat: !0,
      },
      home_moveCellCursorToRowStart: {
        keys: "home",
        action: function () {
          this.moveCellCursorToRowStart();
        },
        repeat: !1,
      },
      end_moveCellCursorToRowEnd: {
        keys: "end",
        action: function () {
          this.moveCellCursorToRowEnd();
        },
        repeat: !1,
      },
      ctrlLeftArrow_moveCellCursorToRowStart: {
        keys: "ctrl+left",
        action: function () {
          this.moveCellCursorToRowStart();
        },
        repeat: !1,
      },
      ctrlRightArrow_moveCellCursorToRowEnd: {
        keys: "ctrl+right",
        action: function () {
          this.moveCellCursorToRowEnd();
        },
        repeat: !1,
      },
      ctrlUpArrow_moveCellCursorToColStart: {
        keys: "ctrl+up",
        action: function () {
          this.moveCellCursorToColStart();
        },
        repeat: !1,
      },
      ctrlDownArrow_moveCellCursorToColEnd: {
        keys: "ctrl+down",
        action: function () {
          this.moveCellCursorToColEnd();
        },
        repeat: !1,
      },
      ctrlHome_moveCellCursorToDocumentStart: {
        keys: "ctrl+home",
        action: function () {
          this.moveCellCursorToDocumentStart();
        },
        repeat: !1,
      },
      ctrlEnd_moveCellCursorToDocumentEnd: {
        keys: "ctrl+end",
        action: function () {
          this.moveCellCursorToDocumentEnd();
        },
        repeat: !1,
      },
      rightArrow_moveCellCursorRight: {
        keys: "right",
        action: function () {
          this.moveCellCursor({ x: 1, y: 0 });
        },
        repeat: !0,
      },
      downArrow_moveCellCursorDown: {
        keys: "down",
        action: function () {
          this.moveCellCursor({ x: 0, y: 1 });
        },
        repeat: !0,
      },
      leftArrow_moveCellCursorLeft: {
        keys: "left",
        action: function () {
          this.moveCellCursor({ x: -1, y: 0 });
        },
        repeat: !0,
      },
      upArrow_moveCellCursorUp: {
        keys: "up",
        action: function () {
          this.moveCellCursor({ x: 0, y: -1 });
        },
        repeat: !0,
      },
      shiftRightArrow_modifySelectionRightwards: {
        keys: "shift+right",
        action: function () {
          this.modifySelection("right");
        },
        repeat: !0,
      },
      shiftDownArrow_modifySelectionDownwards: {
        keys: "shift+down",
        action: function () {
          this.modifySelection("down");
        },
        repeat: !0,
      },
      shiftLeftArrow_modifySelectionLeftwards: {
        keys: "shift+left",
        action: function () {
          this.modifySelection("left");
        },
        repeat: !0,
      },
      shiftUpArrow_modifySelectionUpwards: {
        keys: "shift+up",
        action: function () {
          this.modifySelection("up");
        },
        repeat: !0,
      },
      ctrlZ_undo: {
        keys: "ctrl+z",
        action: function () {
          this.undo();
        },
        repeat: !1,
      },
      ctrlY_redo: {
        keys: "ctrl+y",
        action: function () {
          this.redo();
        },
        repeat: !1,
      },
      ctrlShiftZ_redo: {
        keys: "ctrl+shift+z",
        action: function () {
          this.redo();
        },
        repeat: !1,
      },
      backspace_clearCellValues: {
        keys: "backspace",
        action: function () {
          this.clearCellValues(this.getCellSelection());
        },
        repeat: !1,
        active: function () {
          return this.allowCellEdit;
        },
      },
      delete_clearCellValues: {
        keys: "delete",
        action: function () {
          this.clearCellValues(this.getCellSelection());
        },
        repeat: !1,
        active: function () {
          return this.allowCellEdit;
        },
      },
      inputRange_openInlineEditor: {
        keys: "range:input",
        action: function () {
          this.openEditor("inline");
        },
        repeat: !1,
        active: function () {
          return this.allowCellEdit;
        },
      },
      ctrlRange_enableClipboardNode: {
        keys: "range:ctrl",
        action: function () {
          this.enableClipboardInteraction();
        },
        repeat: !1,
      },
      esc_closeEditor: {
        keys: "esc",
        action: function () {
          this.closeEditor();
        },
        repeat: !1,
      },
      esc_closeContextMenu: {
        keys: "esc",
        action: function () {
          this.constructor.contextMenu.close();
        },
        repeat: !1,
      },
      downArrow_moveContextMenuCursorDown: {
        keys: "down",
        action: function () {
          this.constructor.contextMenu.moveCursorDown();
        },
        repeat: !0,
      },
      upArrow_moveContextMenuCursorUp: {
        keys: "up",
        action: function () {
          this.constructor.contextMenu.moveCursorUp();
        },
        repeat: !0,
      },
      enter_hitContextMenuItem: {
        keys: "enter",
        action: function () {
          this.constructor.contextMenu.triggerHit();
        },
        repeat: !1,
      },
    },
    v = {
      traverseSingleCell: [
        "rightArrow_moveCellCursorRight",
        "downArrow_moveCellCursorDown",
        "leftArrow_moveCellCursorLeft",
        "upArrow_moveCellCursorUp",
        "tab_navigateNext",
        "shiftTab_navigatePrev",
        "enter_openEditor",
        "pageDown_moveCellCursorOneViewportDown",
        "pageUp_moveCellCursorOneViewportUp",
        "home_moveCellCursorToRowStart",
        "end_moveCellCursorToRowEnd",
        "ctrlLeftArrow_moveCellCursorToRowStart",
        "ctrlRightArrow_moveCellCursorToRowEnd",
        "ctrlUpArrow_moveCellCursorToColStart",
        "ctrlDownArrow_moveCellCursorToColEnd",
        "ctrlHome_moveCellCursorToDocumentStart",
        "ctrlEnd_moveCellCursorToDocumentEnd",
        "shiftRightArrow_modifySelectionRightwards",
        "shiftDownArrow_modifySelectionDownwards",
        "shiftLeftArrow_modifySelectionLeftwards",
        "shiftUpArrow_modifySelectionUpwards",
        "inputRange_openInlineEditor",
        "backspace_clearCellValues",
        "delete_clearCellValues",
        "ctrlZ_undo",
        "ctrlY_redo",
        "ctrlShiftZ_redo",
        "ctrlRange_enableClipboardNode",
      ],
      traverseMultiCell: [
        "rightArrow_moveCellCursorRight",
        "downArrow_moveCellCursorDown",
        "leftArrow_moveCellCursorLeft",
        "upArrow_moveCellCursorUp",
        "tab_navigateNext",
        "shiftTab_navigatePrev",
        "enter_navigateNext",
        "shiftEnter_navigatePrev",
        "pageDown_moveCellCursorOneViewportDown",
        "pageUp_moveCellCursorOneViewportUp",
        "home_moveCellCursorToRowStart",
        "end_moveCellCursorToRowEnd",
        "ctrlLeftArrow_moveCellCursorToRowStart",
        "ctrlRightArrow_moveCellCursorToRowEnd",
        "ctrlUpArrow_moveCellCursorToColStart",
        "ctrlDownArrow_moveCellCursorToColEnd",
        "ctrlHome_moveCellCursorToDocumentStart",
        "ctrlEnd_moveCellCursorToDocumentEnd",
        "shiftRightArrow_modifySelectionRightwards",
        "shiftDownArrow_modifySelectionDownwards",
        "shiftLeftArrow_modifySelectionLeftwards",
        "shiftUpArrow_modifySelectionUpwards",
        "inputRange_openInlineEditor",
        "backspace_clearCellValues",
        "delete_clearCellValues",
        "ctrlZ_undo",
        "ctrlY_redo",
        "ctrlShiftZ_redo",
        "ctrlRange_enableClipboardNode",
      ],
      editInline: [
        "rightArrow_moveCellCursorRight",
        "downArrow_moveCellCursorDown",
        "leftArrow_moveCellCursorLeft",
        "upArrow_moveCellCursorUp",
        "tab_navigateNext",
        "shiftTab_navigatePrev",
        "enter_navigateNext",
        "shiftEnter_navigatePrev",
        "ctrlEnter_saveEditor",
        "pageDown_moveCellCursorOneViewportDown",
        "pageUp_moveCellCursorOneViewportUp",
        "home_moveCellCursorToRowStart",
        "end_moveCellCursorToRowEnd",
        "ctrlLeftArrow_moveCellCursorToRowStart",
        "ctrlRightArrow_moveCellCursorToRowEnd",
        "ctrlUpArrow_moveCellCursorToColStart",
        "ctrlDownArrow_moveCellCursorToColEnd",
        "ctrlHome_moveCellCursorToDocumentStart",
        "ctrlEnd_moveCellCursorToDocumentEnd",
        "esc_closeEditor",
      ],
      editOpened: [
        "tab_navigateNext",
        "shiftTab_navigatePrev",
        "enter_navigateNext",
        "shiftEnter_navigatePrev",
        "ctrlEnter_saveEditor",
        "esc_closeEditor",
      ],
      contextMenuOpen: [
        "esc_closeContextMenu",
        "downArrow_moveContextMenuCursorDown",
        "upArrow_moveContextMenuCursorUp",
        "enter_hitContextMenuItem",
        "ctrlZ_undo",
        "ctrlY_redo",
        "ctrlShiftZ_redo",
        "ctrlRange_enableClipboardNode",
      ],
    },
    y = {
      numbers: {
        headerTextFunction: function (t, e) {
          return String(1 + t);
        },
      },
      letters: {
        range: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
        headerTextFunction: function (t, e) {
          return (function (t) {
            var o = "";
            do {
              (t -= 1),
                (o = e.range.charAt(t % e.range.length) + o),
                (t = (t / e.range.length) >> 0);
            } while (t > 0);
            return o;
          })(1 + t);
        },
      },
    },
    x = ["numbers", "letters"];
  function N(t, e, o, i, s) {
    return i
      ? i || ""
      : this.colHeaderLabelType in s
      ? (this.colHeaderLabelPrefix || "") +
        s[this.colHeaderLabelType] +
        (this.colHeaderLabelSuffix || "")
      : "id" == this.colHeaderLabelType
      ? (this.colHeaderLabelPrefix || "") +
        e +
        (this.colHeaderLabelSuffix || "")
      : "index" == this.colHeaderLabelType
      ? (this.colHeaderLabelPrefix || "") +
        t +
        (this.colHeaderLabelSuffix || "")
      : (this.colHeaderLabelPrefix || "") + (this.colHeaderLabelSuffix || "");
  }
  function w(t, e, o, i, s) {
    return i
      ? i || ""
      : this.rowHeaderLabelType in s
      ? (this.rowHeaderLabelPrefix || "") +
        s[this.rowHeaderLabelType] +
        (this.rowHeaderLabelSuffix || "")
      : "id" == this.rowHeaderLabelType
      ? (this.rowHeaderLabelPrefix || "") +
        e +
        (this.rowHeaderLabelSuffix || "")
      : "index" == this.rowHeaderLabelType
      ? (this.rowHeaderLabelPrefix || "") +
        t +
        (this.rowHeaderLabelSuffix || "")
      : (this.rowHeaderLabelPrefix || "") + (this.rowHeaderLabelSuffix || "");
  }
  var C = {
      outerBorderColor: "#8d9295",
      textColor: "#000000",
      documentColor: "#ffffff",
      sheetColor: "#f4f4f4",
      colHeaderBackgroundColor: "#eaecee",
      colHeaderHighlightBackgroundColor: "#cad1d6",
      colHeaderSelectedBackgroundColor: "#8d9295",
      colHeaderTextColor: "#000000",
      colHeaderSelectedTextColor: "#ffffff",
      rowHeaderBackgroundColor: "#eaecee",
      rowHeaderHighlightBackgroundColor: "#cad1d6",
      rowHeaderSelectedBackgroundColor: "#8d9295",
      rowHeaderTextColor: "#000000",
      rowHeaderSelectedTextColor: "#ffffff",
      gridLineOpacity: 0.15,
      gridLineColor: "#555555",
      gridLineHeaderColor: "#000000",
      cellSelectionBackgroundColor: "#0078ff",
      cellSelectionBorderColor: "#0078ff",
      cellCursorColor: "#0078ff",
      fillHandleColor: "#0078ff",
      copyRangeBorderColor: "#0078ff",
      cutRangeBorderColor: "#0078ff",
      fillRangeBorderColor: "#555555",
      scrollbarBorderColor: "#dddddd",
      scrollbarBackgroundColor: "#ffffff",
      scrollbarThumbColor: "transparent",
      scrollbarThumbHighlightColor: "transparent",
      colResizeGuideLineColor: "#0078ff",
      colResizeGuideHandleColor: "#0078ff",
      colMoveGuideColor: "#000000",
      colMoveGhostColor: "#000000",
      colMoveGhostOpacity: 0.1,
      rowMoveGuideColor: "#000000",
      rowMoveGhostColor: "#000000",
      rowMoveGhostOpacity: 0.1,
      inlineEditorBorderColor: "#0078ff",
      openedEditorBorderColor: "#0078ff",
      rowZebraStripeColors: [null, "rgba(0,0,0,.05)"],
      contextMenuTextColor: "#000000",
      contextMenuBackgroundColor: "#ffffff",
      contextMenuItemHighlightBackgroundColor: "#eeeeee",
      contextMenuItemShortCutLabelTextColor: "#aaaaaa",
      colResizeHandleBackgroundColor: "#8d9295",
    },
    S = {
      Copy: null,
      Cut: null,
      Paste: null,
      "Delete Row(s)": null,
      "Insert Row(s) (up)": null,
      "Insert Row(s) (down)": null,
      "Delete Column(s)": null,
      "Insert Column(s) (left)": null,
      "Insert Column(s) (right)": null,
      Deselect: null,
      "Sort A to Z": null,
      "Sort Z to A": null,
    },
    b = ["laicrem.com", "esnec.li", "jo.it", "rever.in", "spl.se"],
    H = {
      left: {},
      center: {
        "margin-left": "-100%",
        "margin-right": "-100%",
        "text-align": "center",
      },
      right: { float: "right", "text-align": "right" },
    },
    T = {
      cell: "default",
      colHeader: "default",
      rowHeader: "default",
      headerJoint: "default",
      horizontalScrollbar: "default",
      verticalScrollbar: "default",
      selectedRowHeader: "grab",
      selectedColHeader: "grab",
      fillHandle: "crosshair",
      colHeaderEdge: "ew-resize",
    },
    L = {
      cellSelect: "default",
      colSelect: "default",
      rowSelect: "default",
      colMove: "grabbing",
      rowMove: "grabbing",
      cellFill: "crosshair",
      colResize: "ew-resize",
    };
  function P(t) {
    return "string" != typeof t ? "" : t.charAt(0).toUpperCase() + t.slice(1);
  }
  function k(t) {
    for (var e, o, i, s, l, n = "", r = 0; r < 2; r++)
      n +=
        ((e = t[r]),
        (o = r),
        (i = void 0),
        (s = void 0),
        (l = void 0),
        (i = t[4].substr(0, 3) + t[2].substr(-2)),
        (s = t[3].substr(0, 5) + t[4].substr(-2)),
        (l = t[2].substr(0, 2) + t[3].substr(-2)),
        (o
          ? P
          : function (t) {
              return t;
            })(e[i](".")[1] + e[i](".")[0][i]("")[s]()[l]("")));
    return n;
  }
  function M(t) {
    return Array.isArray(t);
  }
  function R(t) {
    return M(t) && M(t[0]);
  }
  function A(t) {
    return t instanceof Object && t.constructor === Object;
  }
  function I(t) {
    return M(t) && A(t[0]);
  }
  function z(t) {
    return null !== t && "" !== t && !isNaN(t);
  }
  function O(t, e, o) {
    null == this._cellStore[t - 1] && (this._cellStore[t - 1] = []),
      null == this._cellStore[t - 1][e - 1]
        ? (this._cellStore[t - 1][e - 1] = { value: o })
        : (this._cellStore[t - 1][e - 1].value = o);
  }
  function E(t, e) {
    void 0 === e && (e = null),
      (this._dataFormat = R(t) ? "arrayCollection" : "objectCollection"),
      (this._rowStore = []);
    for (var o = 0; o < t.length; o++) {
      var i = 1 + o;
      this._rowStore.push({ id: i, title: void 0 }), this._rowList.push(i);
    }
    if (
      ((this._rowStore._lastId = i), (this._colStore = []), null != e && I(e))
    ) {
      for (var s = 0; s < e.length; s++) {
        c = 1 + s;
        var l = void 0,
          n = void 0;
        I(t) &&
          ("source" in e[s]
            ? e[s].source in t[0] && ((l = e[s].source), (n = e[s].source))
            : ((l = Object.keys(t[0])[s] || void 0),
              (n = Object.keys(t[0])[s] || void 0)));
        var r = e[s].field || l,
          h = e[s].title || n;
        this._colStore.push({
          id: c,
          node: void 0,
          field: r,
          title: h,
          width: e[s].width || this.defaultColWidth,
          align: e[s].align || this.defaultColAlign,
        }),
          this._colList.push(c);
      }
      this._colStore._lastId = c;
    } else if (R(t)) {
      for (s = 0; s < t[0].length; s++)
        (c = 1 + s),
          this._colStore.push({
            id: c,
            node: void 0,
            field: void 0,
            title: void 0,
            width: this.defaultColWidth,
            align: this.defaultColAlign,
          }),
          this._colList.push(c);
      this._colStore._lastId = c;
    } else if (I(t)) {
      var c,
        d = 0;
      for (var a in t[0]) {
        c = 1 + d;
        (r = a), (h = a);
        this._colStore.push({
          id: c,
          node: void 0,
          field: r,
          title: h,
          width: this.defaultColWidth,
          align: this.defaultColAlign,
        }),
          this._colList.push(c),
          d++;
      }
      this._colStore._lastId = c;
    }
    if (((this._cellStore = []), null != e && I(e))) {
      if (R(t))
        for (o = 0; o < this._rowStore.length; o++)
          for (s = 0; s < this._colStore.length; s++) {
            if ("source" in e[s] && z(e[s].source)) var u = Number(e[s].source);
            else u = s;
            O.call(
              this,
              this._rowStore[o].id,
              this._colStore[s].id,
              t[o][u] || null
            );
          }
      else if (I(t))
        for (o = 0; o < this._rowStore.length; o++)
          for (s = 0; s < this._colStore.length; s++) {
            if ("source" in e[s]) var p = e[s].source;
            else p = Object.keys(t[0])[s];
            O.call(
              this,
              this._rowStore[o].id,
              this._colStore[s].id,
              t[o][p] || null
            );
          }
    } else if (R(t))
      for (o = 0; o < this._rowStore.length; o++)
        for (s = 0; s < this._colStore.length; s++)
          O.call(this, this._rowStore[o].id, this._colStore[s].id, t[o][s]);
    else if (I(t))
      for (o = 0; o < this._rowStore.length; o++)
        for (s = 0; s < this._colStore.length; s++)
          O.call(
            this,
            this._rowStore[o].id,
            this._colStore[s].id,
            t[o][this._colStore[s].field]
          );
  }
  function V(t) {
    for (var e in t) (e in this || e == k(b)) && (this[e] = t[e]);
    var o = t.data || this.constructor.createEmptyData(3, 3),
      i = t.columns || null;
    E.call(this, o, i);
  }
  function D(t) {
    V.call(this, t);
  }
  function F(t, e, o) {
    void 0 === t && (t = null),
      void 0 === e && (e = {}),
      void 0 === o && (o = !1);
    var i = ["user-select", "user-drag", "touch-callout"],
      s = ["-ktml", "-moz-", "-ms-", "-webkit-", "-o-"];
    for (var l in (o &&
      ((t.style.margin = "0"),
      (t.style.padding = "0"),
      (t.style.border = "0"),
      (t.style["font-weight"] = "normal"),
      (t.style["font-size"] = "100%"),
      (t.style.font = "inherit"),
      (t.style["vertical-align"] = "baseline"),
      (t.style.display = "block"),
      (t.style["list-style"] = "none")),
    e)) {
      if (i.indexOf(l) > -1)
        for (var n = 0; n < s.length; n++)
          s[n] + l in e || (t.style[s[n] + l] = e[l]);
      t.style[l] = e[l];
    }
  }
  function K(t, e) {
    void 0 === e && (e = {});
    var o = document.createElement(t);
    for (var i in e)
      if ("string" == typeof e[i] || z(e[i])) o.setAttribute(i, e[i]);
      else if ("style" == i) F(o, e.style, !0);
      else if ("styleText" == i) {
        var s = "";
        for (var l in e.styleText)
          if (M(e.styleText[l]))
            for (var n = 0; n < e.styleText[l].length; n++)
              s += l + ":" + e.styleText[l][n] + ";";
          else s += l + ":" + e.styleText[l] + ";";
        o.style.cssText = s;
      }
    return o;
  }
  function B() {
    return document.createDocumentFragment();
  }
  function W(t, e) {
    void 0 === t && (t = null), void 0 === e && (e = []);
    for (var o = B(), i = 0; i < e.length; i++)
      null != e[i] && o.appendChild(e[i]);
    return t.appendChild(o), t;
  }
  function G(t) {
    if (null == t) return null;
    var e = {};
    for (var o in t) e[o] = t[o];
    return e;
  }
  function X(t, e) {
    var o = G(t);
    for (var i in e) o[i] = e[i];
    return o;
  }
  function Y(t, e) {
    if ((void 0 === e && (e = void 0), null == e))
      var o = t.parentNode.children;
    else o = e.children;
    o = t.parentNode.children;
    for (var i = 0; i < o.length; i++) if (o[i] == t) return i;
    return -1;
  }
  function j(t, e) {
    for (; "classList" in t && !t.classList.contains(e); ) t = t.parentNode;
    return "classList" in t && t.classList.contains(e) ? t : null;
  }
  function U(t, e, o) {
    if (
      (void 0 === e && (e = "#fff"),
      void 0 === o && (o = "#000"),
      "rgb" == t.substring(0, 3))
    )
      var i = t.replace(/[^\d,.]/g, "").split(","),
        s = i[0],
        l = i[1],
        n = i[2];
    else {
      var r = "#" === t.charAt(0) ? t.substring(1, 7) : t;
      (s = parseInt(r.substring(0, 2), 16)),
        (l = parseInt(r.substring(2, 4), 16)),
        (n = parseInt(r.substring(4, 6), 16));
    }
    var h = [s / 255, l / 255, n / 255].map(function (t) {
      return t <= 0.03928 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * h[0] + 0.7152 * h[1] + 0.0722 * h[2] > 0.179 ? o : e;
  }
  var q = function (t, e) {
    void 0 === t && (t = null),
      (this._domNodes = {}),
      (this._offsetX = 4),
      (this._offsetY = 4),
      (this._prevCursorIndex = null),
      (this._cursorIndex = null),
      (this._context = null),
      (this._isOpen = !1),
      (this._selectItemCallback = function () {}),
      (this._closeCallback = function () {}),
      (this.items = []),
      (this._domNodes.containerNode = t);
  };
  (q.prototype.isOpen = function () {
    return this._isOpen;
  }),
    (q.prototype.open = function (t, e, o, i, s, l) {
      if (
        ((this._isOpen = !0),
        (this.items = e),
        (this._context = t),
        (this._selectItemCallback = s),
        (this._closeCallback = l),
        "light" ==
          U(this._context.getThemeSetting("documentColor"), "light", "dark"))
      )
        var n = "rgba(255,255,255,0.2)";
      else n = "rgba(0,0,0,.35)";
      for (
        var r =
            "box-shadow:" +
            n +
            " 0 1px 4px;border-radius:4px;list-style:none;margin:0;padding:6px 1px;background-color:" +
            this._context.getThemeSetting("contextMenuBackgroundColor") +
            ";color:" +
            this._context.getThemeSetting("contextMenuTextColor") +
            ";",
          h =
            "position:absolute;right:10px;top:0;color:" +
            this._context.getThemeSetting(
              "contextMenuItemShortCutLabelTextColor"
            ) +
            ";font-weight:bold;font-size:smaller;",
          c = '<ul class="dgxl-contextMenuItemList" style="' + r + '">',
          d = 0;
        d < this.items.length;
        d++
      ) {
        var a = "dgxl-contextMenuItem",
          u = "";
        "disabled" in this.items[d] &&
        this.items[d].disabled.call(this._context)
          ? ((a += " " + a + "-disabled"), (u += "opacity:0.25;"))
          : (u += "cursor:pointer;"),
          (c +=
            '<li class="' +
            a +
            '" style="height:32px;line-height:32px;padding:0 10px;position:relative;' +
            u +
            '">'),
          (c +=
            '<div class="dgxl-contextMenuItemLabel">' +
            this._context.getLocaleSetting(this.items[d].label) +
            "</div>"),
          "shortcut" in this.items[d] &&
            (c +=
              '<div class="dgxl-contextMenuItemShortcut" style="' +
              h +
              '">' +
              this.items[d].shortcut +
              "</div>"),
          (c += "</li>");
      }
      (c += "</ul>"),
        tt.call(this, window, o, i),
        (this._domNodes.containerNode.innerHTML = c),
        (this._domNodes.containerNode.style.display = "block"),
        this.setCursor(-1),
        "_mouseDownListener" in this._domNodes.containerNode ||
          (this._domNodes.containerNode._mouseDownListener = function (t) {
            if (
              0 == t.button &&
              this._domNodes.containerNode.contains(t.target)
            ) {
              var e = j(t.target, "dgxl-contextMenuItem");
              if (null == e) var o = -1;
              else o = Y(e);
              this.hit(o);
            } else this.close();
          }.bind(this)),
        "_contextMenuListener" in this._domNodes.containerNode ||
          (this._domNodes.containerNode._contextMenuListener = function (t) {
            t.preventDefault();
          }),
        document.addEventListener(
          "mousedown",
          this._domNodes.containerNode._mouseDownListener
        ),
        document.addEventListener(
          "contextmenu",
          this._domNodes.containerNode._contextMenuListener
        ),
        "_mouseMoveListener" in this._domNodes.containerNode ||
          (this._domNodes.containerNode._mouseMoveListener = function (t) {
            var e = j(t.target, "dgxl-contextMenuItem");
            if (null == e) var o = -1;
            else o = Y(e);
            o > -1 &&
            "disabled" in this.items[o] &&
            this.items[o].disabled.call(this._context)
              ? this.setCursor(-1)
              : this.setCursor(o);
          }.bind(this)),
        "_mouseLeaveListener" in this._domNodes.containerNode ||
          (this._domNodes.containerNode._mouseLeaveListener = function (t) {
            this.setCursor(-1);
          }.bind(this)),
        this._domNodes.containerNode.addEventListener(
          "mousemove",
          this._domNodes.containerNode._mouseMoveListener
        ),
        this._domNodes.containerNode.addEventListener(
          "mouseleave",
          this._domNodes.containerNode._mouseLeaveListener
        );
    }),
    (q.prototype.close = function () {
      this._closeCallback.call(this._context, { contextMenu: this });
    }),
    (q.prototype.execClose = function () {
      (this._isOpen = !1),
        document.removeEventListener(
          "mousedown",
          this._domNodes.containerNode._mouseDownListener
        ),
        document.removeEventListener(
          "contextmenu",
          this._domNodes.containerNode._contextMenuListener
        ),
        this._domNodes.containerNode.removeEventListener(
          "mousemove",
          this._domNodes.containerNode._mouseMoveListener
        ),
        this._domNodes.containerNode.removeEventListener(
          "mouseleave",
          this._domNodes.containerNode._mouseLeaveListener
        ),
        this.setCursor(-1),
        (this._domNodes.containerNode.innerHTML = ""),
        (this._domNodes.containerNode.style.display = "none");
    }),
    (q.prototype.setCursor = function (t) {
      if (t !== this._prevCursorIndex) {
        var e = this._domNodes.containerNode;
        e.children.length &&
          (null !== this._prevCursorIndex &&
            this._prevCursorIndex > -1 &&
            ((e.children[0].children[
              this._prevCursorIndex
            ].style.backgroundColor = ""),
            e.children[0].children[this._prevCursorIndex].classList.remove(
              "dgxl-contextMenuItem-highlight"
            )),
          (this._cursorIndex = t),
          null !== this._cursorIndex &&
            this._cursorIndex > -1 &&
            ((e.children[0].children[this._cursorIndex].style.backgroundColor =
              this._context.getThemeSetting(
                "contextMenuItemHighlightBackgroundColor"
              )),
            e.children[0].children[this._cursorIndex].classList.add(
              "dgxl-contextMenuItem-highlight"
            )),
          (this._prevCursorIndex = this._cursorIndex));
      }
    }),
    (q.prototype.moveCursorDown = function () {
      -1 == this._cursorIndex || null === this._cursorIndex
        ? this.setCursor(Z.call(this))
        : this._cursorIndex == Q.call(this)
        ? this.setCursor(Z.call(this))
        : this.setCursor(J.call(this, this._cursorIndex));
    }),
    (q.prototype.moveCursorUp = function () {
      -1 == this._cursorIndex || null === this._cursorIndex
        ? this.setCursor(Q.call(this))
        : 0 == this._cursorIndex
        ? this.setCursor(Q.call(this))
        : this.setCursor($.call(this, this._cursorIndex));
    }),
    (q.prototype.moveCursorRight = function () {}),
    (q.prototype.moveCursorLeft = function () {}),
    (q.prototype.triggerHit = function () {
      this.hit(this._cursorIndex);
    }),
    (q.prototype.hit = function (t) {
      -1 != t &&
        this.items[t] &&
        (("disabled" in this.items[t] &&
          this.items[t].disabled.call(this._context)) ||
          ("method" in this.items[t] &&
            this._selectItemCallback.call(this._context, {
              contextMenu: this,
              index: t,
              item: this.items[t],
            })));
    });
  var Z = function () {
      return J.call(this, -1);
    },
    J = function (t) {
      var e = t + 1;
      return "disabled" in this.items[e] &&
        this.items[e].disabled.call(this._context)
        ? J.call(this, e)
        : e;
    },
    Q = function () {
      return $.call(this, this.items.length);
    },
    $ = function (t) {
      var e = t - 1;
      return "disabled" in this.items[e] &&
        this.items[e].disabled.call(this._context)
        ? $.call(this, e)
        : e;
    },
    tt = function (t, e, o) {
      void 0 === t && (t = window);
      var i = this._domNodes.containerNode,
        s = 12 + 32 * this.items.length;
      if (
        ((i._height = s),
        (i._width = 240),
        (i.style.width = "240px"),
        t == window)
      )
        var l = window.scrollY + window.innerHeight,
          n = window.scrollX + window.innerWidth;
      else if (t instanceof Element) {
        var r = t.getBoundingClientRect();
        (l = Math.floor(window.scrollY + r.y + r.height)),
          (n = Math.floor(window.scrollX + r.x + r.width));
      }
      o + this._offsetY + s > l
        ? (i._top = o - (s + this._offsetY))
        : (i._top = o + this._offsetY),
        e + this._offsetX + 240 > n
          ? (i._left = e - (240 + this._offsetX))
          : (i._left = e + this._offsetX),
        (i.style.top = i._top + "px"),
        (i.style.left = i._left + "px");
    },
    et = function (t, e) {
      void 0 === t && (t = null),
        (this._domNodes = {}),
        (this._offsetX = 0),
        (this._offsetY = 20),
        (this._containerSpacing = 10),
        (this._prevCursorIndex = null),
        (this._cursorIndex = null),
        (this._context = null),
        (this._isOpen = !1),
        (this._selectItemCallback = function () {}),
        (this._closeCallback = function () {}),
        (this.items = []),
        (this.visualFontSize = 15),
        (this.visualPadding = 12),
        (this.visualItemHeight = 48),
        (this.visualBorderRadius = 8),
        (this._domNodes.containerNode = t);
    };
  (et.prototype.isOpen = function () {
    return this._isOpen;
  }),
    (et.prototype.open = function (t, e, o, i, s, l, n) {
      if (
        ((this._isOpen = !0),
        (this.items = e),
        (this._context = t),
        (this._selectItemCallback = l),
        (this._closeCallback = n),
        "visualViewport" in window)
      )
        var r = window.visualViewport.scale;
      else r = document.documentElement.clientWidth / window.innerWidth;
      if (
        ((this._fontSize = Math.round(this.visualFontSize / r)),
        (this._padding = Math.round(this.visualPadding / r)),
        (this._itemHeight = Math.round(this.visualItemHeight / r)),
        (this._borderRadius = Math.round(this.visualBorderRadius / r)),
        "light" ==
          U(this._context.getThemeSetting("documentColor"), "light", "dark"))
      )
        var h = "rgba(255,255,255,0.2)";
      else h = "rgba(0,0,0,.35)";
      F(this._domNodes.containerNode, {
        "background-color": this._context.getThemeSetting(
          "contextMenuBackgroundColor"
        ),
        "border-radius": this._borderRadius + "px",
        "box-shadow": h + " 0 1px 4px",
      });
      for (
        var c =
            "display:flex;list-style:none;margin:0;padding:0;font-size:" +
            this._fontSize +
            "px;color:" +
            this._context.getThemeSetting("contextMenuTextColor") +
            ";",
          d =
            "white-space:nowrap;padding:0 " +
            this._padding +
            "px;height:" +
            this._itemHeight +
            "px;line-height:" +
            this._itemHeight +
            "px;",
          a = '<ul class="dgxl-contextMenuTouchItemList" style="' + c + '">',
          u = 0;
        u < this.items.length;
        u++
      ) {
        var p = "dgxl-contextMenuTouchItem",
          _ = "";
        "disabled" in this.items[u] &&
        this.items[u].disabled.call(this._context)
          ? ((p += " " + p + "-disabled"), (_ += "opacity:0.25;"))
          : (_ += "cursor:pointer;"),
          (a += '<li class="' + p + '" style="' + (d + _) + '">'),
          (a += this._context.getLocaleSetting(this.items[u].label)),
          (a += "</li>");
      }
      (a += "</ul>"),
        ot.call(this, window, a, o, i, s),
        (this._domNodes.containerNode.style.visibility = "visible"),
        this.setCursor(-1),
        "_touchMoveListener" in this._domNodes.containerNode ||
          (this._domNodes.containerNode._touchMoveListener = function (t) {
            var e = document.elementFromPoint(
              t.changedTouches[0].clientX,
              t.changedTouches[0].clientY
            );
            this._domNodes.containerNode.contains(e)
              ? j(e, "dgxl-contextMenuTouchItem") !=
                  this._domNodes.containerNode._originalTarget &&
                this.setCursor(-1)
              : this.setCursor(-1);
          }.bind(this)),
        "_touchEndListener" in this._domNodes.containerNode ||
          (this._domNodes.containerNode._touchEndListener = function (t) {
            var e = this,
              o = document.elementFromPoint(
                t.changedTouches[0].clientX,
                t.changedTouches[0].clientY
              );
            if (this._domNodes.containerNode.contains(o)) {
              var i = j(o, "dgxl-contextMenuTouchItem");
              null != i &&
                i == this._domNodes.containerNode._originalTarget &&
                setTimeout(function () {
                  e.hit(Y(i));
                }, 10);
            }
            document.body.removeEventListener(
              "touchend",
              this._domNodes.containerNode._touchEndListener,
              { passive: !0 }
            );
          }.bind(this)),
        "_touchStartListener" in this._domNodes.containerNode ||
          (this._domNodes.containerNode._touchStartListener = function (t) {
            document.body.addEventListener(
              "touchmove",
              this._domNodes.containerNode._touchMoveListener,
              { passive: !0 }
            ),
              document.body.addEventListener(
                "touchend",
                this._domNodes.containerNode._touchEndListener,
                { passive: !0 }
              );
            var e = document.elementFromPoint(
              t.changedTouches[0].clientX,
              t.changedTouches[0].clientY
            );
            if (this._domNodes.containerNode.contains(e)) {
              var o = j(e, "dgxl-contextMenuTouchItem");
              if (null == o) var i = -1;
              else if (null != o) i = Y(o);
              (this._domNodes.containerNode._originalTarget = o),
                i > -1 &&
                "disabled" in this.items[i] &&
                this.items[i].disabled.call(this._context)
                  ? this.setCursor(-1)
                  : this.setCursor(i);
            } else
              this._context._domNodes.containerNode.contains(e) || this.close();
          }.bind(this)),
        document.body.addEventListener(
          "touchstart",
          this._domNodes.containerNode._touchStartListener,
          { passive: !0 }
        );
    }),
    (et.prototype.close = function () {
      this._closeCallback.call(this._context, { contextMenuTouch: this });
    }),
    (et.prototype.execClose = function () {
      (this._isOpen = !1),
        document.body.removeEventListener(
          "touchstart",
          this._domNodes.containerNode._touchStartListener,
          { passive: !0 }
        ),
        document.body.removeEventListener(
          "touchmove",
          this._domNodes.containerNode._touchMoveListener,
          { passive: !0 }
        ),
        document.body.removeEventListener(
          "touchend",
          this._domNodes.containerNode._touchEndListener,
          { passive: !0 }
        ),
        this.setCursor(-1),
        (this._domNodes.containerNode.innerHTML = ""),
        (this._domNodes.containerNode.style.visibility = "hidden");
    }),
    (et.prototype.setCursor = function (t) {
      if (t !== this._prevCursorIndex) {
        var e = this._domNodes.containerNode;
        e.children.length &&
          (null !== this._prevCursorIndex &&
            this._prevCursorIndex > -1 &&
            e.children[0].children[this._prevCursorIndex].classList.remove(
              "dgxl-contextMenuTouchItem-highlight"
            ),
          (this._cursorIndex = t),
          null !== this._cursorIndex &&
            this._cursorIndex > -1 &&
            e.children[0].children[this._cursorIndex].classList.add(
              "dgxl-contextMenuTouchItem-highlight"
            ),
          (this._prevCursorIndex = this._cursorIndex));
      }
    }),
    (et.prototype.triggerHit = function () {
      this.hit(this._cursorIndex);
    }),
    (et.prototype.hit = function (t) {
      -1 != t &&
        this.items[t] &&
        (("disabled" in this.items[t] &&
          this.items[t].disabled.call(this._context)) ||
          ("method" in this.items[t] &&
            this._selectItemCallback.call(this._context, {
              contextMenuTouch: this,
              index: t,
              item: this.items[t],
            })));
    });
  var ot = function (t, e, o, i, s) {
    void 0 === t && (t = window);
    var l = this._domNodes.containerNode;
    if (t == window)
      var n = {
        top: window.scrollY + this._containerSpacing,
        right: window.scrollX + window.innerWidth - this._containerSpacing,
        bottom: window.scrollY + window.innerHeight - this._containerSpacing,
        left: window.scrollX + this._containerSpacing,
      };
    else if (t instanceof Element) {
      var r = t.getBoundingClientRect();
      n = {
        top: Math.floor(window.scrollY + r.y) + this._containerSpacing,
        right:
          Math.floor(window.scrollX + r.x + r.width) - this._containerSpacing,
        bottom:
          Math.floor(window.scrollY + r.y + r.height) - this._containerSpacing,
        left: Math.floor(window.scrollX + r.x) + this._containerSpacing,
      };
    }
    (l.style.maxWidth = n.right - n.left + "px"), (l.innerHTML = e);
    var h = l.offsetWidth;
    (l._height = 44),
      (l._width = h),
      i + this._offsetY + 44 > n.bottom
        ? (l._top = i + this._offsetY)
        : (l._top = i - (44 + this._offsetY));
    var c = o - l._width / 2 + this._offsetX,
      d = c + l._width,
      a = Math.max(0, d - n.right),
      u = c < n.left ? n.left - c : 0;
    (l._left = o - l._width / 2 + this._offsetX),
      (a && u) || (a > 0 ? (l._left -= a) : u > 0 && (l._left += u)),
      (l.style.top = l._top + "px"),
      (l.style.left = l._left + "px");
  };
  function it() {
    st.call(this), lt.call(this), ct.call(this);
  }
  var st = function () {
      (this._domNodes.containerNode = document.getElementById(
        this._containerId
      )),
        null === this._domNodes.containerNode
          ? (this._domNodes.containerNode = K("div", {
              style: {
                overflow: "hidden",
                position: "relative",
                "text-align": "left",
                "touch-action": "auto",
              },
            }))
          : (this._domNodes.containerNode.innerHTML = "");
    },
    lt = function () {
      Object.keys(this.constructor._domNodes).length ||
        (W(document.body, [nt.call(this), rt.call(this), ht.call(this)]),
        (this.constructor.contextMenu = new q(
          this.constructor._domNodes.contextMenuNode
        )),
        (this.constructor.contextMenuTouch = new et(
          this.constructor._domNodes.contextMenuTouchNode
        )));
    },
    nt = function () {
      return (
        (this.constructor._domNodes.contextMenuNode = K("div", {
          class: "dgxl-contextMenu",
          style: {
            position: "absolute",
            top: 0,
            left: 0,
            "z-index": 99999,
            "-webkit-touch-callout": "none",
            "user-select": "none",
            "font-family": "sans-serif",
            "font-size": "14px",
            display: "none",
          },
        })),
        this.constructor._domNodes.contextMenuNode
      );
    },
    rt = function () {
      return (
        (this.constructor._domNodes.contextMenuTouchNode = K("div", {
          class: "dgxl-contextMenuTouch",
          style: {
            position: "absolute",
            top: 0,
            left: 0,
            padding: "0",
            "z-index": 99999,
            "-webkit-touch-callout": "none",
            "user-select": "none",
            "font-family": "sans-serif",
            "font-size": "14px",
            "overflow-x": "auto",
            visibility: "hidden",
          },
        })),
        this.constructor._domNodes.contextMenuTouchNode
      );
    },
    ht = function () {
      this.constructor._domNodes.scrollbarMeterNode = K("div", {
        class: "dgxl-scrollbarMeter",
        style: {
          position: "absolute",
          width: "100px",
          height: "100px",
          "pointer-events": "none",
          visibility: "hidden",
          top: 0,
          left: 0,
          overflow: "scroll",
        },
      });
      var t = K("div", {
        class: "dgxl-scrollbarMeterSurface",
        style: { width: "200px", height: "200px" },
      });
      return (
        this.constructor._domNodes.scrollbarMeterNode.appendChild(t),
        this.constructor._domNodes.scrollbarMeterNode
      );
    },
    ct = function () {
      (this._domNodes.textMeterNode = K("div", {
        class: "dgxl-textMeter",
        id: "dgxl-" + this._componentId + "-textMeter",
        style: {
          "white-space": "pre",
          overflow: "hidden",
          position: "absolute",
          "z-index": 1e3,
          background: "lightyellow",
          top: 0,
          left: 0,
          "pointer-events": "none",
          visibility: "hidden",
          "line-height": this.rowHeight + "px",
        },
      })),
        (this._domNodes.lineHeightMeterNode = K("div", {
          class: "dgxl-lineHeightMeter",
          style: { "font-family": "sans-serif", "font-size": "14px" },
        }));
      for (var t = "", e = 0; e < "DataGridXL".length; e++)
        t += "DataGridXL"[e] + "\n";
      (this._domNodes.lineHeightMeterNode.textContent = t),
        (this._domNodes.textWidthMeterCanvasNode = K("canvas", {
          class: "dgxl-textWidthMeterCanvas",
          style: {
            position: "absolute",
            width: this._outerViewportWidth + "px",
            height: this._outerViewportHeight + "px",
            top: 0,
            left: 0,
          },
        })),
        W(this._domNodes.textMeterNode, [
          this._domNodes.lineHeightMeterNode,
          this._domNodes.textWidthMeterCanvasNode,
        ]),
        (this._textWidthMeterCanvasContext =
          this._domNodes.textWidthMeterCanvasNode.getContext("2d")),
        (this._textWidthMeterCanvasContext.font =
          this._editorFontSize + "px " + this._editorFontFamily),
        document.body.appendChild(this._domNodes.textMeterNode);
    };
  function dt() {
    var t = !1,
      e = window.getComputedStyle(this._domNodes.containerNode);
    (this._containerWidth =
      this._domNodes.containerNode.clientWidth -
      (parseFloat(e.paddingLeft) + parseFloat(e.paddingRight))),
      (this._containerHeight =
        this._domNodes.containerNode.clientHeight -
        (parseFloat(e.paddingTop) + parseFloat(e.paddingBottom))),
      0 == this._containerHeight &&
        ((this._domNodes.containerNode.style.height = "300px"), (t = !0)),
      0 == this._containerWidth &&
        ((this._domNodes.containerNode.style.width = "100%"), (t = !0)),
      "static" == e.position &&
        (this._domNodes.containerNode.style.position = "relative"),
      "inline" == e.display &&
        ((this._domNodes.containerNode.style.display = "inline-block"),
        (t = !0)),
      t &&
        ((e = window.getComputedStyle(this._domNodes.containerNode)),
        (this._containerWidth =
          this._domNodes.containerNode.clientWidth -
          (parseFloat(e.paddingLeft) + parseFloat(e.paddingRight))),
        (this._containerHeight =
          this._domNodes.containerNode.clientHeight -
          (parseFloat(e.paddingTop) + parseFloat(e.paddingBottom))));
  }
  function at() {
    (this._nativeScrollbarWidth =
      this.constructor._domNodes.scrollbarMeterNode.offsetWidth -
      this.constructor._domNodes.scrollbarMeterNode.clientWidth),
      (this._nativeScrollbarHeight =
        this.constructor._domNodes.scrollbarMeterNode.offsetHeight -
        this.constructor._domNodes.scrollbarMeterNode.clientHeight);
  }
  function ut() {
    var t = "DataGridXL".length;
    this._actualRowHeight =
      Math.round(
        (this._domNodes.lineHeightMeterNode.getBoundingClientRect().height /
          t) *
          100
      ) / 100;
  }
  function pt() {
    for (
      var t = this._innerDocumentWidth - this._innerViewportWidth,
        e = 0,
        o = 0,
        i = 0,
        s = 0;
      s < this._colList.length && ((o = s), (i = e), !(e >= t));
      s++
    )
      e += this.getColFromStore(this._colList[s]).width;
    return {
      startIndex: o,
      leftoverSpace: i + this._innerViewportWidth - this._innerDocumentWidth,
    };
  }
  function _t() {
    for (
      var t = this._innerDocumentHeight - this._innerViewportHeight,
        e = 0,
        o = 0,
        i = 0,
        s = 0;
      s < this._rowList.length && ((o = s), (i = e), !(e >= t));
      s++
    )
      e += this._actualRowHeight;
    return {
      startIndex: o,
      leftoverSpace: i + this._innerViewportHeight - this._innerDocumentHeight,
    };
  }
  function gt() {
    for (var t = 0, e = 0; e < 0; e++)
      t += this.getColFromStore(this._colList[e]).width;
    return t;
  }
  function ft() {
    return 0 * this._actualRowHeight;
  }
  function mt() {
    return this.showColHeaders ? this.colHeaderHeight : 0;
  }
  function vt() {
    return this.showRowHeaders ? this.rowHeaderWidth : 0;
  }
  function yt() {
    return 0 == this._nativeScrollbarWidth ? 10 : this._nativeScrollbarWidth;
  }
  function xt(t) {
    void 0 === t && (t = "whole");
    if (-1 != ["whole", "outer", "inner"].indexOf(t)) {
      var e = this._componentWidth - yt.call(this);
      return "whole" == t
        ? e
        : "outer" == t
        ? e - vt.call(this)
        : "inner" == t
        ? e - vt.call(this) - gt.call(this)
        : void 0;
    }
  }
  function Nt(t) {
    void 0 === t && (t = "whole");
    if (-1 != ["whole", "outer", "inner"].indexOf(t)) {
      var e = this._componentHeight - yt.call(this);
      return "whole" == t
        ? e
        : "outer" == t
        ? e - mt.call(this)
        : "inner" == t
        ? e - mt.call(this) - ft.call(this)
        : void 0;
    }
  }
  function wt(t) {
    void 0 === t && (t = "whole");
    if (-1 == ["whole", "outer", "inner"].indexOf(t)) return null;
    var e = 0;
    if (("whole" == t && (e += vt.call(this)), "inner" == t)) var o = 0;
    else o = 0;
    for (var i = o; i < this._colList.length; i++)
      e += this.getColFromStore(this._colList[i]).width;
    return e;
  }
  function Ct(t) {
    void 0 === t && (t = "whole");
    if (-1 == ["whole", "outer", "inner"].indexOf(t)) return null;
    var e = 0;
    if (("whole" == t && (e += mt.call(this)), "inner" == t)) var o = 0;
    else o = 0;
    for (var i = o; i < this._rowList.length; i++) e += this._actualRowHeight;
    return e;
  }
  function St() {
    var t = this._lastRowView.startIndex - 0;
    return 0 == t ? 1 : this._componentHeight + 30 * t;
  }
  function bt() {
    var t = this._lastColView.startIndex - 0;
    return 0 == t ? 1 : this._componentWidth + 30 * t;
  }
  function Ht() {
    return this._innerDocumentHeight + this._lastRowView.leftoverSpace;
  }
  function Tt() {
    return this._innerDocumentWidth + this._lastColView.leftoverSpace;
  }
  function Lt() {
    (this._componentWidth = this._containerWidth),
      (this._componentHeight = this._containerHeight - 32),
      k(b) in this && this[k(b)] && (this._componentHeight += 32),
      (this._wholeDocumentWidth = wt.call(this, "whole")),
      (this._wholeDocumentHeight = Ct.call(this, "whole")),
      (this._outerDocumentWidth = wt.call(this, "outer")),
      (this._outerDocumentHeight = Ct.call(this, "outer")),
      (this._innerDocumentWidth = wt.call(this, "inner")),
      (this._innerDocumentHeight = Ct.call(this, "inner")),
      (this._wholeViewportWidth = xt.call(this, "whole")),
      (this._wholeViewportHeight = Nt.call(this, "whole")),
      (this._outerViewportWidth = xt.call(this, "outer")),
      (this._outerViewportHeight = Nt.call(this, "outer")),
      (this._innerViewportWidth = xt.call(this, "inner")),
      (this._innerViewportHeight = Nt.call(this, "inner")),
      (this._lastColView = pt.call(this)),
      (this._lastRowView = _t.call(this)),
      (this._scrollHeight = St.call(this)),
      (this._scrollWidth = bt.call(this)),
      (this._scrollableDocumentHeight = Ht.call(this)),
      (this._scrollableDocumentWidth = Tt.call(this));
  }
  function Pt() {
    null == this._nativeScrollbarHeight &&
      null == this._nativeScrollbarWidth &&
      at.call(this),
      ut.call(this),
      dt.call(this),
      Lt.call(this);
  }
  function kt(t, e, o) {
    var i;
    return function () {
      var s = this,
        l = arguments,
        n = function () {
          (i = null), o || t.apply(s, l);
        },
        r = o && !i;
      clearTimeout(i), (i = setTimeout(n, e)), r && t.apply(s, l);
    };
  }
  var Mt = function (t, e) {
      void 0 === t && (t = null),
        (this._sharedSensorStyles = {
          display: "block",
          position: "absolute",
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
          overflow: "auto",
          "z-index": -1,
          visibility: "hidden",
        }),
        (this._resizeSensorStyles = { overflow: "hidden" }),
        (this._expandTriggerStyles = { width: "100000px", height: "100000px" }),
        (this._shrinkTriggerStyles = { width: "200%", height: "200%" }),
        (this._context = e),
        (this.onResize = function () {}),
        (this._domNodes = {}),
        (this._domNodes.containerNode = t),
        this._resizeListener,
        Rt.call(this),
        At.call(this);
    },
    Rt = function () {
      this._domNodes.componentNode = K("div", {
        class: "dgxl-resizeSensor",
        style: X(this._sharedSensorStyles, this._resizeSensorStyles),
      });
      var t = B(),
        e = K("div", {
          class: "dgxl-expandSensor",
          style: this._sharedSensorStyles,
        });
      e.appendChild(
        K("div", {
          class: "dgxl-expandTrigger",
          style: this._expandTriggerStyles,
        })
      );
      var o = K("div", {
        class: "dgxl-shrinkSensor",
        style: this._sharedSensorStyles,
      });
      o.appendChild(
        K("div", {
          class: "dgxl-shrinkTrigger",
          style: this._shrinkTriggerStyles,
        })
      ),
        t.appendChild(e),
        t.appendChild(o),
        this._domNodes.componentNode.appendChild(t),
        this._domNodes.containerNode.appendChild(this._domNodes.componentNode);
    },
    At = function () {
      var t = this,
        e = kt(function (e) {
          t.onResize.call(t._context);
        }, 50);
      this._resizeListener = e.bind(this);
      var o = !0,
        i = !0,
        s = this._domNodes.componentNode.children[0],
        l = this._domNodes.componentNode.children[1],
        n = function (t) {
          (s.scrollLeft = 1e5),
            (s.scrollTop = 1e5),
            (l.scrollLeft = 1e5),
            (l.scrollTop = 1e5);
        },
        r = function (e) {
          e.target == s && o
            ? (o = !1)
            : e.target == l && i
            ? (i = !1)
            : (t._resizeListener(), n());
        };
      n(), s.addEventListener("scroll", r), l.addEventListener("scroll", r);
    };
  function It(t, e) {
    for (
      var o = [], i = 0, s = this._innerViewportHeight;
      i < s && !(t > this._rowList.length - 1);

    )
      o.push(this._rowList[t]), (i += this._actualRowHeight), t++;
    (this._rowViewOverflow = i - this._innerViewportHeight),
      (this._rowView = o);
  }
  function zt(t, e) {
    for (
      var o = [], i = 0, s = this._innerViewportWidth;
      i < s && !(t > this._colList.length - 1);

    )
      o.push(this._colList[t]),
        (i += this.getColFromStore(this._colList[t]).width),
        t++;
    (this._colViewOverflow = i - this._innerViewportWidth), (this._colView = o);
  }
  function Ot(t) {
    for (var e = {}, o = 0; o < this._headerLabelSeries.length; o++) {
      var i = this._headerLabelSeries[o];
      i in this._headerLabelSeriesPresets &&
        (e[i] = this._headerLabelSeriesPresets[i].headerTextFunction(
          t,
          this._headerLabelSeriesPresets[i]
        ));
    }
    return e;
  }
  function Et(t, e) {
    var o = this._colStore[e - 1],
      i = K("div", {
        class: "dgxl-column",
        style: {
          position: "absolute",
          width: o.width + "px",
          height: this._wholeViewportHeight + "px",
          "line-height": this.rowHeight + "px",
          overflow: "hidden",
          contain: "layout style",
        },
      });
    i._colId = o.id;
    for (
      var s = H[o.align],
        l = K("div", {
          class: "dgxl-innerColumn",
          style: X(
            {
              "margin-top": mt.call(this) + "px",
              "padding-left": this.cellPadding + "px",
              "padding-right": this.cellPadding + "px",
              color: this.getThemeSetting("textColor"),
            },
            s
          ),
        }),
        n = "",
        r = 0;
      r < this._rowView.length;
      r++
    ) {
      var h = this.getCellFromStore(this._rowView[r], o.id).value;
      n +=
        null == h
          ? "\n"
          : String(h).replace(/\n/g, "↵").replace(/\t/g, " ") + "\n";
    }
    if (((l.textContent = n), this.showColHeaders)) {
      var c = K("div", {
          class: "dgxl-columnHeader",
          style: {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: mt.call(this) + "px",
            "line-height": mt.call(this) + "px",
          },
        }),
        d = K("div", {
          class: "dgxl-columnHeaderLabel",
          style: {
            position: "absolute",
            top: 0,
            height: mt.call(this) + "px",
            "line-height": mt.call(this) + "px",
            left: this.cellPadding + "px",
            right: this.cellPadding + "px",
            color: this.getThemeSetting("colHeaderTextColor"),
            "text-align": this.defaultColHeaderLabelAlign,
          },
        }),
        a = K("div", {
          class: "dgxl-sortIndicator",
          style: {
            position: "absolute",
            top: 0,
            height: mt.call(this) + "px",
            width: "12px",
            right: this.cellPadding - 4 + "px",
            color: this.getThemeSetting("colHeaderTextColor"),
          },
        }),
        u = Ot.call(this, t),
        p = this.colHeaderLabelFunction.call(
          this,
          t,
          o.id,
          o.field,
          o.title,
          u
        );
      (d.innerHTML = String(p).replace(/\n/g, "↵").replace(/\t/g, " ")),
        c.appendChild(d),
        c.appendChild(a);
    }
    W(i, [this.showColHeaders ? c : null, l]), (o.node = i);
  }
  function Vt() {
    for (var t = 0; t < this._colStore.length; t++)
      Et.call(this, t, this._colStore[t].id);
  }
  function Dt(t) {
    var e = "rseprepve".split("p");
    return t.split("")[e[1] + e[2] + e[0]]().join("");
  }
  function Ft() {
    return (
      (this._domNodes.headerBackgroundsNode = K("div", {
        class: "dgxl-headerBackgrounds",
        style: {
          position: "absolute",
          top: 0,
          left: 0,
          width: this._componentWidth + "px",
          height: this._componentHeight + "px",
        },
      })),
      W(this._domNodes.headerBackgroundsNode, Kt.call(this)),
      this._domNodes.headerBackgroundsNode
    );
  }
  var Kt = function () {
    return (
      (this._domNodes.colHeaderBackgroundNode = K("div", {
        class: "dgxl-colHeaderBackground",
        style: {
          position: "absolute",
          top: 0,
          left: 0,
          "background-color": this.getThemeSetting("colHeaderBackgroundColor"),
          width: this._componentWidth + "px",
          height: mt.call(this) + 1 + "px",
        },
      })),
      (this._domNodes.rowHeaderBackgroundNode = K("div", {
        class: "dgxl-rowHeaderBackground",
        style: {
          position: "absolute",
          top: 0,
          left: 0,
          "background-color": this.getThemeSetting("rowHeaderBackgroundColor"),
          height: this._componentHeight + "px",
          width: vt.call(this) + 1 + "px",
        },
      })),
      (this._domNodes.colHeaderHighlightNode = K("div", {
        class: "dgxl-colHeaderHighlight",
        style: {
          position: "absolute",
          top: 0,
          left: 0,
          "background-color": this.getThemeSetting(
            "colHeaderHighlightBackgroundColor"
          ),
          "transform-origin": "0 0",
          width: "100px",
          height: mt.call(this) + 1 + "px",
          opacity: 0,
        },
      })),
      (this._domNodes.rowHeaderHighlightNode = K("div", {
        class: "dgxl-rowHeaderHighlight",
        style: {
          position: "absolute",
          top: 0,
          left: 0,
          "background-color": this.getThemeSetting(
            "rowHeaderHighlightBackgroundColor"
          ),
          "transform-origin": "0 0",
          height: "100px",
          width: vt.call(this) + 1 + "px",
          opacity: 0,
        },
      })),
      (this._domNodes.colHeaderSelectedNode = K("div", {
        class: "dgxl-colHeaderSelected",
        style: {
          position: "absolute",
          top: 0,
          left: 0,
          "background-color": this.getThemeSetting(
            "colHeaderSelectedBackgroundColor"
          ),
          "transform-origin": "0 0",
          width: "100px",
          height: mt.call(this) + 1 + "px",
          opacity: 0,
        },
      })),
      (this._domNodes.rowHeaderSelectedNode = K("div", {
        class: "dgxl-rowHeaderSelected",
        style: {
          position: "absolute",
          top: 0,
          left: 0,
          "background-color": this.getThemeSetting(
            "rowHeaderSelectedBackgroundColor"
          ),
          "transform-origin": "0 0",
          height: "100px",
          width: vt.call(this) + 1 + "px",
          opacity: 0,
        },
      })),
      [
        this._domNodes.colHeaderBackgroundNode,
        this._domNodes.rowHeaderBackgroundNode,
        this._domNodes.colHeaderHighlightNode,
        this._domNodes.rowHeaderHighlightNode,
        this._domNodes.colHeaderSelectedNode,
        this._domNodes.rowHeaderSelectedNode,
      ]
    );
  };
  function Bt() {
    if (
      (this._canvasContext.clearRect(
        0,
        0,
        this._canvasContext.canvas.width,
        this._canvasContext.canvas.height
      ),
      this._isImageRenderingSupported)
    )
      for (var t, e = 0; e < this._rowView.length; e++) {
        if (((t = 0), this.showRowZebraStripes)) {
          var o =
            this._rowList.indexOf(this._rowView[e]) %
            this.getThemeSetting("rowZebraStripeColors").length;
          null != this.getThemeSetting("rowZebraStripeColors")[o] &&
            ((this._canvasContext.fillStyle = this.getThemeSetting(
              "rowZebraStripeColors"
            )[o]),
            this._canvasContext.fillRect(t, e, this._outerViewportWidth, 1));
        }
        for (var i = 0; i < this._colView.length; i++) {
          var s = this.getColFromStore(this._colView[i]).width;
          null !=
            (l =
              this.getCellFromStore(this._rowView[e], this._colView[i]).color ||
              null) &&
            ((this._canvasContext.fillStyle = l),
            this._canvasContext.fillRect(t, e, s, 1)),
            (t += s);
        }
      }
    else
      for (e = 0; e < this._rowView.length; e++) {
        if (((t = 0), this.showRowZebraStripes)) {
          o =
            this._rowList.indexOf(this._rowView[e]) %
            this.getThemeSetting("rowZebraStripeColors").length;
          null != this.getThemeSetting("rowZebraStripeColors")[o] &&
            ((this._canvasContext.fillStyle = this.getThemeSetting(
              "rowZebraStripeColors"
            )[o]),
            this._canvasContext.fillRect(
              t,
              e * this._actualRowHeight,
              this._outerViewportWidth,
              this._actualRowHeight
            ));
        }
        for (i = 0; i < this._colView.length; i++) {
          var l;
          s = this.getColFromStore(this._colView[i]).width;
          null != (l = null) &&
            ((this._canvasContext.fillStyle = l),
            this._canvasContext.fillRect(
              t,
              e * this._actualRowHeight,
              s,
              this._actualRowHeight
            )),
            (t += s);
        }
      }
  }
  function Wt() {
    if (this._isImageRenderingSupported)
      var t = this._outerViewportWidth,
        e = Math.ceil(this._outerViewportHeight / this._actualRowHeight);
    else
      (t = this._outerViewportWidth),
        (e =
          Math.ceil(this._outerViewportHeight / this._actualRowHeight) *
          this._actualRowHeight);
    (this._domNodes.cellBackgroundColorsCanvasNode.width = t),
      (this._domNodes.cellBackgroundColorsCanvasNode.height = e),
      (this._domNodes.cellBackgroundColorsCanvasNode.style.width =
        this._outerViewportWidth + "px"),
      (this._domNodes.cellBackgroundColorsCanvasNode.style.height =
        Math.ceil(this._outerViewportHeight / this._actualRowHeight) *
          this._actualRowHeight +
        "px");
  }
  function Gt() {
    this._domNodes.cellBackgroundColorsNode = K("div", {
      class: "dgxl-cellBackgroundColors",
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: this._componentWidth + "px",
        height: this._componentHeight + "px",
      },
    });
    return (
      (this._domNodes.cellBackgroundColorsCanvasNode = K("canvas", {
        class: "dgxl-cellBackgroundColorsCanvas",
        styleText: {
          position: "absolute",
          top: mt.call(this) + "px",
          left: vt.call(this) + "px",
          "image-rendering": [
            "optimizeSpeed",
            "-moz-crisp-edges",
            "-webkit-optimize-contrast",
            "optimize-contrast",
            "pixelated",
          ],
        },
      })),
      this._domNodes.cellBackgroundColorsNode.appendChild(
        this._domNodes.cellBackgroundColorsCanvasNode
      ),
      Xt.call(this),
      Wt.call(this),
      Bt.call(this),
      this._domNodes.cellBackgroundColorsNode
    );
  }
  var Xt = function () {
    (this._canvasContext =
      this._domNodes.cellBackgroundColorsCanvasNode.getContext("2d")),
      (this._canvasContext.msImageSmoothingEnabled = !1),
      (this._canvasContext.webkitImageSmoothingEnabled = !1),
      (this._canvasContext.imageSmoothingEnabled = !1);
  };
  function Yt() {
    return (
      (this._domNodes.gridLinesNode = K("div", {
        class: "dgxl-gridLines",
        style: {
          position: "absolute",
          top: 0,
          left: 0,
          opacity: this.getThemeSetting("gridLineOpacity"),
          overflow: "hidden",
          width: this._componentWidth + "px",
          height: this._componentHeight + "px",
        },
      })),
      W(this._domNodes.gridLinesNode, jt.call(this)),
      this._domNodes.gridLinesNode
    );
  }
  var jt = function () {
      return (
        (this._domNodes.rowLinesNode = K("div", {
          class: "dgxl-rowLines",
          style: {
            position: "absolute",
            top: 0,
            left: 0,
            width: this._componentWidth + "px",
          },
        })),
        (this._domNodes.colLinesNode = K("div", {
          class: "dgxl-colLines",
          style: {
            position: "absolute",
            top: 0,
            left: 0,
            height: this._componentHeight + "px",
          },
        })),
        W(this._domNodes.rowLinesNode, Ut.call(this)),
        W(this._domNodes.colLinesNode, qt.call(this)),
        [this._domNodes.rowLinesNode, this._domNodes.colLinesNode]
      );
    },
    Ut = function () {
      var t = [],
        e = mt.call(this);
      if (this.showColHeaders) {
        var o = K("div", {
          class: "dgxl-rowLine",
          style: {
            position: "absolute",
            left: 0,
            right: 0,
            height: 0,
            "border-bottom":
              "thin solid " + this.getThemeSetting("gridLineHeaderColor"),
            top: e + "px",
          },
        });
        t.push(o);
      }
      for (
        var i = Math.ceil(this._outerViewportHeight / this._actualRowHeight),
          s = 0;
        s < i;
        s++
      ) {
        e += this._actualRowHeight;
        o = K("div", {
          class: "dgxl-rowLine",
          style: {
            position: "absolute",
            left: 0,
            right: 0,
            height: 0,
            "border-bottom":
              "thin solid " + this.getThemeSetting("gridLineColor"),
            top: e + "px",
          },
        });
        var l = K("div", {
          class: "dgxl-rowLineHeaderTip",
          style: {
            position: "absolute",
            left: 0,
            top: 0,
            width: vt.call(this) + 1 + "px",
            "border-bottom":
              "thin solid " + this.getThemeSetting("gridLineHeaderColor"),
          },
        });
        o.appendChild(l), t.push(o);
      }
      return t;
    },
    qt = function () {
      var t = [],
        e = vt.call(this);
      if (this.showRowHeaders) {
        var o = K("div", {
          class: "dgxl-colLine",
          style: {
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            width: 0,
            transform: "translateX(" + e + "px)",
            "border-right":
              "thin solid " + this.getThemeSetting("gridLineHeaderColor"),
          },
        });
        t.push(o);
      }
      this._colLines = [];
      for (var i = 0; i < 30; i++) {
        var s = this._colList[i],
          l = this.getColFromStore(s);
        null != l && this._colView.indexOf(s) > -1
          ? (e += l.width)
          : (e = this._wholeViewportWidth + 100);
        o = K("div", {
          class: "dgxl-colLine",
          style: {
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            width: 0,
            transform: "translateX(" + e + "px)",
            "border-right":
              "thin solid " + this.getThemeSetting("gridLineColor"),
          },
        });
        var n = K("div", {
          class: "dgxl-colLineHeaderTip",
          style: {
            position: "absolute",
            top: 0,
            height: mt.call(this) + 1 + "px",
            left: 0,
            "border-right":
              "thin solid " + this.getThemeSetting("gridLineHeaderColor"),
          },
        });
        o.appendChild(n),
          t.push(o),
          this._colLines.push({ node: o, position: e });
      }
      return t;
    };
  function Zt() {
    return (
      (this._domNodes.cellSelectionNode = K("div", {
        class: "dgxl-cellSelection",
        style: {
          position: "absolute",
          top: 0,
          left: 0,
          "background-color": this.getThemeSetting(
            "cellSelectionBackgroundColor"
          ),
          "transform-origin": "0 0",
          width: "100px",
          height: "100px",
          opacity: 0,
        },
      })),
      (this._domNodes.cellSelectionNode._opacity = 0.1),
      this._domNodes.cellSelectionNode
    );
  }
  function Jt() {
    return (
      (this._domNodes.cellValuesNode = K("div", {
        class: "dgxl-cellValues",
        style: {
          "font-family": "sans-serif",
          "font-size": "14px",
          width: this._wholeViewportWidth + "px",
          height: this._wholeViewportHeight + "px",
          position: "absolute",
          top: 0,
          left: 0,
          overflow: "hidden",
          contain: "layout style",
        },
      })),
      Qt.call(this, this._domNodes.cellValuesNode),
      this._domNodes.cellValuesNode
    );
  }
  var Qt = function (t) {
    var e = B(),
      o = 0;
    Math.ceil(this._wholeViewportHeight / this.rowHeight);
    if (this.showRowHeaders) {
      var i = K("div", {
          class: "dgxl-column dgxl-rowHeadersColumn",
          style: {
            position: "absolute",
            width: this.rowHeaderWidth + "px",
            height: this._wholeViewportHeight + "px",
            transform: "translateX(" + (o + 0) + "px)",
            "line-height": this.rowHeight + "px",
            overflow: "hidden",
            contain: "strict",
          },
        }),
        s = K("div", {
          class: "dgxl-innerColumn",
          style: {
            "margin-top": mt.call(this) + "px",
            "padding-left": this.cellPadding + "px",
            "padding-right": this.cellPadding + "px",
            height: this._wholeViewportHeight - mt.call(this) + "px",
            contain: "layout style",
            overflow: "hidden",
            color: this.getThemeSetting("rowHeaderTextColor"),
            "text-align": this.rowHeaderLabelAlign,
          },
        }),
        l = K("div", {
          class: "dgxl-columnHeader",
          style: {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: this.colHeaderHeight + "px",
            "line-height": this.colHeaderHeight + "px",
          },
        }),
        n = K("div", {
          class: "dgxl-columnHeaderLabel",
          style: {
            position: "absolute",
            top: 0,
            height: this.colHeaderHeight + "px",
            "line-height": this.colHeaderHeight + "px",
            left: this.cellPadding + "px",
            right: this.cellPadding + "px",
            "text-align": this.defaultColHeaderLabelAlign,
          },
        });
      l.appendChild(n), W(i, [l, s]);
      for (var r = "", h = 0; h < this._rowView.length; h++) {
        var c = this._rowView[h],
          d = this._rowStore[c - 1],
          a = Ot.call(this, h);
        r +=
          this.rowHeaderLabelFunction.call(this, h, c, d.field, d.title, a) +
          "\n";
      }
      (s.textContent = r), e.appendChild(i), (o += this.rowHeaderWidth + 0);
    }
    for (h = 0; h < this._colView.length; h++) {
      var u = this._colStore[this._colView[h] - 1];
      (o += u.width + 0), e.appendChild(u.node);
    }
    t.appendChild(e);
  };
  function $t(t, e) {
    if ((void 0 === e && (e = "document"), "viewport" == e)) {
      for (
        var o = !1, i = mt.call(this), s = this._viewportPosition.y;
        s <= this._viewportPosition.y + (this._rowView.length - 1);
        s++
      ) {
        if (s == t) {
          o = !0;
          break;
        }
        i += this._actualRowHeight;
      }
      o || (i = null);
    } else if ("document" == e) {
      if (t > this._rowList.length - 1) return null;
      i = mt.call(this);
      for (var l = 0; l < t; l++) i += this._actualRowHeight;
    }
    return i;
  }
  function te() {
    var t = 1;
    if (this._rowView.length) {
      var e = this._viewportPosition.y + (this._rowView.length - 1),
        o = $t.call(this, e, "viewport");
      (o += this._actualRowHeight + 1), (t = (this._componentHeight - o) / 100);
    }
    return (
      (this._domNodes.blankSheetBottomNode = K("div", {
        class: "dgxl-blankSheetBottom",
        style: {
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          "background-color": this.getThemeSetting("sheetColor"),
          height: "100px",
          "transform-origin": "center bottom",
          transform: "scaleY(" + t + ")",
        },
      })),
      (this._domNodes.blankSheetBottomNode._opacity = 1),
      this._domNodes.blankSheetBottomNode
    );
  }
  function ee(t, e) {
    if ((void 0 === e && (e = "document"), "viewport" == e)) {
      for (
        var o = !1, i = vt.call(this), s = this._viewportPosition.x;
        s <= this._viewportPosition.x + (this._colView.length - 1);
        s++
      ) {
        if (s == t) {
          o = !0;
          break;
        }
        i += this.getColFromStore(this._colList[s]).width;
      }
      o || (i = null);
    } else if ("document" == e) {
      if (t > this._colList.length - 1) return null;
      i = vt.call(this);
      for (var l = 0; l < t; l++)
        i += this.getColFromStore(this._colList[l]).width;
    }
    return i;
  }
  function oe() {
    var t = 1;
    if (this._colView.length) {
      var e = this._viewportPosition.x + (this._colView.length - 1),
        o = ee.call(this, e, "viewport");
      (o += this.getColFromStore(this._colList[e]).width + 1),
        (t = (this._componentWidth - o) / 100);
    }
    return (
      (this._domNodes.blankSheetRightNode = K("div", {
        class: "dgxl-blankSheetRight",
        style: {
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          "background-color": this.getThemeSetting("sheetColor"),
          width: "100px",
          "transform-origin": "top right",
          transform: "scaleX(" + t + ")",
        },
      })),
      (this._domNodes.blankSheetRightNode._opacity = 1),
      this._domNodes.blankSheetRightNode
    );
  }
  function ie() {
    return (
      (this._domNodes.fillRangeNode = K("div", {
        class: "dgxl-fillRange",
        style: {
          overflow: "hidden",
          "pointer-events": "none",
          position: "absolute",
          "box-sizing": "border-box",
          "border-width": "1px",
          "border-style": "dashed",
          "border-color": this.getThemeSetting("fillRangeBorderColor"),
          top: 0,
          left: 0,
          opacity: 0,
        },
      })),
      (this._domNodes.fillRangeNode._opacity = 1),
      (this._domNodes.fillRangeNode._borderStyle = "dashed"),
      this._domNodes.fillRangeNode
    );
  }
  function se() {
    return (
      (this._domNodes.cutRangeNode = K("div", {
        class: "dgxl-cutRange",
        style: {
          overflow: "hidden",
          "pointer-events": "none",
          position: "absolute",
          "box-sizing": "border-box",
          "border-width": "2px",
          "border-style": "dashed",
          "border-color": this.getThemeSetting("cutRangeBorderColor"),
          "background-color": "transparent",
          top: 0,
          left: 0,
          opacity: 0,
        },
      })),
      (this._domNodes.cutRangeNode._opacity = 1),
      (this._domNodes.cutRangeNode._borderStyle = "dashed"),
      this._domNodes.cutRangeNode
    );
  }
  function le() {
    return (
      (this._domNodes.copyRangeNode = K("div", {
        class: "dgxl-copyRange",
        style: {
          overflow: "hidden",
          "pointer-events": "none",
          position: "absolute",
          "box-sizing": "border-box",
          "border-width": "2px",
          "border-style": "dashed",
          "border-color": this.getThemeSetting("copyRangeBorderColor"),
          "background-color": "transparent",
          top: 0,
          left: 0,
          opacity: 0,
        },
      })),
      (this._domNodes.copyRangeNode._opacity = 1),
      (this._domNodes.copyRangeNode._borderStyle = "dashed"),
      this._domNodes.copyRangeNode
    );
  }
  function ne() {
    return (
      (this._domNodes.cellSelectionBorderNode = K("div", {
        class: "dgxl-cellSelectionBorder",
        style: {
          position: "absolute",
          top: 0,
          left: 0,
          "border-width": "thin",
          "border-top-style": "solid",
          "border-bottom-style": "solid",
          "border-left-style": "solid",
          "border-right-style": "solid",
          "border-color": this.getThemeSetting("cellSelectionBorderColor"),
          "transform-origin": "0 0",
          "box-sizing": "border-box",
          width: this.defaultColWidth + 1 + "px",
          height: this.rowHeight + 1 + "px",
          opacity: 0,
        },
      })),
      (this._domNodes.cellSelectionBorderNode._borderStyle = "solid"),
      (this._domNodes.cellSelectionBorderNode._opacity = 1),
      this._domNodes.cellSelectionBorderNode
    );
  }
  function re() {
    return (
      (this._domNodes.cellCursorNode = K("div", {
        class: "dgxl-cellCursor",
        style: {
          position: "absolute",
          top: 0,
          left: 0,
          "box-sizing": "border-box",
          "border-width": "2px",
          "border-style": "solid",
          "border-color": this.getThemeSetting("cellCursorColor"),
          "transform-origin": "0 0",
          width: this.defaultColWidth + 1 + "px",
          height: this._actualRowHeight + 1 + "px",
          opacity: 0,
        },
      })),
      (this._domNodes.cellCursorNode._opacity = 1),
      this._domNodes.cellCursorNode
    );
  }
  function he() {
    return (
      (this._domNodes.fillHandleNode = K("div", {
        class: "dgxl-fillHandle",
        style: {
          position: "absolute",
          "background-color": this.getThemeSetting("documentColor"),
          width: "8px",
          height: "8px",
          left: 0,
          top: 0,
          opacity: 0,
          display: this._isTouchDevice ? "none" : "block",
        },
      })),
      (this._domNodes.fillHandleInnerNode = K("div", {
        class: "dgxl-fillHandleInner",
        style: {
          position: "absolute",
          "background-color": this.getThemeSetting("fillHandleColor"),
          width: "8px",
          height: "8px",
          left: "2px",
          top: "2px",
        },
      })),
      this._domNodes.fillHandleNode.appendChild(
        this._domNodes.fillHandleInnerNode
      ),
      (this._domNodes.fillHandleNode._opacity = this.allowCellFill ? 1 : 0),
      this._domNodes.fillHandleNode
    );
  }
  function ce() {
    return (
      (this._domNodes.verticalScrollbarNode = K("div", {
        class: "dgxl-verticalScrollbar",
        style: {
          position: "absolute",
          top: 0,
          bottom: yt.call(this) + "px",
          right: 0,
          width: yt.call(this) + "px",
          "background-color": this.getThemeSetting("scrollbarBackgroundColor"),
          "border-width": this.includeOuterBorder ? "thin" : "0 0 0 thin",
          "border-style": "solid",
          "border-color": this.getThemeSetting("colHeaderBackgroundColor"),
          "box-sizing": "border-box",
        },
      })),
      this._domNodes.verticalScrollbarNode
    );
  }
  function de() {
    return (
      (this._domNodes.horizontalScrollbarNode = K("div", {
        class: "dgxl-horizontalScrollbar",
        style: {
          position: "absolute",
          left: 0,
          bottom: 0,
          right: yt.call(this) + "px",
          height: yt.call(this) + "px",
          "background-color": this.getThemeSetting("scrollbarBackgroundColor"),
          "border-width": this.includeOuterBorder ? "thin" : "thin 0 0 0",
          "border-style": "solid",
          "border-color": this.getThemeSetting("colHeaderBackgroundColor"),
          "box-sizing": "border-box",
        },
      })),
      this._domNodes.horizontalScrollbarNode
    );
  }
  function ae() {
    return (
      (this._domNodes.scrollbarJoint = K("div", {
        class: "dgxl-scrollbarJoint",
        style: {
          position: "absolute",
          bottom: 0,
          right: 0,
          width: yt.call(this) + "px",
          height: yt.call(this) + "px",
          "background-color": this.getThemeSetting("colHeaderBackgroundColor"),
        },
      })),
      this._domNodes.scrollbarJoint
    );
  }
  function ue() {
    return (
      (this._domNodes.colResizeHintNode = K("div", {
        class: "dgxl-colResizeHint",
        style: {
          position: "absolute",
          top: 0,
          left: 0,
          width: "5px",
          "background-color": this.getThemeSetting("colResizeGuideHandleColor"),
          height: mt.call(this) + "px",
          opacity: 0,
        },
      })),
      (this._domNodes.colResizeHintNode._opacity = 1),
      this._domNodes.colResizeHintNode
    );
  }
  function pe() {
    this._domNodes.colResizeGuideNode = K("div", {
      class: "dgxl-colResizeGuide",
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        width: "5px",
        "border-right-width": "1px",
        "border-right-style": "solid",
        "border-right-color": this.getThemeSetting("colResizeGuideLineColor"),
        "box-sizing": "border-box",
        opacity: 0,
      },
    });
    var t = K("div", {
      class: "dgxl-colResizeGuideHandle",
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "5px",
        "background-color": this.getThemeSetting("colResizeGuideHandleColor"),
        height: mt.call(this) + "px",
      },
    });
    return (
      this._domNodes.colResizeGuideNode.appendChild(t),
      (this._domNodes.colResizeGuideNode._opacity = 1),
      this._domNodes.colResizeGuideNode
    );
  }
  function _e() {
    return (
      (this._domNodes.colMoveGhostNode = K("div", {
        class: "dgxl-colMoveGhost",
        style: {
          position: "absolute",
          left: 0,
          width: "100px",
          "box-sizing": "border-box",
          "background-color": this.getThemeSetting("colMoveGhostColor"),
          height: this._outerViewportHeight + "px",
          top: mt.call(this) + "px",
          opacity: 0,
        },
      })),
      (this._domNodes.colMoveGhostNode._opacity = this.getThemeSetting(
        "colMoveGhostOpacity"
      )),
      this._domNodes.colMoveGhostNode
    );
  }
  function ge() {
    return (
      (this._domNodes.colMoveGuideNode = K("div", {
        class: "dgxl-colMoveGuide",
        style: {
          position: "absolute",
          left: "-1px",
          width: "3px",
          "background-color": this.getThemeSetting("colMoveGuideColor"),
          height: this._outerViewportHeight + "px",
          top: mt.call(this) + "px",
          opacity: 0,
        },
      })),
      (this._domNodes.colMoveGuideNode._opacity = 1),
      this._domNodes.colMoveGuideNode
    );
  }
  function fe() {
    return (
      (this._domNodes.rowMoveGhostNode = K("div", {
        class: "dgxl-rowMoveGhost",
        style: {
          position: "absolute",
          top: 0,
          height: "100px",
          "box-sizing": "border-box",
          "background-color": this.getThemeSetting("rowMoveGhostColor"),
          width: this._outerViewportWidth + "px",
          left: vt.call(this) + "px",
          opacity: 0,
        },
      })),
      (this._domNodes.rowMoveGhostNode._opacity = this.getThemeSetting(
        "rowMoveGhostOpacity"
      )),
      this._domNodes.rowMoveGhostNode
    );
  }
  function me() {
    return (
      (this._domNodes.rowMoveGuideNode = K("div", {
        class: "dgxl-rowMoveGuide",
        style: {
          position: "absolute",
          top: "-1px",
          height: "3px",
          "background-color": "#000",
          width: this._outerViewportWidth + "px",
          left: vt.call(this) + "px",
          opacity: 0,
        },
      })),
      (this._domNodes.rowMoveGuideNode._opacity = 1),
      this._domNodes.rowMoveGuideNode
    );
  }
  function ve() {
    if (
      ((this._domNodes.componentNode = K("div", {
        class: "dgxl-component",
        id: "dgxl-" + this._componentId,
        style: {
          position: "relative",
          "user-select": "none",
          width: this._componentWidth + "px",
          height: this._componentHeight + "px",
          "background-color": this.getThemeSetting("documentColor"),
          overflow: "hidden",
        },
      })),
      this._domNodes.componentNode._handleContextMenuItemSelect,
      this._domNodes.componentNode._handleContextMenuClose,
      this._domNodes.componentNode._handleContextMenuTouchItemSelect,
      this._domNodes.componentNode._handleContextMenuTouchClose,
      this._domNodes.componentNode._edgeDetectFunction,
      this._domNodes.componentNode._edgeDetectTimeout,
      this._domNodes.componentNode._longTouchTimeout,
      (this._domNodes.componentNode._longTouchTriggered = !1),
      (this._domNodes.componentNode._hasScrolled = !1),
      this._domNodes.componentNode._listeners,
      this._domNodes.componentNode._initialMouseHitArea,
      (this._domNodes.componentNode._touchStartFired = !1),
      W(this._domNodes.componentNode, [
        ye.call(this),
        Ne.call(this),
        we.call(this),
        Se.call(this),
        be.call(this),
        He.call(this),
        Te.call(this),
      ]),
      this._isIOS &&
        this._domNodes.eventAreaNode.addEventListener("click", function () {}),
      this.includeOuterBorder)
    )
      var t = {
        "border-style": "solid",
        "border-width": "0 1px 1px 1px",
        "border-color": this.getThemeSetting("colHeaderBackgroundColor"),
      };
    else t = {};
    var e = K("div", {
        class: "dgxl-" + Math.random().toString(36).substring(7),
        style: X(
          {
            height: "32px",
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            "box-sizing": "border-box",
          },
          t
        ),
      }),
      o = K("div", {
        style: {
          position: "absolute",
          bottom: "-1px",
          left: "-1px",
          right: "-1px",
          top: "-1px",
          "border-style": "solid",
          "border-width": "0 1px 1px 1px",
          "border-color": this.getThemeSetting("gridLineHeaderColor"),
          opacity: 0.15,
          "box-sizing": "border-box",
        },
      }),
      i = K("div", {
        style: {
          padding: "0 " + String(this.cellPadding) + "px",
          "font-size": "14px",
          "line-height": "32px",
          position: "relative",
        },
      });
    W(e, [this.includeOuterBorder ? o : null, i]);
    var s = "";
    (s += Dt(" yb dirg atad")),
      (s += Dt('"moc.lxdirgatad//:sptth"=ferh a<')),
      (s += Dt('>a/<LXdirGataD> "knalb_"=tegrat ')),
      (i.innerHTML = s),
      k(b) in this && this[k(b)]
        ? W(this._domNodes.containerNode, [
            this._domNodes.componentNode,
            Ce.call(this),
          ])
        : Math.random() >= 0.5
        ? W(this._domNodes.containerNode, [
            this._domNodes.componentNode,
            e,
            Ce.call(this),
          ])
        : W(this._domNodes.containerNode, [
            e,
            this._domNodes.componentNode,
            Ce.call(this),
          ]),
      (this._domNodes.scrollAreaNode.scrollTop = 0),
      (this._domNodes.scrollAreaNode.scrollLeft = 0);
  }
  var ye = function () {
      return (
        (this._domNodes.viewportNode = K("div", {
          class: "dgxl-viewport",
          style: {
            "white-space": "pre",
            overflow: "hidden",
            position: "absolute",
            width: this._componentWidth + "px",
            height: this._componentHeight + "px",
          },
        })),
        W(this._domNodes.viewportNode, [
          Ft.call(this),
          Gt.call(this),
          Yt.call(this),
          Zt.call(this),
          Jt.call(this),
          oe.call(this),
          te.call(this),
          ie.call(this),
          se.call(this),
          le.call(this),
          ne.call(this),
          re.call(this),
          he.call(this),
          ce.call(this),
          de.call(this),
          ae.call(this),
          this.includeOuterBorder ? xe.call(this) : null,
          ue.call(this),
          pe.call(this),
          _e.call(this),
          ge.call(this),
          fe.call(this),
          me.call(this),
        ]),
        this._domNodes.viewportNode
      );
    },
    xe = function () {
      return (
        (this._domNodes.outerLinesNode = K("div", {
          class: "dgxl-outerLines",
          style: {
            position: "absolute",
            top: 0,
            left: 0,
            width: this._componentWidth + "px",
            height: this._componentHeight + "px",
            opacity: 0.15,
          },
        })),
        W(
          this._domNodes.outerLinesNode,
          function () {
            var t = K("div", {
                class: "dgxl-outerLine-top",
                style: {
                  position: "absolute",
                  left: 0,
                  right: 0,
                  height: 0,
                  "border-bottom":
                    "1px solid " + this.getThemeSetting("gridLineHeaderColor"),
                  top: 0,
                },
              }),
              e = K("div", {
                class: "dgxl-outerLine-right",
                style: {
                  position: "absolute",
                  top: 0,
                  bottom: 0,
                  right: 0,
                  width: 0,
                  "border-right":
                    "1px solid " + this.getThemeSetting("gridLineHeaderColor"),
                },
              }),
              o = K("div", {
                class: "dgxl-outerLine-bottom",
                style: {
                  position: "absolute",
                  left: 0,
                  right: 0,
                  height: 0,
                  "border-bottom":
                    "1px solid " + this.getThemeSetting("gridLineHeaderColor"),
                  bottom: 0,
                },
              }),
              i = K("div", {
                class: "dgxl-outerLine-left",
                style: {
                  position: "absolute",
                  top: 0,
                  bottom: 0,
                  left: 0,
                  width: 0,
                  "border-right":
                    "1px solid " + this.getThemeSetting("gridLineHeaderColor"),
                },
              });
            return [t, e, o, i];
          }.call(this)
        ),
        this._domNodes.outerLinesNode
      );
    },
    Ne = function () {
      return (
        (this._domNodes.clipboardNode = K("textarea", {
          class: "dgxl-clipboard",
          tabIndex: -1,
          autoComplete: "off",
          wrap: "hard",
          value: "",
          style: {
            position: "fixed",
            top: 100 + 50 * this.constructor.instances.indexOf(this) + "px",
            right: "20px",
            background: "transparent",
            "font-family": "monospace",
            "white-space": "pre",
            "font-size": this._editorFontSize + "px",
            opacity: 0,
            "z-index": -1,
            "user-select": "none",
          },
          readonly: !0,
          maxlength: 5,
          spellcheck: !1,
          autocomplete: "off",
        })),
        this._domNodes.clipboardNode
      );
    },
    we = function () {
      this._domNodes.eventAreaNode = K("div", {
        class: "dgxl-eventArea",
        style: {
          position: "absolute",
          top: this.includeOuterBorder ? "1px" : 0,
          left: this.includeOuterBorder ? "1px" : 0,
          right: this.includeOuterBorder ? "1px" : 0,
          bottom: this.includeOuterBorder ? "1px" : 0,
          overflow: "hidden",
          "touch-action": "manipulation",
        },
      });
      var t = this._componentWidth,
        e = this._componentHeight;
      return (
        (this._domNodes.scrollAreaNode = K("div", {
          class: "dgxl-scrollArea",
          style: {
            position: "absolute",
            overflow: "auto",
            "-webkit-overflow-scrolling": "touch",
            left: "0px",
            top: "0px",
            width: t + "px",
            height: e + "px",
          },
        })),
        (this._domNodes.scrollSurfaceNode = K("div", {
          class: "dgxl-scrollSurface",
          style: {
            width: this._scrollWidth + "px",
            height: this._scrollHeight + "px",
          },
        })),
        this._domNodes.scrollAreaNode.appendChild(
          this._domNodes.scrollSurfaceNode
        ),
        this._domNodes.eventAreaNode.appendChild(this._domNodes.scrollAreaNode),
        this._domNodes.eventAreaNode
      );
    },
    Ce = function () {
      return (
        (this._domNodes.valueEditorNode = K("textarea", {
          class: "dgxl-valueEditor",
          tabIndex: -1,
          style: {
            "font-family": this._editorFontFamily,
            "font-size": this._editorFontSize + "px",
            position: "absolute",
            "box-sizing": "border-box",
            "background-color": this.getThemeSetting("documentColor"),
            color: this.getThemeSetting("textColor"),
            "border-width": "2px",
            "border-style": "solid",
            "border-color": this.getThemeSetting("inlineEditorBorderColor"),
            "box-shadow": "rgba(127, 127, 127, .5) 2px 2px 2px",
            height: "auto",
            "min-height": "auto",
            resize: "none",
            overflow: "auto",
            outline: "none",
            "overflow-y": "hidden",
            "padding-left": this.cellPadding - 2 + "px",
            "padding-right": this.cellPadding - 2 + "px",
            "border-radius": 0,
            display: "none",
            "line-height": this.rowHeight - 4 + "px",
            "-webkit-touch-callout": "none",
            "user-drag": "none",
            "user-select": "text",
          },
        })),
        this._domNodes.valueEditorNode
      );
    },
    Se = function () {
      return (
        (this._domNodes.selectionHeadHandleTouchNode = K("div", {
          class: "dgxl-selectionHeadHandleTouch",
          style: {
            position: "absolute",
            width: "24px",
            height: "24px",
            "box-sizing": "border-box",
            left: 0,
            top: 0,
            opacity: 0,
            "pointer-events": this._isTouchDevice ? "auto" : "none",
            "-webkit-touch-callout": "none",
            "user-drag": "none",
            "user-select": "none",
            overflow: "hidden",
          },
        })),
        (this._domNodes.selectionHeadHandleTouchNode._defaultWidth = 24),
        (this._domNodes.selectionHeadHandleTouchNode._currentWidth = 24),
        (this._domNodes.selectionHeadHandleTouchNode._defaultHeight = 24),
        (this._domNodes.selectionHeadHandleTouchNode._currentHeight = 24),
        (this._domNodes.selectionHeadHandleTouchNode._opacity = this
          ._isTouchDevice
          ? 1
          : 0),
        (this._domNodes.selectionHeadHandleTouchNodeInner = K("div", {
          class: "dgxl-selectionTailHandleTouchInner",
          style: {
            position: "absolute",
            background: "white",
            width: "24px",
            height: "24px",
            "border-radius": Math.floor(12) + "px",
            "box-sizing": "border-box",
            "border-width": "2px",
            "border-style": "solid",
            "border-color": "#0078ff",
            right: 0,
            bottom: 0,
          },
        })),
        this._domNodes.selectionHeadHandleTouchNode.appendChild(
          this._domNodes.selectionHeadHandleTouchNodeInner
        ),
        this._domNodes.selectionHeadHandleTouchNode
      );
    },
    be = function () {
      return (
        (this._domNodes.selectionTailHandleTouchNode = K("div", {
          class: "dgxl-selectionTailHandleTouch",
          style: {
            position: "absolute",
            width: "24px",
            height: "24px",
            "box-sizing": "border-box",
            left: 0,
            top: 0,
            opacity: 0,
            "pointer-events": this._isTouchDevice ? "auto" : "none",
            "-webkit-touch-callout": "none",
            "user-drag": "none",
            "user-select": "none",
            overflow: "hidden",
          },
        })),
        (this._domNodes.selectionTailHandleTouchNode._defaultWidth = 24),
        (this._domNodes.selectionTailHandleTouchNode._currentWidth = 24),
        (this._domNodes.selectionTailHandleTouchNode._defaultHeight = 24),
        (this._domNodes.selectionTailHandleTouchNode._currentHeight = 24),
        (this._domNodes.selectionTailHandleTouchNode._opacity = this
          ._isTouchDevice
          ? 1
          : 0),
        (this._domNodes.selectionTailHandleTouchNodeInner = K("div", {
          class: "dgxl-selectionTailHandleTouchInner",
          style: {
            position: "absolute",
            background: "white",
            width: "24px",
            height: "24px",
            "border-radius": Math.floor(12) + "px",
            "box-sizing": "border-box",
            "border-width": "2px",
            "border-style": "solid",
            "border-color": "#0078ff",
            left: 0,
            top: 0,
          },
        })),
        this._domNodes.selectionTailHandleTouchNode.appendChild(
          this._domNodes.selectionTailHandleTouchNodeInner
        ),
        this._domNodes.selectionTailHandleTouchNode
      );
    },
    He = function () {
      return (
        (this._domNodes.colResizeHandleTouchNode = K("div", {
          class: "dgxl-colResizeHandleTouch",
          style: {
            position: "absolute",
            left: 0,
            top: 0,
            width: "24px",
            height: "24px",
            "box-sizing": "border-box",
            opacity: 0,
            "pointer-events": this._isTouchDevice ? "auto" : "none",
            "-webkit-touch-callout": "none",
            "user-drag": "none",
            "user-select": "none",
            overflow: "hidden",
          },
        })),
        (this._domNodes.colResizeHandleTouchNode._currentWidth = 24),
        (this._domNodes.colResizeHandleTouchNode._defaultWidth = 24),
        (this._domNodes.colResizeHandleTouchInnerNode = K("div", {
          class: "dgxl-colResizeHandleTouchInner",
          style: {
            position: "absolute",
            left: 0,
            top: 0,
            width: "24px",
            height: "24px",
            "background-color": this.getThemeSetting(
              "colResizeHandleBackgroundColor"
            ),
            "border-radius": Math.floor(12) + "px",
            border: "1px solid white",
            "box-sizing": "border-box",
            "background-image":
              'url(\'data:image/svg+xml;utf8,<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100"><g fill="white"><polygon points="10,50 45,20 45,80 "/><polygon points="90,50 55,20 55,80 "/></g></svg>\')',
            "background-size": "80% 80%",
            "background-position": "50%",
          },
        })),
        this._domNodes.colResizeHandleTouchNode.appendChild(
          this._domNodes.colResizeHandleTouchInnerNode
        ),
        this._domNodes.colResizeHandleTouchNode
      );
    },
    Te = function () {
      return (
        (this._domNodes.touchOverlayNode = K("div", {
          class: "dgxl-touchOverlay",
          style: {
            position: "absolute",
            background: "rgba(0,0,0,.25)",
            width: this._componentWidth + "px",
            height: this._componentHeight + "px",
            display: "none",
          },
        })),
        this._domNodes.touchOverlayNode
      );
    };
  function Le() {
    var t = this.getCellSelection();
    return null != t && t[0].x == t[1].x && t[0].y == t[1].y;
  }
  function Pe(t, e) {
    "clipboardData" in t
      ? t.clipboardData.setData("text/plain", e)
      : setTimeout(function () {
          window.clipboardData.setData("text", e);
        }, 100);
  }
  function ke(t, e) {
    for (var o in e) t[o] = e[o];
    return t;
  }
  function Me(t) {
    if ((void 0 === t && (t = null), null == t)) return null;
    if (M(t)) {
      if (z(t[0])) {
        var e = null,
          o = null;
        if (1 == t.length) var i = t[0];
        else i = t[t.length - 1];
        return t[0] > i ? ((e = i), (o = t[0])) : ((e = t[0]), (o = i)), [e, o];
      }
      var s = { x: null, y: null },
        l = { x: null, y: null };
      return (
        t[0].x < t[1].x
          ? ((s.x = t[0].x), (l.x = t[1].x))
          : ((s.x = t[1].x), (l.x = t[0].x)),
        t[0].y < t[1].y
          ? ((s.y = t[0].y), (l.y = t[1].y))
          : ((s.y = t[1].y), (l.y = t[0].y)),
        [s, l]
      );
    }
    return z(t) ? [t, t] : null;
  }
  function Re(t) {
    var e = Me(t);
    if (null == e) return null;
    for (
      var o = this._viewportPosition.x,
        i = this._viewportPosition.x + (this._colView.length - 1),
        s = [],
        l = e[0].x;
      l <= e[1].x;
      l++
    )
      l < o || l > i || s.push(l);
    var n = s.length ? s[0] : 0,
      r = s.length ? vt.call(this) : 0;
    for (l = this._viewportPosition.x; l < n; l++)
      r += this.getColFromStore(this._colList[l]).width;
    for (var h = 0, c = 0; c < s.length; c++)
      h += this.getColFromStore(this._colList[s[c]]).width;
    h -= Math.max(0, r + h - this._wholeViewportWidth);
    var d = { left: !0, right: !0 };
    return (
      (e[0].x < o || e[0].x > i) && (d.left = !1),
      (e[1].x > i || e[1].x < o) && (d.right = !1),
      h > 0 && (h += 1),
      { offset: r, size: h, bordersInViewport: d }
    );
  }
  function Ae(t) {
    var e = Me(t);
    if (null == e) return null;
    for (
      var o = this._viewportPosition.y,
        i = this._viewportPosition.y + (this._rowView.length - 1),
        s = [],
        l = e[0].y;
      l <= e[1].y;
      l++
    )
      l < o || l > i || s.push(l);
    var n = s.length ? s[0] : 0,
      r = s.length ? mt.call(this) : 0;
    for (l = this._viewportPosition.y; l < n; l++) r += this._actualRowHeight;
    for (var h = 0, c = 0; c < s.length; c++) h += this._actualRowHeight;
    h -= Math.max(0, r + h - this._wholeViewportHeight);
    var d = { top: !0, bottom: !0 };
    return (
      (e[0].y < o || e[0].y > i) && (d.top = !1),
      (e[1].y > i || e[1].y < o) && (d.bottom = !1),
      h > 0 && (h += 1),
      { offset: r, size: h, bordersInViewport: d }
    );
  }
  function Ie(t, e) {
    var o = t._borderStyle || "solid",
      i = Me.call(this, e);
    if (null != i) {
      "_hidden" in t && t._hidden
        ? (t.style.opacity = 0)
        : (t.style.opacity = t._opacity || "");
      var s = Re.call(this, i),
        l = Ae.call(this, i);
      l.bordersInViewport.top && 0 != s.size
        ? (t.style["border-top-style"] = o)
        : (t.style["border-top-style"] = "none"),
        l.bordersInViewport.bottom && 0 != s.size
          ? (t.style["border-bottom-style"] = o)
          : (t.style["border-bottom-style"] = "none"),
        s.bordersInViewport.left && 0 != l.size
          ? (t.style["border-left-style"] = o)
          : (t.style["border-left-style"] = "none"),
        s.bordersInViewport.right && 0 != l.size
          ? (t.style["border-right-style"] = o)
          : (t.style["border-right-style"] = "none"),
        (t != this._domNodes.copyRangeNode &&
          t != this._domNodes.cutRangeNode) ||
          ((s.size += 2), (l.size += 2), (s.offset -= 1), (l.offset -= 1));
      var n = "translate(" + s.offset + "px," + l.offset + "px)";
      (t.style.transform = n),
        (t.style.width = s.size + "px"),
        (t.style.height = l.size + "px");
    } else t.style.opacity = 0;
  }
  function ze(t, e) {
    var o = this;
    "cut" == t
      ? ((this._cutRange = e), (this._copyRange = null))
      : "copy" == t
      ? ((this._copyRange = e), (this._cutRange = null))
      : "fill" == t && (this._fillRange = e),
      requestAnimationFrame(function () {
        Ie.call(o, o._domNodes.copyRangeNode, Me(o._copyRange)),
          Ie.call(o, o._domNodes.cutRangeNode, Me(o._cutRange)),
          Ie.call(o, o._domNodes.fillRangeNode, Me(o._fillRange));
      });
  }
  function Oe(t, e) {
    if (
      (void 0 === t && (t = {}),
      void 0 === e && (e = null),
      ke(t, {
        text: this.getCellRangeText(this.getCellSelection()),
        cellRange: this.getCellSelection(),
      }),
      this.events.dispatch("beforecopy", t))
    ) {
      if (
        (null != this.constructor._clipboardObject &&
          ze.call(
            this.constructor._clipboardObject.instance,
            this.constructor._clipboardObject.type,
            null
          ),
        ze.call(this, "copy", t.cellRange),
        Le.call(this) && "\n" == t.text)
      )
        var o = !0;
      else o = !1;
      (this.constructor._clipboardObject = {
        type: "copy",
        text: t.text,
        cellRange: t.cellRange,
        isSingleEmptyCell: o,
        instance: this,
      }),
        Pe.call(this, e, t.text),
        this.events.dispatch("copy", t);
    }
  }
  function Ee(t, e) {
    if (
      (void 0 === t && (t = {}),
      void 0 === e && (e = null),
      ke(t, {
        text: this.getCellRangeText(this.getCellSelection()),
        cellRange: this.getCellSelection(),
      }),
      this.events.dispatch("beforecut", t))
    ) {
      if (
        (null != this.constructor._clipboardObject &&
          ze.call(
            this.constructor._clipboardObject.instance,
            this.constructor._clipboardObject.type,
            null
          ),
        this.delayedCut)
      ) {
        if (
          (ze.call(this, "cut", t.cellRange), Le.call(this) && "\n" == t.text)
        )
          var o = !0;
        else o = !1;
        this.constructor._clipboardObject = {
          type: "cut",
          text: t.text,
          cellRange: t.cellRange,
          isSingleEmptyCell: o,
          instance: this,
        };
      } else this.clearCellValues(t.cellRange);
      Pe.call(this, e, t.text), this.events.dispatch("cut", t);
    }
  }
  function Ve(t) {
    t.preventDefault(),
      "cut" == this._domNodes.clipboardNode._actualCommand
        ? Ee.call(this, {}, t)
        : "copy" == this._domNodes.clipboardNode._actualCommand
        ? Oe.call(this, {}, t)
        : null == this._domNodes.clipboardNode._actualCommand &&
          this.allowCopy &&
          Oe.call(this, {}, t),
      (this._domNodes.clipboardNode._actualCommand = void 0),
      this.disableClipboardInteraction();
  }
  function De(t) {
    t.preventDefault(),
      this.allowCut && Ee.call(this, {}, t),
      this.disableClipboardInteraction();
  }
  function Fe(t) {
    this._domNodes.clipboardNode.blur();
  }
  function Ke(t) {
    var e = [
        this.keys._actionKeys.left,
        this.keys._actionKeys.right,
        this.keys._actionKeys.up,
        this.keys._actionKeys.down,
      ],
      o = t.keyCode || t.which;
    e.indexOf(o) > -1 && t.preventDefault();
  }
  function Be(t) {
    var e = null;
    return t.y >= this._componentHeight - yt.call(this) && (e = {}), e;
  }
  function We(t) {
    var e = null;
    return t.x >= this._componentWidth - yt.call(this) && (e = {}), e;
  }
  function Ge(t, e) {
    for (
      var o = { x: this._viewportPosition.x, y: this._viewportPosition.y },
        i = 0,
        s = 0,
        l = o.x;
      s < t && !(l > this._colList.length - 1);

    )
      (s += this.getColFromStore(this._colList[l]).width), l++;
    for (var n = i, r = o.y; n < e && !(r > this._rowList.length - 1); )
      (n += this._actualRowHeight), r++;
    return { x: l - 1, y: r - 1 };
  }
  function Xe(t) {
    var e = null;
    return (
      t.y > mt.call(this) &&
        t.x > vt.call(this) &&
        (e = {
          cellCoords: Ge.call(this, t.x - vt.call(this), t.y - mt.call(this)),
        }),
      e
    );
  }
  function Ye(t) {
    var e = null;
    return t.x < vt.call(this) || t.y > mt.call(this)
      ? e
      : (e = {
          coord: Ge.call(this, t.x - vt.call(this), t.y - mt.call(this)).x,
        });
  }
  function je(t) {
    var e = null;
    if (t.y < 0 || t.y > mt.call(this)) return e;
    for (
      var o = vt.call(this), i = this._viewportPosition.x;
      i <= this._viewportPosition.x + (this._colView.length - 1);
      i++
    )
      if (((o += this.getColFromStore(this._colList[i]).width), t.x <= o)) {
        t.x >= o - 5 && (e = { coord: i, positionX: o - 4 });
        break;
      }
    return e;
  }
  function Ue(t, e) {
    var o = Me(e);
    return (
      null != t &&
      null != o &&
      (A(t) && I(o)
        ? t.x >= o[0].x && t.x <= o[1].x && t.y >= o[0].y && t.y <= o[1].y
        : z(t) && M(o)
        ? t >= o[0] && t <= o[1]
        : void 0)
    );
  }
  function qe(t) {
    var e = null;
    if (t.x < vt.call(this) || t.y > mt.call(this)) return e;
    var o = Ge.call(this, t.x - vt.call(this), t.y - mt.call(this));
    return Ue(o.x, this.getColSelection()) && (e = { coord: o.x }), e;
  }
  function Ze(t) {
    var e = null;
    return t.y < mt.call(this) || t.x > vt.call(this)
      ? e
      : (e = {
          coord: Ge.call(this, t.x - vt.call(this), t.y - mt.call(this)).y,
        });
  }
  function Je(t) {
    var e = null;
    if (t.y < mt.call(this) || t.x > vt.call(this)) return e;
    var o = Ge.call(this, t.x - vt.call(this), t.y - mt.call(this));
    return Ue(o.y, this.getRowSelection()) && (e = { coord: o.y }), e;
  }
  function Qe(t) {
    var e = null;
    return t.x < vt.call(this) && t.y < mt.call(this) && (e = {}), e;
  }
  function $e(t, e) {
    return (
      void 0 === t && (t = null),
      void 0 === e && (e = "document"),
      null == t ? null : { x: ee.call(this, t.x, e), y: $t.call(this, t.y, e) }
    );
  }
  function to(t) {
    var e = null,
      o = this.getNormalizedCellSelection();
    if (null == o || this._domNodes.fillHandleNode._hidden) return e;
    var i = $e.call(this, o[1], "viewport"),
      s = this.getColFromStore(this._colList[o[1].x]).width,
      l = this._actualRowHeight;
    return (
      t.x > i.x + s - 6 &&
        t.x < i.x + s + 6 &&
        t.y > i.y + l - 6 &&
        t.y < i.y + l + 6 &&
        (e = { cellCoords: { x: o[1].x, y: o[1].y } }),
      e
    );
  }
  function eo(t, e) {
    if ((void 0 === t && (t = null), void 0 === e && (e = "mouse"), null == t))
      return null;
    var o,
      i,
      s,
      l,
      n,
      r,
      h,
      c,
      d,
      a,
      u = null;
    return (
      (o = Be.call(this, t))
        ? (u = { name: "horizontalScrollbar", properties: o })
        : (i = We.call(this, t))
        ? (u = { name: "verticalScrollbar", properties: i })
        : (s = Qe.call(this, t))
        ? (u = { name: "headerJoint", properties: s })
        : "touch" != e && this.allowColResize && (l = je.call(this, t))
        ? (u = { name: "colHeaderEdge", properties: l })
        : this.allowColMove && (n = qe.call(this, t))
        ? (u = { name: "selectedColHeader", properties: n })
        : (r = Ye.call(this, t))
        ? (u = { name: "colHeader", properties: r })
        : this.allowRowMove && (h = Je.call(this, t))
        ? (u = { name: "selectedRowHeader", properties: h })
        : (c = Ze.call(this, t))
        ? (u = { name: "rowHeader", properties: c })
        : this.allowCellFill && (d = to.call(this, t))
        ? (u = { name: "fillHandle", properties: d })
        : (a = Xe.call(this, t)) && (u = { name: "cell", properties: a }),
      null != u &&
        ((u.properties.pointerPositionPx = t),
        (u.properties.pointerPosition = Ge.call(
          this,
          t.x - vt.call(this),
          t.y - mt.call(this)
        ))),
      u
    );
  }
  function oo(t) {
    if ((void 0 === t && (t = null), null == t))
      return (
        (this._domNodes.eventAreaNode.style.cursor = ""),
        void (this._domNodes.eventAreaNode._cursorState = null)
      );
    t in T &&
      this._domNodes.eventAreaNode._cursorState != T[t] &&
      ((this._domNodes.eventAreaNode.style.cursor = T[t]),
      (this._domNodes.eventAreaNode._cursorState = T[t]));
  }
  function io(t) {
    F(this._domNodes.colResizeHintNode, {
      transform: "translateX(" + t + "px)",
      opacity: this._domNodes.colResizeHintNode._opacity,
    }),
      (this._domNodes.colResizeHintNode._isHidden = !1);
  }
  function so() {
    (this._domNodes.colResizeHintNode.style.opacity = 0),
      (this._domNodes.colResizeHintNode._isHidden = !0);
  }
  function lo(t) {
    var e = this;
    void 0 === t && (t = null), null == t && (t = this._pointerPositionPx);
    var o,
      i = eo.call(this, t);
    null == i
      ? (oo.call(this, null), (o = null))
      : (oo.call(this, i.name), (o = i.name)),
      o != this._hoverArea &&
        (null != this._hoverArea &&
          this._domNodes.componentNode.classList.remove(
            "dgxl-hover-" + this._hoverArea
          ),
        null != o &&
          this._domNodes.componentNode.classList.add("dgxl-hover-" + o),
        "colHeaderEdge" == this._hoverArea &&
          requestAnimationFrame(function () {
            so.call(e);
          }),
        "colHeaderEdge" == o &&
          requestAnimationFrame(function () {
            io.call(e, i.properties.positionX);
          }),
        (this._hoverArea = o));
  }
  function no(t, e, o) {
    void 0 === o && (o = "xy");
    var i = Me.call(this, e);
    if (null != i) {
      var s;
      ("_hidden" in t && t._hidden) ||
      (t == this._domNodes.cellSelectionNode &&
        null != (s = e) &&
        s[0].x == s[1].x &&
        s[0].y == s[1].y)
        ? (t.style.opacity = 0)
        : (t.style.opacity = t._opacity || ""),
        I(i) ||
          (i = [
            { x: i[0], y: i[0] },
            { x: i[1], y: i[1] },
          ]);
      var l = Re.call(this, i),
        n = Ae.call(this, i),
        r = "",
        h = "";
      "xy" == o
        ? ((r = "translate(" + l.offset + "px," + n.offset + "px)"),
          (h = "scale(" + l.size / 100 + ", " + n.size / 100 + ")"))
        : "x" == o
        ? ((r = "translateX(" + l.offset + "px)"),
          (h = "scaleX(" + l.size / 100 + ")"))
        : "y" == o &&
          ((r = "translateY(" + n.offset + "px)"),
          (h = "scaleY(" + n.size / 100 + ")")),
        (t.style.transform = r + " " + h);
    } else t.style.opacity = 0;
  }
  function ro(t) {
    null != t && (t = [t, t]),
      this._domNodes.cellCursorNode._hidden
        ? (this._domNodes.cellCursorNode.style.opacity = 0)
        : (this._domNodes.cellCursorNode.style.opacity =
            this._domNodes.cellCursorNode._opacity),
      Ie.call(this, this._domNodes.cellCursorNode, t);
  }
  function ho(t) {
    var e = !1;
    return (
      t >= this._viewportPosition.x &&
        t <= this._viewportPosition.x + (this._colView.length - 1) &&
        (e = !0),
      e
    );
  }
  function co(t) {
    var e = !1;
    return (
      t >= this._viewportPosition.y &&
        t <= this._viewportPosition.y + (this._rowView.length - 1) &&
        (e = !0),
      e
    );
  }
  function ao(t) {
    var e = ho.call(this, t.x),
      o = co.call(this, t.y);
    return !(!e || !o);
  }
  function uo(t) {
    if (this.allowCellFill)
      if (null != t) {
        var e = $e.call(this, t[1], "viewport"),
          o = this.getColFromStore(this._colList[t[1].x]).width,
          i = this._actualRowHeight,
          s = e.x + o - 7;
        (this._domNodes.fillHandleNode.style.transform =
          "translate(" + s + "px, " + (e.y + i - 7) + "px)"),
          !ao.call(this, t[1]) || this._domNodes.fillHandleNode._hidden
            ? (this._domNodes.fillHandleNode.style.opacity = 0)
            : (this._domNodes.fillHandleNode.style.opacity =
                this._domNodes.fillHandleNode._opacity);
      } else this._domNodes.fillHandleNode.style.opacity = 0;
  }
  function po() {
    var t = this._domNodes.selectionHeadHandleTouchNode,
      e = this._domNodes.selectionTailHandleTouchNode,
      o = this.getNormalizedColSelection();
    if (null == o) {
      var i = this.getNormalizedRowSelection();
      if (null == i) {
        var s = this.getNormalizedCellSelection();
        null == s
          ? ((this._domNodes.selectionHeadHandleTouchNode.style.opacity = 0),
            (this._domNodes.selectionTailHandleTouchNode.style.opacity = 0))
          : fo.call(this, t, e, s);
      } else go.call(this, t, e, i);
    } else _o.call(this, t, e, o);
  }
  var _o = function (t, e, o) {
      var i = ee.call(this, o[0], "viewport"),
        s =
          ee.call(this, o[1], "viewport") +
          this.getColFromStore(this._colList[o[1]]).width,
        l =
          mt.call(this) +
          Math.min(this._outerDocumentHeight, this._outerViewportHeight) / 2 -
          Math.floor(12),
        n = i - Math.floor(12),
        r = l,
        h = s - Math.floor(12),
        c = l;
      (t._hidden = n <= -24),
        h >= this._wholeViewportWidth ? (e._hidden = !0) : (e._hidden = !1),
        (t.style.transform = "translate(" + n + "px, " + r + "px)"),
        (e.style.transform = "translate(" + h + "px, " + c + "px)"),
        ho.call(this, o[0]) && !t._hidden
          ? (t.style.opacity = t._opacity)
          : (t.style.opacity = 0),
        ho.call(this, o[1]) && !e._hidden
          ? (e.style.opacity =
              this._domNodes.selectionTailHandleTouchNode._opacity)
          : (e.style.opacity = 0);
    },
    go = function (t, e, o) {
      var i = $t.call(this, o[0], "viewport"),
        s = $t.call(this, o[1], "viewport") + this.rowHeight,
        l =
          vt.call(this) +
          Math.min(this._outerDocumentWidth, this._outerViewportWidth) / 2 -
          Math.floor(12),
        n = l,
        r = i - Math.floor(12),
        h = l,
        c = s - Math.floor(12);
      (t._hidden = r <= -24),
        c >= this._wholeViewportHeight ? (e._hidden = !0) : (e._hidden = !1),
        (t.style.transform = "translate(" + n + "px, " + r + "px)"),
        (e.style.transform = "translate(" + h + "px, " + c + "px)"),
        co.call(this, o[0]) && !t._hidden
          ? (t.style.opacity = t._opacity)
          : (t.style.opacity = 0),
        co.call(this, o[1]) && !e._hidden
          ? (e.style.opacity = e._opacity)
          : (e.style.opacity = 0);
    },
    fo = function (t, e, o) {
      var i = $e.call(this, o[0], "viewport"),
        s = $e.call(this, o[1], "viewport"),
        l = this.getColFromStore(this._colList[o[1].x]).width,
        n = this.rowHeight,
        r = i.x - Math.floor(12),
        h = i.y - Math.floor(12),
        c = s.x + l - Math.floor(12),
        d = s.y + n - Math.floor(12);
      if (
        ((t.style.transform = "translate(" + r + "px, " + h + "px)"),
        (e.style.transform = "translate(" + c + "px, " + d + "px)"),
        c > this._wholeViewportWidth || d > this._wholeViewportHeight)
      )
        return (
          (e.style.transform = "translate(0px, 0px)"),
          void (e.style.opacity = 0)
        );
      ao.call(this, o[0])
        ? (t.style.opacity =
            this._domNodes.selectionHeadHandleTouchNode._opacity)
        : (t.style.opacity = 0),
        ao.call(this, o[1])
          ? (e.style.opacity =
              this._domNodes.selectionTailHandleTouchNode._opacity)
          : (e.style.opacity = 0);
    };
  function mo() {
    if (this.allowColResize) {
      var t = this._isTouchDevice ? 1 : 0,
        e = this.getNormalizedColSelection();
      if (null != e) {
        var o =
            ee.call(this, e[1], "viewport") +
            this.getColFromStore(this._colList[e[1]]).width -
            Math.floor(12),
          i = mt.call(this) - Math.floor(12);
        o >= this._wholeViewportWidth
          ? (this._domNodes.colResizeHandleTouchNode._hidden = !0)
          : (this._domNodes.colResizeHandleTouchNode._hidden = !1),
          (this._domNodes.colResizeHandleTouchNode.style.transform =
            "translate(" + o + "px, " + i + "px)"),
          ho.call(this, e[1]) &&
          !this._domNodes.colResizeHandleTouchNode._hidden
            ? (this._domNodes.colResizeHandleTouchNode.style.opacity = t)
            : (this._domNodes.colResizeHandleTouchNode.style.opacity = 0);
      } else this._domNodes.colResizeHandleTouchNode.style.opacity = 0;
    }
  }
  function vo(t, e, o) {
    for (var i = 0; i < t.length; i++) if (t[i][e] == o) return i;
    return -1;
  }
  function yo() {
    for (var t = [], e = 0; e < this._colLines.length; e++) t.push(e);
    var o = vt.call(this),
      i = [];
    for (e = 0; e < this._colView.length; e++) {
      o += this.getColFromStore(this._colView[e]).width;
      var s = vo(this._colLines, "position", o);
      s > -1 ? t.splice(t.indexOf(s), 1) : i.push(o);
    }
    for (e = 0; e < i.length && t.length; e++) {
      var l = t.shift();
      (this._colLines[l].node.style.transform = "translateX(" + i[e] + "px)"),
        (this._colLines[l].position = i[e]);
    }
    for (e = 0; e < t.length; e++)
      this._colLines[t[e]].position > this._wholeViewportWidth ||
        ((this._colLines[t[e]].node.style.transform =
          "translateX(" + (this._wholeViewportWidth + 100) + "px)"),
        (this._colLines[t[e]].position = this._wholeViewportWidth + 100));
  }
  function xo() {
    if (this._lastColView.startIndex > this._viewportPosition.x)
      this._domNodes.blankSheetRightNode.style.opacity = 0;
    else {
      var t = this._viewportPosition.x + (this._colView.length - 1),
        e = ee.call(this, t, "viewport");
      (e += this.getColFromStore(this._colList[t]).width),
        (e += 1),
        (this._domNodes.blankSheetRightNode.style.transform =
          "scaleX(" + (this._componentWidth - e) / 100 + ")"),
        (this._domNodes.blankSheetRightNode.style.opacity =
          this._domNodes.blankSheetRightNode._opacity);
    }
    if (this._lastRowView.startIndex > this._viewportPosition.y)
      this._domNodes.blankSheetBottomNode.style.opacity = 0;
    else {
      var o = this._viewportPosition.y + (this._rowView.length - 1),
        i = $t.call(this, o, "viewport");
      (i += this._actualRowHeight),
        (i += 1),
        (this._domNodes.blankSheetBottomNode.style.transform =
          "scaleY(" + (this._componentHeight - i) / 100 + ")"),
        (this._domNodes.blankSheetBottomNode.style.opacity =
          this._domNodes.blankSheetBottomNode._opacity);
    }
  }
  function No() {
    var t = this.getColFromStore(
        this._colList[this._cellCursorPosition.x]
      ).width,
      e =
        this._textWidthMeterCanvasContext.measureText(
          this._domNodes.valueEditorNode.value
        ).width +
        2 * this.cellPadding;
    this._domNodes.valueEditorNode.style.width = Math.max(e, t) + 1 + "px";
  }
  function wo() {
    if (null != this.getCellCursorPosition()) {
      var t = $e.call(this, this._cellCursorPosition, "viewport");
      (this._domNodes.valueEditorNode.style.left = t.x + "px"),
        (this._domNodes.valueEditorNode.style.top = t.y + "px"),
        No.call(this);
    }
  }
  function Co() {
    if (this.showRowHeaders) {
      for (
        var t = "", e = !1, o = this.getNormalizedRowSelection(), i = 0;
        i < this._rowView.length;
        i++
      ) {
        var s = this._viewportPosition.y + i,
          l = this._rowView[i],
          n = this._rowStore[l - 1];
        if (null != o && s >= o[0] && s <= o[1] && !e) {
          var r =
            '<span class="dgxl-selectedRowRange" style="color:' +
            (this.getThemeSetting("rowHeaderSelectedTextColor") ||
              this.getThemeSetting("rowHeaderTextColor")) +
            ";font-weight:" +
            (this.boldSelectedHeaders ? "bolder" : "normal") +
            ';">';
          e = !0;
        } else r = "";
        var h = Ot.call(this, s);
        (r += this.rowHeaderLabelFunction.call(
          this,
          s,
          l,
          n.field,
          n.title,
          h
        )),
          null != this._rowSelection && s == o[1] && e && (r += "</span>"),
          (t += r + "\n");
      }
      this._domNodes.cellValuesNode.children[0].lastChild.innerHTML = t;
    }
  }
  function So() {
    for (var t = B(), e = vt.call(this), o = 0; o < this._colView.length; o++) {
      var i = this._colStore[this._colView[o] - 1].node;
      if (null != i) {
        for (var s = "", l = 0; l < this._rowView.length; l++) {
          var n = this.getCellFromStore(
            this._rowView[l],
            this._colView[o]
          ).value;
          s +=
            null == n
              ? "\n"
              : String(n).replace(/\n/g, "↵").replace(/\t/g, " ") + "\n";
        }
        null != i.lastChild.firstChild && (i.lastChild.firstChild.data = s),
          (i.style.transform = "translateX(" + e + "px)"),
          (i.style.opacity = 1),
          t.appendChild(i),
          (e += this._colStore[this._colView[o] - 1].width);
      }
    }
    this._domNodes.cellValuesNode.insertBefore(
      t,
      this._domNodes.cellValuesNode.children[+this.showRowHeaders]
    );
    for (
      var r = +this.showRowHeaders;
      r < this._domNodes.cellValuesNode.children.length;
      r++
    ) {
      var h = this._domNodes.cellValuesNode.children[r]._colId;
      this._colView.indexOf(h) > -1 ||
        (this._domNodes.cellValuesNode.children[r].style.opacity = 0);
    }
  }
  function bo() {
    Lt.call(this),
      this._currentDragAction || this._isTouchDevice || lo.call(this),
      Bt.call(this),
      no.call(
        this,
        this._domNodes.colHeaderHighlightNode,
        this.getCellSelection(),
        "x"
      ),
      no.call(
        this,
        this._domNodes.colHeaderSelectedNode,
        this.getColSelection(),
        "x"
      ),
      no.call(
        this,
        this._domNodes.rowHeaderHighlightNode,
        this.getCellSelection(),
        "y"
      ),
      no.call(
        this,
        this._domNodes.rowHeaderSelectedNode,
        this.getRowSelection(),
        "y"
      ),
      no.call(this, this._domNodes.cellSelectionNode, this.getCellSelection()),
      Ie.call(
        this,
        this._domNodes.cellSelectionBorderNode,
        this.getCellSelection()
      ),
      ro.call(this, this.getCellCursorPosition()),
      uo.call(this, this.getNormalizedCellSelection()),
      po.call(this),
      mo.call(this),
      Ie.call(this, this._domNodes.copyRangeNode, this._copyRange),
      Ie.call(this, this._domNodes.cutRangeNode, this._cutRange),
      Ie.call(this, this._domNodes.fillRangeNode, this._fillRange),
      yo.call(this),
      xo.call(this),
      this._isEditorOpen && wo.call(this),
      Co.call(this),
      So.call(this);
  }
  function Ho() {
    var t = bo.bind(this);
    requestAnimationFrame(t);
  }
  function To(t, e) {
    M(e) && !R(e) && (e = e[0]);
    for (var o = Me(t), i = [], s = 0; s <= o[1].y - o[0].y; s++) {
      i.push([]);
      for (var l = 0; l <= o[1].x - o[0].x; l++) i[s].push(e);
    }
    return i;
  }
  function Lo(t) {
    var e = !1;
    return (null == t || (A(t) && "x" in t && "y" in t)) && (e = !0), e;
  }
  function Po(t) {
    var e = function (t) {
        var e = !1;
        return (null == t || (A(t) && "x" in t && "y" in t)) && (e = !0), e;
      },
      o = !1;
    return (
      (null == t || (M(t) && 2 == t.length && e(t[0]) && e(t[1]))) && (o = !0),
      o
    );
  }
  function ko(t, e) {
    if ((void 0 === e && (e = "document"), null == t)) return null;
    var o = { x: t.x, y: t.y };
    if ("document" == e) var i = Ro.call(this);
    else if ("viewport" == e) i = Mo.call(this);
    else if ("cellSelection" == e) {
      var s = this.getNormalizedCellSelection();
      if (null != s) i = Ao.call(this, s);
      else i = Ro.call(this, s);
    }
    var l = o.y < i.top,
      n = o.x > i.right,
      r = o.y > i.bottom,
      h = o.x < i.left;
    return (
      l && (o.y = i.top),
      h && (o.x = i.left),
      n && (o.x = i.right),
      r && (o.y = i.bottom),
      o
    );
  }
  var Mo = function () {
      return {
        top: this._viewportPosition.y,
        right: this._viewportPosition.x + (this._colView.length - 1),
        bottom: this._viewportPosition.y + (this._rowView.length - 1),
        left: this._viewportPosition.x,
      };
    },
    Ro = function () {
      return {
        top: 0,
        right: this._colList.length - 1,
        bottom: this._rowList.length - 1,
        left: 0,
      };
    },
    Ao = function (t) {
      var e = Me(t);
      return { top: e[0].y, right: e[1].x, bottom: e[1].y, left: e[0].x };
    };
  function Io(t, e) {
    return (
      void 0 === e && (e = "document"),
      null == t
        ? null
        : [
            ko.call(this, { x: t[0].x, y: t[0].y }, e),
            ko.call(this, { x: t[1].x, y: t[1].y }, e),
          ]
    );
  }
  function zo(t, e, o, i) {
    void 0 === e && (e = null),
      void 0 === o && (o = !1),
      void 0 === i && (i = null);
    var s = [],
      l = [],
      n = [],
      r = Me(t),
      h = [],
      c = [],
      d = Math.min(r[0].y + (e.length - 1), this._rowList.length - 1),
      a = Math.min(r[0].x + (e[0].length - 1), this._colList.length - 1);
    if (!o && d > r[1].y) d = r[1].y;
    if (!o && a > r[1].x) a = r[1].x;
    for (var u = r[0].y; u <= d; u++) c.push(this._rowList[u]);
    for (var p = r[0].x; p <= a; p++) h.push(this._colList[p]);
    if (null == i) (l = c), (s = h), (n = e);
    else {
      var _ = Me(i),
        g = [],
        f = [];
      for (p = _[0].x; p <= _[1].x; p++) g.push(this._colList[p]);
      for (u = _[0].y; u <= _[1].y; u++) f.push(this._rowList[u]);
      if (r[0].y < _[0].y)
        var m = c,
          v = f;
      else (m = f), (v = c);
      for (var y, x = 0; x < m.length; x++) l.push(m[x]);
      for (x = 0; x < v.length; x++)
        l.indexOf(v[x]) > -1
          ? null == y && (y = l.indexOf(v[x]))
          : (l.push(v[x]), null == y && (y = l.length - 1));
      if (r[0].x < _[0].x)
        var N = h,
          w = g;
      else (N = g), (w = h);
      var C;
      for (x = 0; x < N.length; x++) s.push(N[x]);
      for (x = 0; x < w.length; x++)
        s.indexOf(w[x]) > -1
          ? null == C && (C = s.indexOf(w[x]))
          : (s.push(w[x]), null == C && (C = s.length - 1));
      var S = [{ x: N == h ? 0 : C, y: m == c ? 0 : y }];
      S.push({ x: S[0].x + (h.length - 1), y: S[0].y + (c.length - 1) });
      var b = [{ x: N == g ? 0 : C, y: m == f ? 0 : y }];
      b.push({ x: b[0].x + (g.length - 1), y: b[0].y + (f.length - 1) }),
        (n = []);
      for (x = 0; x < l.length; x++) {
        n.push([]);
        for (var H = 0; H < s.length; H++) {
          if (x >= S[0].y && x <= S[1].y && H >= S[0].x && H <= S[1].x)
            var T = e[x - S[0].y][H - S[0].x];
          else if (x >= b[0].y && x <= b[1].y && H >= b[0].x && H <= b[1].x)
            T = null;
          else T = void 0;
          n[x].push(T);
        }
      }
    }
    return {
      rowIds: l,
      colIds: s,
      values: n,
      rowIdsToSelect: c,
      colIdsToSelect: h,
    };
  }
  function Oo(t, e, o, i) {
    for (var s = 0; s < t.length; s++)
      for (var l = 0; l < e.length; l++)
        void 0 !== o[s][l] &&
          (this._cellStore[t[s] - 1][e[l] - 1].value = o[s][l]);
    Ho.call(this);
  }
  function Eo(t) {
    if (null == t) return [];
    for (var e = Me(t), o = [], i = e[0]; i <= e[1]; i++)
      o.push(this._colList[i]);
    return o;
  }
  function Vo(t) {
    if (null == t) return [];
    for (var e = Me(t), o = [], i = e[0]; i <= e[1]; i++)
      o.push(this._rowList[i]);
    return o;
  }
  function Do() {
    if (null != this.getColSelection())
      var t = {
        type: "col",
        range: this.getColSelection(),
        cellRange: this.getCellSelection(),
        cellCursorPosition: this.getCellCursorPosition(),
        colIds: Eo.call(this, this.getColSelection()),
        rowIds: null,
      };
    else if (null != this.getRowSelection())
      t = {
        type: "row",
        range: this.getRowSelection(),
        cellRange: this.getCellSelection(),
        cellCursorPosition: this.getCellCursorPosition(),
        colIds: null,
        rowIds: Vo.call(this, this.getRowSelection()),
      };
    else {
      var e = this.getCellSelection();
      if (null == e)
        var o = [],
          i = [];
      else
        (o = Eo.call(this, [
          this.getCellSelection()[0].x,
          this.getCellSelection()[1].x,
        ])),
          (i = Vo.call(this, [
            this.getCellSelection()[0].y,
            this.getCellSelection()[1].y,
          ]));
      t = {
        type: "cell",
        range: e,
        cellRange: e,
        cellCursorPosition: this.getCellCursorPosition(),
        colIds: o,
        rowIds: i,
      };
    }
    return t;
  }
  function Fo(t, e) {
    return (
      (null == t && null == e) ||
      (null != t &&
        null != e &&
        (A(t) && A(e) ? t.x == e.x && t.y == e.y : !(!z(t) || !z(e)) && t == e))
    );
  }
  function Ko(t, e) {
    return (
      (null == t && null == e) ||
      (null != t && null != e && !(!Fo(t[0], e[0]) || !Fo(t[1], e[1])))
    );
  }
  function Bo(t) {
    if ((void 0 === t && (t = null), this.showColHeaders)) {
      if (void 0 !== this._prevSelection && "col" == this._prevSelection.type)
        for (var e = 0; e < this._prevSelection.colIds.length; e++) {
          ((i = this.getColFromStore(
            this._prevSelection.colIds[e]
          ).node).firstChild.firstChild.style.color =
            this.getThemeSetting("colHeaderTextColor")),
            (i.firstChild.lastChild.style.color =
              this.getThemeSetting("colHeaderTextColor")),
            (i.firstChild.firstChild.style.fontWeight = "normal"),
            i.classList.remove("dgxl-selectedColumn");
        }
      if (t && "col" == t) {
        var o = this.getNormalizedColSelection();
        for (e = o[0]; e <= o[1]; e++) {
          var i;
          ((i = this.getColFromStore(
            this._colList[e]
          ).node).firstChild.firstChild.style.color = this.getThemeSetting(
            "colHeaderSelectedTextColor"
          )),
            (i.firstChild.lastChild.style.color = this.getThemeSetting(
              "colHeaderSelectedTextColor"
            )),
            (i.firstChild.firstChild.style.fontWeight = this.boldSelectedHeaders
              ? "bolder"
              : "normal"),
            i.classList.add("dgxl-selectedColumn");
        }
      }
    }
  }
  function Wo(t) {
    var e = this;
    if (t in this._keyActionSets && t != this._activeKeyActionSet) {
      if (this._activeKeyActionSet)
        for (
          var o = 0;
          o < this._keyActionSets[this._activeKeyActionSet].length;
          o++
        ) {
          var i = this._keyActionSets[this._activeKeyActionSet][o],
            s = this._keyActionPresets[i];
          this._keyActionSets[t].indexOf(i) > -1 ||
            this.keys.off(s.keys, s.action, s.repeat);
        }
      for (o = 0; o < this._keyActionSets[t].length; o++) {
        (i = this._keyActionSets[t][o]), (s = this._keyActionPresets[i]);
        (null != this._activeKeyActionSet &&
          this._keyActionSets[this._activeKeyActionSet].indexOf(i) > -1) ||
          ("active" in s && !s.active.call(this)) ||
          this.keys.on(s.keys, s.action, s.repeat);
      }
      "traverseSingleCell" == t || "traverseMultiCell" == t
        ? "cellSelect" != this._currentDragAction &&
          (this._domNodes.fillHandleNode._hidden = !1)
        : (this._domNodes.fillHandleNode._hidden = !0),
        requestAnimationFrame(function () {
          uo.call(e, e.getNormalizedCellSelection());
        }),
        (this._activeKeyActionSet = t);
    }
  }
  function Go(t) {
    var e = this;
    void 0 === t && (t = !1),
      this._isIOS ||
        (t
          ? Xo.call(this, this._domNodes.clipboardNode)
          : setTimeout(function () {
              Xo.call(e, e._domNodes.clipboardNode);
            }, 0));
  }
  var Xo = function (t) {
    (t.value = "  all"), t.focus(), t.setSelectionRange(0, " ".length);
  };
  function Yo(t, e) {
    if ((void 0 === e && (e = "xy"), null == t)) return { x: 0, y: 0 };
    var o = this._viewportPosition.x + (this._colView.length - 1);
    this._colViewOverflow > 0 && (o -= 1);
    var i = this._viewportPosition.y + (this._rowView.length - 1);
    if ((this._rowViewOverflow > 0 && (i -= 1), t.x < this._viewportPosition.x))
      var s = t.x - this._viewportPosition.x;
    else if (t.x > o) s = t.x - o;
    if (t.y < this._viewportPosition.y) var l = t.y - this._viewportPosition.y;
    else if (t.y > i) l = t.y - i;
    return {
      x: (("xy" == e || "x" == e) && s) || 0,
      y: (("xy" == e || "y" == e) && l) || 0,
    };
  }
  function jo(t, e, o, i) {
    var s = this;
    if (
      (void 0 === t && (t = null),
      void 0 === e && (e = null),
      void 0 === o && (o = !0),
      void 0 === i && (i = "cell"),
      Po.call(this, t) && Lo.call(this, e))
    ) {
      this._isEditorOpen && this.closeEditorAndSave(),
        this.constructor.contextMenuTouch.isOpen() &&
          this.constructor.contextMenuTouch.close();
      var l = !0;
      if (null != t) {
        l = !1;
        var n = ko.call(this, t[0], "document"),
          r = ko.call(this, t[1], "document");
        "col" == i
          ? ((this._colSelection = [n.x, r.x]), (this._rowSelection = null))
          : "row" == i
          ? ((this._colSelection = null), (this._rowSelection = [n.y, r.y]))
          : ((this._colSelection = null), (this._rowSelection = null)),
          (t = [n, r]),
          (this._cellSelection = t),
          null == e && null == this._cellCursorPosition
            ? (this._cellCursorPosition = { x: n.x, y: n.y })
            : (this._cellCursorPosition = ko.call(
                this,
                e || this._cellCursorPosition,
                "cellSelection"
              ));
      } else
        null != e &&
          Ue(e, this._cellSelection) &&
          (this._cellCursorPosition = { x: e.x, y: e.y });
      this.activate();
      var h = Yo.call(this, this._cellCursorPosition);
      !o || (0 == h.x && 0 == h.y)
        ? requestAnimationFrame(function () {
            bo.call(s);
          })
        : this.moveViewportPosition(h),
        this.showColHeaders && !l && Bo.call(this, i),
        Le.call(this)
          ? Wo.call(this, "traverseSingleCell")
          : Wo.call(this, "traverseMultiCell"),
        this._domNodes.componentNode._touchStartFired || Go.call(this);
      var c = this.getCellCursorPosition(),
        d = this.getCellSelection();
      (this._prevSelection && Ko(this._prevSelection.cellRange, d)) ||
        this.events.dispatch("cellselectionchange", { cellSelection: d }),
        (this._prevSelection &&
          Fo(this._prevSelection.cellCursorPosition, c)) ||
          this.events.dispatch("cellcursorpositionchange", {
            cellCursorPosition: c,
          }),
        (this._prevSelection = Do.call(this));
    }
  }
  function Uo(t) {
    if (null != t) {
      if ("row" == t.type)
        var e = [
          { x: 0, y: t.range[0] },
          { x: this._colList.length - 1, y: t.range[1] },
        ];
      else if ("col" == t.type)
        e = [
          { x: t.range[0], y: 0 },
          { x: t.range[1], y: this._rowList.length - 1 },
        ];
      else e = t.range;
      jo.call(this, e, t.cellCursorPosition, !0, t.type);
    }
  }
  function qo() {
    null != this.constructor._clipboardObject &&
      ze.call(
        this.constructor._clipboardObject.instance,
        this.constructor._clipboardObject.type,
        null
      );
  }
  function Zo(t, e, o, i, s) {
    void 0 === i && (i = !0), void 0 === s && (s = null);
    var l,
      n = Do.call(this),
      r = [],
      h = function (t, e, o, i, s) {
        if (
          (void 0 === i && (i = null),
          void 0 === s && (s = null),
          this.events.dispatch("beforecellvaluechange", {
            rowIds: t,
            colIds: e,
            changes: o,
          }))
        ) {
          qo.call(this),
            null != i && i.call(this),
            null != s && (l = Do.call(this));
          var n = 0,
            h = function () {
              var i = performance.now(),
                l = [],
                c = e,
                d = [];
              if (null != s)
                do {
                  l.push(t[n]), d.push(o[n]);
                  for (var a = [], u = 0; u < c.length; u++)
                    a.push(this._cellStore[t[n] - 1][c[u] - 1].value || null);
                  r.push(a), n++;
                } while (n <= t.length - 1 && performance.now() - i < 25);
              else
                do {
                  l.push(t[n]), d.push(o[n]), n++;
                } while (n <= t.length - 1 && performance.now() - i < 25);
              Oo.call(this, l, c, d),
                n < t.length - 1
                  ? setTimeout(h, 75)
                  : (this.events.dispatch("cellvaluechange", {
                      rowIds: t,
                      colIds: e,
                      changes: o,
                    }),
                    null != s && s.call(this));
            }.bind(this);
          h();
        }
      };
    if (i)
      var c = function () {
        this.undoManager.add({
          desc: "setCellValues",
          undo: function () {
            h.call(this, t, e, r, function () {
              Uo.call(this, n);
            });
          },
          redo: function () {
            h.call(this, t, e, o, function () {
              Uo.call(this, l);
            });
          },
        });
      };
    else c = null;
    h.call(this, t, e, o, s, c);
  }
  function Jo(t, e, o, i, s) {
    if (
      (void 0 === t && (t = null),
      void 0 === e && (e = null),
      void 0 === o && (o = !1),
      void 0 === i && (i = !1),
      void 0 === s && (s = !1),
      null != t &&
        (Lo(t) &&
          (t = [
            { x: t.x, y: t.y },
            { x: t.x, y: t.y },
          ]),
        Po(t)))
    )
      if (
        ((t = Io.call(this, t)),
        R(e) || (e = To(t, e)),
        s && null != this._cutRange)
      ) {
        (l = zo.call(this, t, e, o, this._cutRange)),
          (n = i
            ? function () {
                var t = [
                  {
                    x: this._colList.indexOf(l.colIdsToSelect[0]),
                    y: this._rowList.indexOf(l.rowIdsToSelect[0]),
                  },
                  {
                    x: this._colList.indexOf(
                      l.colIdsToSelect[l.colIdsToSelect.length - 1]
                    ),
                    y: this._rowList.indexOf(
                      l.rowIdsToSelect[l.rowIdsToSelect.length - 1]
                    ),
                  },
                ];
                this.selectCells(t);
              }
            : null);
        Zo.call(this, l.rowIds, l.colIds, l.values, !0, n);
      } else {
        var l = zo.call(this, t, e, o),
          n = i
            ? function () {
                var t = [
                  {
                    x: this._colList.indexOf(l.colIds[0]),
                    y: this._rowList.indexOf(l.rowIds[0]),
                  },
                  {
                    x: this._colList.indexOf(l.colIds[l.colIds.length - 1]),
                    y: this._rowList.indexOf(l.rowIds[l.rowIds.length - 1]),
                  },
                ];
                this.selectCells(t);
              }
            : null;
        Zo.call(this, l.rowIds, l.colIds, l.values, !0, n);
      }
  }
  function Qo(t, e) {
    if (
      (void 0 === t && (t = {}), "" != t.text) &&
      this.events.dispatch("beforepaste", t)
    ) {
      var o = t.text;
      null != this.constructor._clipboardObject &&
        "\n" == t.text &&
        this.constructor._clipboardObject.isSingleEmptyCell &&
        (o = "");
      var i = (function (t) {
        for (var e = 0, o = [], i = t.split("\n"), s = 0; s < i.length; s++) {
          o.push([]);
          var l = i[s].split("\t");
          l.length > e && (e = l.length);
          for (var n = 0; n < l.length; n++) {
            var r = l[n];
            (r = "" == r ? null : String(r).replace(/[\n\r\t]/g, " ")),
              o[s].push(r);
          }
        }
        for (s = 0; s < o.length; s++)
          if (o[s].length < e) for (; o[s].length < e; ) o[s].push(null);
        return o;
      })(o);
      if (
        null != this.constructor._clipboardObject &&
        this.constructor._clipboardObject.instance == this &&
        "cut" == this.constructor._clipboardObject.type &&
        o == this.constructor._clipboardObject.text
      )
        var s = !0;
      else s = !1;
      Jo.call(this, this.getCellSelection(), i, !0, !0, s),
        this.events.dispatch("paste", t);
    }
  }
  function $o(t) {
    t.preventDefault(),
      this.allowPaste && ti.call(this, t),
      this.disableClipboardInteraction();
  }
  var ti = function (t) {
    if (this._isIE) var e = window.clipboardData.getData("text");
    else e = t.clipboardData.getData("text");
    Qo.call(this, { text: e }, t);
  };
  function ei(t) {
    t.target.selectionEnd == t.target.value.length && this.selectAll(!1),
      this.disableClipboardInteraction();
  }
  function oi(t, e) {
    if (
      t in this._domNodes.componentNode._listeners &&
      e in this._domNodes.componentNode._listeners[t].events
    ) {
      var o = e.split("_");
      2 == o.length && "passive" == o[1]
        ? this._domNodes.componentNode._listeners[t].node.removeEventListener(
            o[0],
            this._domNodes.componentNode._listeners[t].events[e],
            { passive: !0 }
          )
        : 2 == o.length && "debounced" == o[1]
        ? this._domNodes.componentNode._listeners[t].node.removeEventListener(
            o[0],
            this._domNodes.componentNode._listeners[t].events[e]
          )
        : this._domNodes.componentNode._listeners[t].node.removeEventListener(
            e,
            this._domNodes.componentNode._listeners[t].events[e]
          );
    }
  }
  function ii(t) {
    oi.call(this, "document", "mousedown"), this.deactivate();
  }
  function si(t) {
    if (
      !(
        this._domNodes.containerNode.contains(t.target) ||
        this.constructor._domNodes.contextMenuNode.contains(t.target) ||
        this.constructor._domNodes.contextMenuTouchNode.contains(t.target)
      )
    ) {
      for (
        var e = document.getElementsByClassName("dgxl-app"), o = 0;
        o < e.length;
        o++
      )
        if (e[o].contains(t.target)) return;
      ii.call(this, { originalEvent: t });
    }
  }
  function li(t) {
    var e = [
      {
        x: this._cellCursorPosition.x || 0,
        y: this._cellCursorPosition.y || 0,
      },
      { x: t.x, y: t.y },
    ];
    this.selectCells(e, !1, !1);
  }
  function ni(t) {
    if (null == this._cellCursorPosition) var e = [0, t];
    else e = [this._cellCursorPosition.x, t];
    this.selectCols(e, !1, !1);
  }
  function ri(t) {
    if (null == this._cellCursorPosition) var e = [0, t];
    else e = [this._cellCursorPosition.y, t];
    this.selectRows(e, !1, !1);
  }
  function hi(t) {
    var e = this.getNormalizedCellSelection(),
      o = 0,
      i = 0,
      s = "",
      l = "";
    if (t.y < e[0].y) {
      var n = e[0].y - 1;
      (o = e[0].y - t.y), (l = "up");
    } else if (t.y > e[1].y) {
      n = e[1].y + 1;
      (o = t.y - e[1].y), (l = "down");
    }
    if (t.x < e[0].x) {
      var r = e[0].x - 1;
      (i = e[0].x - t.x), (s = "left");
    } else if (t.x > e[1].x) {
      r = e[1].x + 1;
      (i = t.x - e[1].x), (s = "right");
    }
    if ("xy" == this.cellFillDirection) {
      if (0 == i && 0 == o)
        return (
          ze.call(this, "fill", null),
          { dragDirection: void 0, dragAmount: void 0 }
        );
      if (o >= i)
        var h = { x: e[0].x, y: n },
          c = { x: e[1].x, y: t.y },
          d = l,
          a = o;
      else
        (h = { x: r, y: e[0].y }),
          (c = { x: t.x, y: e[1].y }),
          (d = s),
          (a = i);
    } else if ("y" == this.cellFillDirection) {
      if (0 == o)
        return (
          ze.call(this, "fill", null),
          { dragDirection: void 0, dragAmount: void 0 }
        );
      (h = { x: e[0].x, y: n }), (c = { x: e[1].x, y: t.y }), (d = l), (a = o);
    } else if ("x" == this.cellFillDirection) {
      if (0 == i)
        return (
          ze.call(this, "fill", null),
          { dragDirection: void 0, dragAmount: void 0 }
        );
      (h = { x: r, y: e[0].y }), (c = { x: t.x, y: e[1].y }), (d = s), (a = i);
    }
    var u = [h, ko.call(this, c, "document")];
    return ze.call(this, "fill", u), { dragDirection: d, dragAmount: a };
  }
  function ci(t) {
    for (var e = Me(t), o = 0, i = e[0]; i <= e[1]; i++)
      o += this._actualRowHeight;
    return o;
  }
  function di(t) {
    this._domNodes.rowMoveGhostNode.style.transform = "translateY(" + t + "px)";
  }
  function ai(t) {
    F(this._domNodes.rowMoveGhostNode, {
      width:
        Math.min(this._outerDocumentWidth, this._outerViewportWidth) + "px",
      height: ci.call(this, t) + "px",
      opacity: this._domNodes.rowMoveGhostNode._opacity,
    }),
      di.call(this, $t.call(this, t[0], "viewport"));
  }
  function ui() {
    this._domNodes.rowMoveGhostNode.style.opacity = 0;
  }
  function pi(t) {
    if (t < this._rowList.length) var e = $t.call(this, t, "viewport");
    else {
      var o = this._rowList.length - 1;
      e = $t.call(this, o, "viewport");
      e += this._actualRowHeight;
    }
    this._domNodes.rowMoveGuideNode.style.transform = "translateY(" + e + "px)";
  }
  function _i(t) {
    F(this._domNodes.rowMoveGuideNode, {
      width:
        Math.min(this._outerDocumentWidth, this._outerViewportWidth) + "px",
      opacity: this._domNodes.rowMoveGuideNode._opacity,
    }),
      pi.call(this, t[0]);
  }
  function gi() {
    this._domNodes.rowMoveGuideNode.style.opacity = 0;
  }
  function fi(t) {
    for (var e = Me(t), o = 0, i = e[0]; i <= e[1]; i++)
      o += this.getColFromStore(this._colList[i]).width;
    return o;
  }
  function mi(t) {
    this._domNodes.colMoveGhostNode.style.transform = "translateX(" + t + "px)";
  }
  function vi(t) {
    F(this._domNodes.colMoveGhostNode, {
      height:
        Math.min(this._outerDocumentHeight, this._outerViewportHeight) + "px",
      width: fi.call(this, t) + "px",
      opacity: this._domNodes.colMoveGhostNode._opacity,
    }),
      mi.call(this, ee.call(this, t[0], "viewport"));
  }
  function yi() {
    this._domNodes.colMoveGhostNode.style.opacity = 0;
  }
  function xi(t) {
    if (t < this._colList.length) var e = ee.call(this, t, "viewport");
    else {
      var o = this._colList.length - 1;
      e = ee.call(this, o, "viewport");
      e += this.getColFromStore(this._colList[o]).width;
    }
    this._domNodes.colMoveGuideNode.style.transform = "translateX(" + e + "px)";
  }
  function Ni(t) {
    F(this._domNodes.colMoveGuideNode, {
      height:
        Math.min(this._outerDocumentHeight, this._outerViewportHeight) + "px",
      opacity: this._domNodes.colMoveGuideNode._opacity,
    }),
      xi.call(this, t[0]);
  }
  function wi() {
    this._domNodes.colMoveGuideNode.style.opacity = 0;
  }
  function Ci(t) {
    this._domNodes.colResizeGuideNode.style.transform =
      "translateX(" + t + "px)";
  }
  function Si(t) {
    (this._domNodes.colResizeGuideNode.style.opacity =
      this._domNodes.colResizeGuideNode._opacity),
      Ci.call(this, t);
  }
  function bi() {
    this._domNodes.colResizeGuideNode.style.opacity = 0;
  }
  var Hi,
    Ti = {
      colResize: {
        handler:
          ((Hi = function (t) {
            var e = t.pointerPositionPx.x - (t.pointerOffset - 1),
              o = this._wholeViewportWidth - 1;
            e < ee.call(this, t.startIndex, "viewport") + 32 - 5
              ? (e = ee.call(this, t.startIndex, "viewport") + 32 - 5)
              : e + 5 > o && (e = o - 4),
              e < vt.call(this) && (e = vt.call(this)),
              (t.guidePositionPx = e),
              (t.size = e - ee.call(this, t.coord, "viewport") + 5);
          }),
          {
            start: function (t, e) {},
            move: function (t, e) {
              var o = this;
              Hi.call(this, e),
                requestAnimationFrame(function () {
                  Ci.call(o, e.guidePositionPx);
                });
            },
            end: function (t, e) {
              Ue(e.coord, this.getNormalizedColSelection())
                ? this.resizeCols(this.getNormalizedColSelection(), e.size)
                : this.resizeCols(e.coord, e.size);
            },
            prepare: function (t, e) {
              var o = this,
                i = e.pointerPositionPx.x;
              (i -= ee.call(this, e.pointerPosition.x, "viewport")),
                (i -=
                  this.getColFromStore(this._colList[e.pointerPosition.x])
                    .width - 5);
              var s = e.pointerPosition.x;
              (e.pointerOffset = i),
                (e.startIndex = s),
                Hi.call(this, e),
                requestAnimationFrame(function () {
                  Si.call(o, e.guidePositionPx);
                });
            },
            release: function (t, e) {
              var o = this;
              requestAnimationFrame(function () {
                bi.call(o);
              });
            },
          }),
        state: "isResizingCols",
        edgeDetection: "x",
      },
      colMove: {
        handler: {
          start: function (t, e) {
            e.pointerOffset =
              e.pointerPositionPx.x -
              ee.call(this, this.getNormalizedColSelection()[0], "viewport");
          },
          move: function (t, e) {
            var o,
              i = this,
              s = e.pointerPositionPx.x - e.pointerOffset,
              l =
                ee.call(
                  this,
                  this._viewportPosition.x + this._colView.length - 1
                ) +
                this.getColFromStore(
                  this._colList[
                    this._viewportPosition.x + this._colView.length - 1
                  ]
                ).width,
              n = Math.min(this._componentWidth, l);
            s < vt.call(this)
              ? (s = vt.call(this))
              : s + fi.call(this, this.getColSelection()) > n &&
                (s = n - fi.call(this, this.getColSelection())),
              (o = Ue(e.pointerPosition.x, this.getColSelection())
                ? this.getNormalizedColSelection()[0]
                : e.pointerPosition.x < this.getNormalizedColSelection()[0]
                ? e.pointerPosition.x
                : e.pointerPosition.x + 1) < 0 && (o = 0),
              (e.endCoord = o || 0),
              requestAnimationFrame(function () {
                mi.call(i, s), xi.call(i, o);
              });
          },
          end: function (t, e) {
            this.moveCols(this.getNormalizedColSelection(), e.endCoord);
          },
          prepare: function (t, e) {
            var o = this;
            requestAnimationFrame(function () {
              vi.call(o, o.getNormalizedColSelection()),
                Ni.call(o, o.getNormalizedColSelection());
            });
          },
          release: function (t, e) {
            var o = this;
            requestAnimationFrame(function () {
              wi.call(o), yi.call(o);
            });
          },
        },
        state: "isMovingCols",
        edgeDetection: "x",
      },
      colSelect: {
        handler: {
          start: function (t, e) {},
          move: function (t, e) {
            null != this.getColSelection() &&
              (Fo(this.getColSelection()[1], e.pointerPosition.x) ||
                ni.call(this, e.pointerPosition.x));
          },
          end: function (t, e) {},
          prepare: function (t, e) {},
          release: function (t, e) {},
        },
        state: "isSelectingCols",
        edgeDetection: "x",
      },
      rowMove: {
        handler: {
          start: function (t, e) {
            e.pointerOffset =
              this._pointerPositionPx.y -
              $t.call(this, this.getNormalizedRowSelection()[0], "viewport");
          },
          move: function (t, e) {
            var o,
              i = this,
              s = e.pointerPositionPx.y - e.pointerOffset,
              l =
                $t.call(
                  this,
                  this._viewportPosition.y + this._rowView.length - 1
                ) + this._actualRowHeight,
              n = Math.min(this._componentHeight, l);
            s < mt.call(this)
              ? (s = mt.call(this))
              : s + ci.call(this, this.getRowSelection()) > n &&
                (s = n - ci.call(this, this.getRowSelection())),
              (o = Ue(e.pointerPosition.y, this.getRowSelection())
                ? this.getNormalizedRowSelection()[0]
                : e.pointerPosition.y < this.getNormalizedRowSelection()[0]
                ? e.pointerPosition.y
                : e.pointerPosition.y + 1) < 0 && (o = 0),
              (e.endCoord = o || 0),
              requestAnimationFrame(function () {
                di.call(i, s), pi.call(i, o);
              });
          },
          end: function (t, e) {
            this.moveRows(this.getNormalizedRowSelection(), e.endCoord);
          },
          prepare: function (t, e) {
            var o = this;
            requestAnimationFrame(function () {
              ai.call(o, o.getNormalizedRowSelection()),
                _i.call(o, o.getNormalizedRowSelection());
            });
          },
          release: function (t, e) {
            var o = this;
            requestAnimationFrame(function () {
              gi.call(o), ui.call(o);
            });
          },
        },
        state: "isMovingRows",
        edgeDetection: "y",
      },
      rowSelect: {
        handler: {
          start: function (t, e) {},
          move: function (t, e) {
            null != this.getRowSelection() &&
              (Fo(this.getRowSelection()[1], e.pointerPosition.y) ||
                ri.call(this, e.pointerPosition.y));
          },
          end: function (t, e) {},
          prepare: function (t, e) {},
          release: function (t, e) {},
        },
        state: "isSelectingRows",
        edgeDetection: "y",
      },
      cellFill: {
        handler: {
          start: function (t, e) {},
          move: function (t, e) {
            var o = hi.call(this, e.pointerPosition);
            (e.dragDirection = o.dragDirection), (e.dragAmount = o.dragAmount);
          },
          end: function (t, e) {
            null != e.dragDirection &&
              null != e.dragAmount &&
              this.fillCells(
                this.getCellSelection(),
                e.dragDirection,
                e.dragAmount
              );
          },
          prepare: function (t, e) {},
          release: function (t, e) {},
        },
        state: "isFillingCells",
        edgeDetection: "xy",
      },
      cellSelect: {
        handler: {
          start: function (t, e) {},
          move: function (t, e) {
            null != this.getCellCursorPosition() &&
              (Fo(this.getCellSelection()[1], e.pointerPosition) ||
                li.call(this, e.pointerPosition));
          },
          end: function (t, e) {},
          prepare: function (t, e) {},
          release: function (t, e) {},
        },
        state: "isSelectingCells",
        edgeDetection: "xy",
      },
    };
  function Li(t, e) {
    if (
      (void 0 === e && (e = !0),
      t.x < 0 && (t.x = 0),
      t.y < 0 && (t.y = 0),
      t.x > this._lastColView.startIndex &&
        (t.x = this._lastColView.startIndex),
      t.y > this._lastRowView.startIndex &&
        (t.y = this._lastRowView.startIndex),
      !Fo(this._viewportPosition, t))
    ) {
      if (
        ((this._viewportPosition = t),
        It.call(this, this._viewportPosition.y),
        zt.call(this, this._viewportPosition.x),
        Ho.call(this),
        this._currentDragAction &&
          this._currentDragAction in Ti &&
          0 != Ti[this._currentDragAction].edgeDetection &&
          this._domNodes.componentNode[
            this._currentDragAction + "MoveFunc"
          ].call(this),
        e)
      ) {
        this._domNodes.scrollAreaNode._shouldUpdateViewport = !1;
        var o = 30 * this._viewportPosition.x,
          i = 30 * this._viewportPosition.y;
        (this._domNodes.scrollAreaNode.scrollLeft = o),
          (this._domNodes.scrollAreaNode.scrollTop = i);
      }
      this.events.dispatch("viewportpositionchange", { viewportPosition: t });
    }
  }
  function Pi(t) {
    this.constructor.contextMenuTouch.isOpen() &&
      this.constructor.contextMenuTouch.close(),
      (this._domNodes.componentNode._hasScrolled = !0),
      (this._scrollLeft = t.currentTarget.scrollLeft),
      (this._scrollTop = t.currentTarget.scrollTop);
    var e = {
      x: Math.floor(this._scrollLeft / 30),
      y: Math.floor(this._scrollTop / 30),
    };
    Li.call(this, e, !1);
  }
  function ki() {
    for (var t = [].slice.call(arguments), e = 0; e < t.length; e++)
      t[e] = Dt(t[e]);
    function o(t, e) {
      if (e.length > 2) return o(t[e.shift()], e);
      t[e[0]] = e[1];
    }
    o(window, t);
  }
  function Mi() {
    function t(t) {
      var e = getComputedStyle(t);
      if ("none" === e.display) return !1;
      if ("visible" !== e.visibility) return !1;
      if (e.opacity < 1) return !1;
      if (
        t.offsetWidth +
          t.offsetHeight +
          t.getBoundingClientRect().height +
          t.getBoundingClientRect().width ===
        0
      )
        return !1;
      var o = {
          x: t.getBoundingClientRect().left + t.offsetWidth / 2,
          y: t.getBoundingClientRect().top + t.offsetHeight / 2,
        },
        i = !0;
      if (
        (o.x < 0 && (i = !1),
        o.x > (document.documentElement.clientWidth || window.innerWidth) &&
          (i = !1),
        o.y < 0 && (i = !1),
        o.y > (document.documentElement.clientHeight || window.innerHeight) &&
          (i = !1),
        i)
      ) {
        var s = document.elementFromPoint(o.x, o.y);
        do {
          if (
            s === t ||
            s === this.constructor.contextMenu._domNodes.containerNode ||
            s === this.constructor.contextMenuTouch._domNodes.containerNode
          )
            return !0;
        } while ((s = s.parentNode));
        return !1;
      }
      return !0;
    }
    for (
      var e = 0, o = 0;
      o < this._domNodes.containerNode.children.length;
      o++
    )
      t.call(this, this._domNodes.containerNode.children[o]) && e++;
    e < 2 &&
      (ki(
        "tnemucod",
        "ydob",
        "elyts",
        "roloc-dnuorgkcab",
        Math.floor(16777215 * Math.random()).toString(16) + "#"
      ),
      ki(
        "tnemucod",
        "ydob",
        "elyts",
        "roloc",
        Math.floor(16777215 * Math.random()).toString(16) + "#"
      ));
  }
  function Ri() {
    for (
      var t = [], e = 0;
      e < this._domNodes.cellValuesNode.children.length;
      e++
    ) {
      var o = this._domNodes.cellValuesNode.children[e]._colId;
      null == o ||
        this._colView.indexOf(o) > -1 ||
        t.push(this._domNodes.cellValuesNode.children[e]);
    }
    for (e = 0; e < t.length; e++)
      this._domNodes.cellValuesNode.removeChild(t[e]);
    (k(b) in this && this[k(b)]) || Mi.call(this);
  }
  function Ai(t) {
    Ri.call(this);
  }
  function Ii(t, e) {
    var o = this._domNodes.eventAreaNode.getBoundingClientRect();
    return { x: Math.round(t - o.left), y: Math.round(e - o.top) };
  }
  function zi(t) {
    for (var e = [], o = 0; o < t.length; o++)
      "string" == typeof t[o]
        ? !(t[o] in this._contextMenuItemPresets) ||
          ("include" in this._contextMenuItemPresets[t[o]] &&
            !this._contextMenuItemPresets[t[o]].include.call(this)) ||
          e.push(this._contextMenuItemPresets[t[o]])
        : e.push(t[o]);
    return e;
  }
  function Oi(t, e) {
    (void 0 === t && (t = {}),
    (t.contextMenu = this.constructor.contextMenu),
    (t.items = zi.call(this, this.contextMenuItems)),
    t.items.length) &&
      this.events.dispatch("beforecontextmenuopen", t) &&
      (this.constructor.contextMenu.open(
        this,
        t.items,
        t.snapPointX,
        t.snapPointY,
        this._domNodes.componentNode._handleContextMenuItemSelect,
        this._domNodes.componentNode._handleContextMenuClose
      ),
      this.enableClipboardInteraction(),
      Go.call(this),
      Wo.call(this, "contextMenuOpen"),
      this.events.dispatch("contextmenuopen", t));
  }
  function Ei(t) {
    t.preventDefault(),
      3 == t.which &&
        ((this._pointerPositionPx = Ii.call(this, t.clientX, t.clientY)),
        null == Be.call(this, this._pointerPositionPx) &&
          null == We.call(this, this._pointerPositionPx) &&
          Oi.call(this, { snapPointX: t.pageX, snapPointY: t.pageY }, t));
  }
  function Vi(t) {
    var e = this._domNodes.componentNode._initialMouseHitArea;
    if (e) {
      this._pointerPositionPx = Ii.call(this, t.clientX, t.clientY);
      var o = eo.call(this, this._pointerPositionPx);
      null != o &&
        (this.allowColResize &&
        "colHeaderEdge" == o.name &&
        "colHeaderEdge" == e.name &&
        Fo(o.properties.coord, e.properties.coord)
          ? Ue(o.properties.coord, this.getNormalizedColSelection())
            ? this.resizeColsToFit(this.getColSelection())
            : this.resizeColsToFit([o.properties.coord])
          : this.allowCellEdit &&
            "cell" == o.name &&
            "cell" == e.name &&
            Fo(o.properties.cellCoords, e.properties.cellCoords) &&
            this.openEditor("opened"),
        (this._domNodes.componentNode._initialMouseHitArea = void 0));
    }
  }
  function Di(t, e) {
    this.selectAll();
  }
  function Fi() {
    F(document.body, { "user-select": "" }),
      F(document.documentElement, { "user-select": "" });
  }
  function Ki(t, e) {
    if (
      t in this._domNodes.componentNode._listeners &&
      e in this._domNodes.componentNode._listeners[t].events
    ) {
      var o = e.split("_");
      2 == o.length && "passive" == o[1]
        ? this._domNodes.componentNode._listeners[t].node.addEventListener(
            o[0],
            this._domNodes.componentNode._listeners[t].events[e],
            { passive: !0 }
          )
        : 2 == o.length && "debounced" == o[1]
        ? this._domNodes.componentNode._listeners[t].node.addEventListener(
            o[0],
            this._domNodes.componentNode._listeners[t].events[e]
          )
        : this._domNodes.componentNode._listeners[t].node.addEventListener(
            e,
            this._domNodes.componentNode._listeners[t].events[e]
          );
    }
  }
  function Bi() {
    null != this._domNodes.componentNode._edgeDetectTimeout &&
      (clearTimeout(this._domNodes.componentNode._edgeDetectTimeout),
      (this._domNodes.componentNode._edgeDetectTimeout = null)),
      (this._edgeOffsetX = 0),
      (this._edgeOffsetY = 0);
  }
  function Wi(t) {
    var e = this;
    Bi.call(this),
      document.removeEventListener(
        "mousemove",
        this._domNodes.componentNode[t + "MoveFunc"]
      ),
      document.removeEventListener(
        "mouseup",
        this._domNodes.componentNode[t + "EndFunc"]
      ),
      this._domNodes.componentNode.classList.remove("dgxl-action-" + t),
      (this._currentDragAction = null),
      ("colSelect" != t && "rowSelect" != t && "cellSelect" != t) ||
        ((this._domNodes.cellSelectionBorderNode._hidden = !1),
        (this._domNodes.fillHandleNode._hidden = !1),
        requestAnimationFrame(function () {
          uo.call(e, e.getNormalizedCellSelection()),
            Ie.call(
              e,
              e._domNodes.cellSelectionBorderNode,
              e.getNormalizedCellSelection()
            );
        })),
      lo.call(
        this,
        this._domNodes.componentNode[t + "Properties"].pointerPositionPx
      ),
      Ki.call(this, "eventAreaNode", "mousemove"),
      Ki.call(this, "eventAreaNode", "mouseleave"),
      Fi.call(this),
      this.keys.resume();
  }
  function Gi() {
    window.getSelection
      ? window.getSelection().removeAllRanges()
      : document.selection && document.selection.empty();
  }
  function Xi() {
    F(document.body, { "user-select": "none" }),
      F(document.documentElement, { "user-select": "none" });
  }
  function Yi(t) {
    var e = 0,
      o = 0;
    return (
      t.x > this._wholeViewportWidth
        ? (e = t.x - this._wholeViewportWidth)
        : t.x < vt.call(this) && (e = -(vt.call(this) - t.x)),
      t.y > this._wholeViewportHeight
        ? (o = t.y - this._wholeViewportHeight)
        : t.y < mt.call(this) && (o = -(mt.call(this) - t.y)),
      { x: e, y: o }
    );
  }
  function ji(t) {
    void 0 === t && (t = "xy");
    var e = this._edgeOffsetX,
      o = this._edgeOffsetY;
    this._edgeOffsetX < -30 ? (e = -30) : this._edgeOffsetX > 30 && (e = 30),
      this._edgeOffsetY < -30 ? (o = -30) : this._edgeOffsetY > 30 && (o = 30),
      0 != this._edgeOffsetX &&
        "y" != t &&
        (this._domNodes.scrollAreaNode.scrollLeft += e),
      0 != this._edgeOffsetY &&
        "x" != t &&
        (this._domNodes.scrollAreaNode.scrollTop += o),
      (this._domNodes.componentNode._edgeDetectTimeout = setTimeout(
        this._domNodes.componentNode._edgeDetectFunction,
        50
      ));
  }
  function Ui(t) {
    void 0 === t && (t = "xy"),
      (this._edgeOffsetX = 0),
      (this._edgeOffsetY = 0),
      t &&
        ((this._domNodes.componentNode._edgeDetectFunction = ji.bind(this, t)),
        (this._domNodes.componentNode._edgeDetectTimeout = setTimeout(
          this._domNodes.componentNode._edgeDetectFunction,
          50
        )));
  }
  function qi(t) {
    if ((void 0 === t && (t = null), null == t))
      return (
        (this._domNodes.eventAreaNode.style.cursor = ""),
        void (this._domNodes.eventAreaNode._cursorState = null)
      );
    t in L &&
      this._domNodes.eventAreaNode._cursorState != L[t] &&
      ((this._domNodes.eventAreaNode.style.cursor = L[t]),
      (this._domNodes.eventAreaNode._cursorState = L[t]));
  }
  function Zi() {
    var t = this;
    null != this._hoverArea &&
      this._domNodes.componentNode.classList.remove(
        "dgxl-hover-" + this._hoverArea
      ),
      "colHeaderEdge" == this._hoverArea &&
        requestAnimationFrame(function () {
          so.call(t);
        }),
      (this._hoverArea = null);
  }
  function Ji(t, e, o) {
    var i = this;
    t in Ti &&
      (("allow" + P(t) in this && !this["allow" + P(t)]) ||
        (Gi.call(this),
        Xi.call(this),
        this.keys.suspend(),
        this._isEditorOpen && this.closeEditor(),
        (this._domNodes.componentNode[t + "Properties"] = G(o)),
        (this._domNodes.componentNode[t + "Flags"] = { hasMoved: !1 }),
        t + "MoveFunc" in this._domNodes.componentNode ||
          (this._domNodes.componentNode[t + "MoveFunc"] = function (e) {
            if (
              (void 0 === e && (e = null),
              this._domNodes.componentNode[t + "Flags"].hasMoved ||
                (Ui.call(this, Ti[t].edgeDetection),
                Ti[t].handler.start.call(
                  this,
                  e,
                  this._domNodes.componentNode[t + "Properties"]
                ),
                (this._domNodes.componentNode[t + "Flags"].hasMoved = !0)),
              null == e)
            )
              var o =
                this._domNodes.componentNode[t + "Properties"]
                  .pointerPositionPx;
            else o = Ii.call(this, e.clientX, e.clientY);
            this._pointerPositionPx = o;
            var i = Ge.call(
              this,
              this._pointerPositionPx.x - vt.call(this),
              this._pointerPositionPx.y - mt.call(this)
            );
            (this._domNodes.componentNode[t + "Properties"].pointerPositionPx =
              o),
              (this._domNodes.componentNode[t + "Properties"].pointerPosition =
                i),
              Ti[t].handler.move.call(
                this,
                e,
                this._domNodes.componentNode[t + "Properties"]
              );
            var s = Yi.call(this, o);
            (this._edgeOffsetX = s.x), (this._edgeOffsetY = s.y);
          }.bind(this)),
        t + "EndFunc" in this._domNodes.componentNode ||
          (this._domNodes.componentNode[t + "EndFunc"] = function (e) {
            Wi.call(this, t),
              Ti[t].handler.release.call(
                this,
                e,
                this._domNodes.componentNode[t + "Properties"]
              ),
              this._domNodes.componentNode[t + "Flags"].hasMoved &&
                Ti[t].handler.end.call(
                  this,
                  e,
                  this._domNodes.componentNode[t + "Properties"]
                ),
              delete this._domNodes.componentNode[t + "Properties"];
          }.bind(this)),
        oi.call(this, "eventAreaNode", "mousemove"),
        oi.call(this, "eventAreaNode", "mouseleave"),
        Zi.call(this),
        qi.call(this, t),
        (this._currentDragAction = t),
        this._domNodes.componentNode.classList.add("dgxl-action-" + t),
        ("colSelect" != t && "rowSelect" != t && "cellSelect" != t) ||
          ((this._domNodes.cellSelectionBorderNode._hidden = !0),
          (this._domNodes.fillHandleNode._hidden = !0),
          requestAnimationFrame(function () {
            uo.call(i, i.getNormalizedCellSelection()),
              Ie.call(
                i,
                i._domNodes.cellSelectionBorderNode,
                i.getNormalizedCellSelection()
              );
          })),
        Ti[t].handler.prepare.call(
          this,
          e,
          this._domNodes.componentNode[t + "Properties"]
        ),
        document.addEventListener(
          "mousemove",
          this._domNodes.componentNode[t + "MoveFunc"]
        ),
        document.addEventListener(
          "mouseup",
          this._domNodes.componentNode[t + "EndFunc"]
        )));
  }
  function Qi(t, e) {
    3 != t.which && Ji.call(this, "colResize", t, e);
  }
  function $i(t, e) {
    3 != t.which && Ji.call(this, "colMove", t, e);
  }
  function ts(t, e) {
    (3 == t.which && Ue(this._pointerPosition.x, this.getColSelection())) ||
      ("mouse" == e.pointer
        ? (t.shiftKey
            ? ni.call(this, e.coord)
            : this.selectCols(e.coord, !0, !1),
          Ji.call(this, "colSelect", t, e))
        : "touch" == e.pointer && this.selectCols(e.coord, !0, !1));
  }
  function es(t, e) {
    3 != t.which && Ji.call(this, "rowMove", t, e);
  }
  function os(t, e) {
    (3 == t.which && Ue(this._pointerPosition.y, this.getRowSelection())) ||
      ("mouse" == e.pointer
        ? (t.shiftKey
            ? ri.call(this, e.coord)
            : this.selectRows(e.coord, !0, !1),
          Ji.call(this, "rowSelect", t, e))
        : "touch" == e.pointer && this.selectRows(e.coord, !0, !1));
  }
  function is(t, e) {
    3 != t.which && Ji.call(this, "cellFill", t, e);
  }
  function ss(t) {
    for (var e = [], o = 0; o < t.length; o++)
      "string" == typeof t[o]
        ? !(t[o] in this._contextMenuTouchItemPresets) ||
          ("include" in this._contextMenuTouchItemPresets[t[o]] &&
            !this._contextMenuTouchItemPresets[t[o]].include.call(this)) ||
          e.push(this._contextMenuTouchItemPresets[t[o]])
        : e.push(t[o]);
    return e;
  }
  function ls(t, e) {
    (void 0 === t && (t = {}),
    (t.contextMenuTouch = this.constructor.contextMenuTouch),
    (t.items = ss.call(this, this.contextMenuTouchItems)),
    t.items.length) &&
      this.events.dispatch("beforecontextmenutouchopen", t) &&
      (this.constructor.contextMenuTouch.open(
        this,
        t.items,
        t.snapPointX,
        t.snapPointY1,
        t.snapPointY2,
        this._domNodes.componentNode._handleContextMenuTouchItemSelect,
        this._domNodes.componentNode._handleContextMenuTouchClose
      ),
      Go.call(this),
      this.events.dispatch("contextmenutouchopen", t));
  }
  function ns(t, e) {
    if (3 != t.which || !Ue(this._pointerPosition, this.getCellSelection()))
      if ("mouse" == e.pointer)
        t.shiftKey
          ? li.call(this, e.cellCoords)
          : this.setCellCursorPosition(e.cellCoords, !0, !1),
          Ji.call(this, "cellSelect", t, e);
      else if ("touch" == e.pointer)
        if (Ue(e.cellCoords, this.getCellSelection()))
          if (this.constructor.contextMenuTouch.isOpen())
            this.constructor.contextMenuTouch.close();
          else {
            var o =
                window.scrollX +
                this._domNodes.componentNode.getBoundingClientRect().left,
              i =
                window.scrollY +
                this._domNodes.componentNode.getBoundingClientRect().top,
              s = Re.call(this, this.getCellSelection()),
              l = Ae.call(this, this.getCellSelection());
            o += s.offset + s.size / 2;
            var n = (i += l.offset) + l.size,
              r = {
                snapPointX: Math.round(o),
                snapPointY1: Math.round(i),
                snapPointY2: Math.round(n),
              };
            ls.call(this, r, t);
          }
        else this.setCellCursorPosition(e.cellCoords, !0, !1);
  }
  function rs(t) {
    this._pointerPositionPx = Ii.call(
      this,
      t.changedTouches[t.changedTouches.length - 1].clientX || t.clientX,
      t.changedTouches[t.changedTouches.length - 1].clientY || t.clientY
    );
    var e = eo.call(this, this._pointerPositionPx, "touch");
    null != e &&
      ((e.properties.pointer = "touch"),
      "cell" == e.name
        ? ns.call(this, t, e.properties)
        : "colHeader" == e.name
        ? ts.call(this, t, e.properties)
        : "rowHeader" == e.name
        ? os.call(this, t, e.properties)
        : "headerJoint" == e.name && Di.call(this, t, e.properties));
  }
  function hs(t) {
    if (this._isIOS) rs.call(this, t);
    else {
      this._pointerPositionPx = Ii.call(this, t.clientX, t.clientY);
      var e = eo.call(this, this._pointerPositionPx);
      (this._domNodes.componentNode._initialMouseHitArea = G(e)),
        null != e &&
          ((e.properties.pointer = "mouse"),
          "headerJoint" == e.name
            ? Di.call(this, t, e.properties)
            : "colHeaderEdge" == e.name
            ? Qi.call(this, t, e.properties)
            : "selectedColHeader" == e.name
            ? $i.call(this, t, e.properties)
            : "colHeader" == e.name
            ? ts.call(this, t, e.properties)
            : "selectedRowHeader" == e.name
            ? es.call(this, t, e.properties)
            : "rowHeader" == e.name
            ? os.call(this, t, e.properties)
            : "fillHandle" == e.name
            ? is.call(this, t, e.properties)
            : "cell" == e.name && ns.call(this, t, e.properties));
    }
  }
  function cs(t) {
    this._domNodes.componentNode._touchStartFired
      ? (this._domNodes.componentNode._touchStartFired = !1)
      : hs.call(this, t);
  }
  function ds(t) {
    Zi.call(this);
  }
  function as(t) {
    (this._pointerPositionPx = Ii.call(this, t.clientX, t.clientY)),
      lo.call(this, this._pointerPositionPx),
      (this._pointerPosition = Ge.call(
        this,
        this._pointerPositionPx.x - vt.call(this),
        this._pointerPositionPx.y - mt.call(this)
      ));
  }
  function us(t) {
    var e = this;
    this._isIOS &&
      F(document.body, {
        "user-select": "",
        "touch-callout": "",
        "user-drag": "",
      }),
      setTimeout(function () {
        Ki.call(e, "eventAreaNode", "mousemove");
      }, 50),
      Ki.call(this, "eventAreaNode", "mousedown"),
      Ki.call(this, "eventAreaNode", "dblclick"),
      oi.call(this, "eventAreaNode", "touchend_passive"),
      "_longTouchTimeout" in this._domNodes.componentNode &&
        (clearTimeout(this._domNodes.componentNode._longTouchTimeout),
        (this._domNodes.componentNode._longTouchTimeout = null)),
      this._domNodes.componentNode._longTouchTriggered
        ? (this._domNodes.componentNode._longTouchTriggered = !1)
        : this._domNodes.componentNode._hasScrolled
        ? (this._domNodes.componentNode._hasScrolled = !1)
        : rs.call(this, t);
  }
  function ps(t) {
    this._pointerPositionPx = Ii.call(
      this,
      t.changedTouches[t.changedTouches.length - 1].clientX,
      t.changedTouches[t.changedTouches.length - 1].clientY
    );
    var e = eo.call(this, this._pointerPositionPx, "touch");
    if (null != e) {
      e.properties.pointer = "touch";
      var o =
          window.scrollX +
          this._domNodes.componentNode.getBoundingClientRect().left,
        i =
          window.scrollY +
          this._domNodes.componentNode.getBoundingClientRect().top;
      if ("cell" == e.name) {
        ns.call(this, t, e.properties);
        var s = Re.call(this, this.getCellSelection()),
          l = Ae.call(this, this.getCellSelection());
        (o += s.offset + s.size / 2), (i += l.offset);
      } else if (
        "selectedColHeader" == e.name ||
        "colHeader" == e.name ||
        "colHeaderEdge" == e.name
      ) {
        ts.call(this, t, e.properties);
        (s = Re.call(this, this.getCellSelection())),
          (l = Ae.call(this, this.getCellSelection()));
        (o += s.offset + s.size / 2), (i += 0);
      } else {
        if ("selectedRowHeader" != e.name && "rowHeader" != e.name) return;
        os.call(this, t, e.properties);
        (s = Re.call(this, this.getCellSelection())),
          (l = Ae.call(this, this.getCellSelection()));
        (o += s.offset + s.size / 2), (i += l.offset);
      }
      var n = i + l.size,
        r = {
          snapPointX: Math.round(o),
          snapPointY1: Math.round(i),
          snapPointY2: Math.round(n),
        };
      ls.call(this, r, t);
    }
  }
  function _s(t) {
    var e = this;
    t.touches.length > 1 ||
      (this._isIOS &&
        F(document.body, {
          "user-select": "none",
          "touch-callout": "none",
          "user-drag": "none",
        }),
      (this._domNodes.componentNode._touchStartFired = !0),
      oi.call(this, "eventAreaNode", "mousemove"),
      oi.call(this, "eventAreaNode", "mousedown"),
      oi.call(this, "eventAreaNode", "dblclick"),
      Ki.call(this, "eventAreaNode", "touchend_passive"),
      (this._pointerPositionPx = Ii.call(
        this,
        t.changedTouches[0].clientX,
        t.changedTouches[0].clientY
      )),
      (this._pointerPosition = Ge.call(
        this,
        this._pointerPositionPx.x - vt.call(this),
        this._pointerPositionPx.y - mt.call(this)
      )),
      (this._domNodes.componentNode._hasScrolled = !1),
      (this._domNodes.componentNode._longTouchTriggered = !1),
      (this._domNodes.componentNode._longTouchTimeout = setTimeout(function () {
        e._domNodes.componentNode._hasScrolled ||
          ((e._domNodes.componentNode._longTouchTriggered = !0), ps.call(e, t));
      }, 500)));
  }
  var gs = {
    rowSelectTouch: {
      handler: {
        start: function (t, e) {
          (this._domNodes.selectionHeadHandleTouchNode.style.opacity = 0),
            (this._domNodes.selectionTailHandleTouchNode.style.opacity = 0),
            (this._colSelection = this.getNormalizedColSelection()),
            "head" == e.dragHandle
              ? (this._cellCursorPosition = { x: 0, y: this._rowSelection[1] })
              : "tail" == e.dragHandle &&
                (this._cellCursorPosition = { x: 0, y: this._rowSelection[0] });
        },
        move: function (t, e) {
          ri.call(this, e.pointerPosition.y);
        },
        end: function (t, e) {
          this.selectRows(this.getNormalizedRowSelection()),
            (this._domNodes.selectionHeadHandleTouchNode.style.opacity =
              this._domNodes.selectionHeadHandleTouchNode._opacity),
            (this._domNodes.selectionTailHandleTouchNode.style.opacity =
              this._domNodes.selectionTailHandleTouchNode._opacity);
        },
        prepare: function (t, e) {},
        release: function (t, e) {},
      },
      state: "isSelectingRowsTouch",
      edgeDetection: "y",
    },
    colSelectTouch: {
      handler: {
        start: function (t, e) {
          (this._domNodes.selectionHeadHandleTouchNode.style.opacity = 0),
            (this._domNodes.selectionTailHandleTouchNode.style.opacity = 0),
            (this._colSelection = this.getNormalizedColSelection()),
            "head" == e.dragHandle
              ? (this._cellCursorPosition = { x: this._colSelection[1], y: 0 })
              : "tail" == e.dragHandle &&
                (this._cellCursorPosition = { x: this._colSelection[0], y: 0 });
        },
        move: function (t, e) {
          ni.call(this, e.pointerPosition.x);
        },
        end: function (t, e) {
          this.selectCols(this.getNormalizedColSelection()),
            (this._domNodes.selectionHeadHandleTouchNode.style.opacity =
              this._domNodes.selectionHeadHandleTouchNode._opacity),
            (this._domNodes.selectionTailHandleTouchNode.style.opacity =
              this._domNodes.selectionTailHandleTouchNode._opacity);
        },
        prepare: function (t, e) {},
        release: function (t, e) {},
      },
      state: "isSelectingColsTouch",
      edgeDetection: "x",
    },
    cellSelectTouch: {
      handler: {
        start: function (t, e) {
          (this._domNodes.selectionHeadHandleTouchNode.style.opacity = 0),
            (this._domNodes.selectionTailHandleTouchNode.style.opacity = 0),
            (this._cellSelection = this.getNormalizedCellSelection()),
            "head" == e.dragHandle
              ? (this._cellCursorPosition = this._cellSelection[1])
              : "tail" == e.dragHandle &&
                (this._cellCursorPosition = this._cellSelection[0]);
        },
        move: function (t, e) {
          li.call(this, e.pointerPosition);
        },
        end: function (t, e) {
          this.selectCells(this.getNormalizedCellSelection()),
            (this._domNodes.selectionHeadHandleTouchNode.style.opacity =
              this._domNodes.selectionHeadHandleTouchNode._opacity),
            (this._domNodes.selectionTailHandleTouchNode.style.opacity =
              this._domNodes.selectionTailHandleTouchNode._opacity);
        },
        prepare: function (t, e) {},
        release: function (t, e) {},
      },
      state: "isSelectingCellsTouch",
      edgeDetection: "xy",
    },
    colResizeTouch: {
      handler: (function () {
        var t = function (t) {
          var e = t.pointerPositionPx.x - (t.pointerOffset - 1),
            o = this._wholeViewportWidth - 1;
          e < ee.call(this, t.startIndex, "viewport") + 32 - 5
            ? (e = ee.call(this, t.startIndex, "viewport") + 32 - 5)
            : e + 5 > o && (e = o - 4),
            e < vt.call(this) && (e = vt.call(this)),
            (t.guidePositionPx = e),
            (t.size = e - ee.call(this, t.startIndex, "viewport") + 4);
        };
        return {
          start: function (t, e) {},
          move: function (e, o) {
            var i = this;
            t.call(this, o),
              requestAnimationFrame(function () {
                Ci.call(i, o.guidePositionPx);
              });
          },
          end: function (t, e) {
            Ue(e.startIndex, this.getNormalizedColSelection())
              ? this.resizeCols(this.getNormalizedColSelection(), e.size)
              : this.resizeCols(e.startIndex, e.size);
          },
          prepare: function (e, o) {
            var i = this,
              s = o.pointerPositionPx.x;
            (s -= ee.call(this, o.pointerPosition.x, "viewport")),
              (s -=
                this.getColFromStore(this._colList[o.pointerPosition.x]).width -
                5);
            var l = o.pointerPosition.x;
            (o.pointerOffset = s),
              (o.startIndex = l),
              t.call(this, o),
              requestAnimationFrame(function () {
                Si.call(i, o.guidePositionPx);
              });
          },
          release: function (t, e) {
            var o = this;
            requestAnimationFrame(function () {
              bi.call(o, 100);
            });
          },
        };
      })(),
      state: "isResizingColsTouch",
      edgeDetection: "x",
    },
  };
  function fs(t) {
    var e = this;
    Bi.call(this),
      document.removeEventListener(
        "touchmove",
        this._domNodes.componentNode[t + "MoveFunc"],
        { passive: !1 }
      ),
      document.removeEventListener(
        "touchend",
        this._domNodes.componentNode[t + "EndFunc"],
        { passive: !1 }
      ),
      this._domNodes.componentNode.classList.remove("dgxl-action-" + t),
      (this._currentDragAction = null),
      ("cellSelectTouch" != t &&
        "colSelectTouch" != t &&
        "rowSelectTouch" != t &&
        "colResizeTouch" != t) ||
        ((this._domNodes.cellSelectionBorderNode._hidden = !1),
        (this._domNodes.fillHandleNode._hidden = !1),
        (this._domNodes.cellCursorNode._hidden = !1),
        requestAnimationFrame(function () {
          uo.call(e, e.getNormalizedCellSelection()),
            Ie.call(
              e,
              e._domNodes.cellSelectionBorderNode,
              e.getNormalizedCellSelection()
            ),
            ro.call(e, e._cellCursorPosition);
        })),
      Ki.call(this, "eventAreaNode", "mousemove"),
      Ki.call(this, "eventAreaNode", "mouseleave"),
      Fi.call(this),
      this.keys.resume();
  }
  function ms(t, e, o) {
    var i = this;
    t in gs &&
      (("allow" + P(t.slice(0, -5)) in this &&
        !this["allow" + P(t.slice(0, -5))]) ||
        (Gi.call(this),
        Xi.call(this),
        this.keys.suspend(),
        this._isEditorOpen && this.closeEditor(),
        (this._domNodes.componentNode[t + "Properties"] = G(o)),
        (this._domNodes.componentNode[t + "Flags"] = { hasMoved: !1 }),
        t + "MoveFunc" in this._domNodes.componentNode ||
          (this._domNodes.componentNode[t + "MoveFunc"] = function (e) {
            if (
              (void 0 === e && (e = null),
              this._domNodes.componentNode[t + "Flags"].hasMoved ||
                (Ui.call(this, gs[t].edgeDetection),
                gs[t].handler.start.call(
                  this,
                  e,
                  this._domNodes.componentNode[t + "Properties"]
                ),
                (this._domNodes.componentNode[t + "Flags"].hasMoved = !0)),
              null == e)
            )
              var o =
                this._domNodes.componentNode[t + "Properties"]
                  .pointerPositionPx;
            else
              o = Ii.call(
                this,
                e.changedTouches[0].clientX,
                e.changedTouches[0].clientY
              );
            this._pointerPositionPx = o;
            var i = Ge.call(
              this,
              this._pointerPositionPx.x - vt.call(this),
              this._pointerPositionPx.y - mt.call(this)
            );
            (this._domNodes.componentNode[t + "Properties"].pointerPositionPx =
              o),
              (this._domNodes.componentNode[t + "Properties"].pointerPosition =
                i),
              gs[t].handler.move.call(
                this,
                e,
                this._domNodes.componentNode[t + "Properties"]
              );
            var s = Yi.call(this, o);
            (this._edgeOffsetX = s.x),
              (this._edgeOffsetY = s.y),
              e.preventDefault();
          }.bind(this)),
        t + "EndFunc" in this._domNodes.componentNode ||
          (this._domNodes.componentNode[t + "EndFunc"] = function (e) {
            fs.call(this, t),
              gs[t].handler.release.call(
                this,
                e,
                this._domNodes.componentNode[t + "Properties"]
              ),
              this._domNodes.componentNode[t + "Flags"].hasMoved &&
                gs[t].handler.end.call(
                  this,
                  e,
                  this._domNodes.componentNode[t + "Properties"]
                ),
              delete this._domNodes.componentNode[t + "Properties"];
          }.bind(this)),
        oi.call(this, "eventAreaNode", "mousemove"),
        oi.call(this, "eventAreaNode", "mouseleave"),
        Zi.call(this),
        (this._currentDragAction = t),
        this._domNodes.componentNode.classList.add("dgxl-action-" + t),
        ("cellSelectTouch" != t &&
          "colSelectTouch" != t &&
          "rowSelectTouch" != t &&
          "colResizeTouch" != t) ||
          ((this._domNodes.cellSelectionBorderNode._hidden = !0),
          (this._domNodes.fillHandleNode._hidden = !0),
          (this._domNodes.cellCursorNode._hidden = !0),
          requestAnimationFrame(function () {
            uo.call(i, i.getNormalizedCellSelection()),
              Ie.call(
                i,
                i._domNodes.cellSelectionBorderNode,
                i.getNormalizedCellSelection()
              ),
              ro.call(i, i._cellCursorPosition);
          })),
        gs[t].handler.prepare.call(
          this,
          e,
          this._domNodes.componentNode[t + "Properties"]
        ),
        document.addEventListener(
          "touchmove",
          this._domNodes.componentNode[t + "MoveFunc"],
          { passive: !1 }
        ),
        document.addEventListener(
          "touchend",
          this._domNodes.componentNode[t + "EndFunc"],
          { passive: !1 }
        ),
        e.preventDefault()));
  }
  function vs(t) {
    t.touches.length > 1 ||
      ((this._pointerPositionPx = Ii.call(
        this,
        t.changedTouches[0].clientX,
        t.changedTouches[0].clientY
      )),
      null == this.getNormalizedColSelection()
        ? null == this.getNormalizedRowSelection()
          ? null == this.getNormalizedCellSelection() ||
            ms.call(this, "cellSelectTouch", t, {
              dragHandle: "head",
              pointerPositionPx: this._pointerPositionPx,
            })
          : ms.call(this, "rowSelectTouch", t, {
              dragHandle: "head",
              pointerPositionPx: this._pointerPositionPx,
            })
        : ms.call(this, "colSelectTouch", t, {
            dragHandle: "head",
            pointerPositionPx: this._pointerPositionPx,
          }));
  }
  function ys(t) {
    null == this.getNormalizedColSelection()
      ? null == this.getNormalizedRowSelection()
        ? null == this.getNormalizedCellSelection() ||
          ms.call(this, "cellSelectTouch", t, { dragHandle: "tail" })
        : ms.call(this, "rowSelectTouch", t, { dragHandle: "tail" })
      : ms.call(this, "colSelectTouch", t, { dragHandle: "tail" });
  }
  function xs(t) {
    if (!(t.touches.length > 1) && null != this.getColSelection()) {
      this._pointerPositionPx = Ii.call(
        this,
        t.changedTouches[0].clientX,
        t.changedTouches[0].clientY
      );
      var e = { x: this.getNormalizedColSelection()[1], y: -1 };
      ms.call(this, "colResizeTouch", t, {
        pointerPositionPx: this._pointerPositionPx,
        pointerPosition: e,
      });
    }
  }
  function Ns(t) {
    No.call(this);
  }
  function ws() {
    (this._domNodes.valueEditorNode._mode = "opened"),
      (this._domNodes.valueEditorNode.style.borderColor = this.getThemeSetting(
        "openedEditorBorderColor"
      )),
      Wo.call(this, "editOpened");
  }
  function Cs(t) {
    "inline" == this._domNodes.valueEditorNode._mode && ws.call(this);
  }
  function Ss() {
    this._domNodes.componentNode._listeners = {
      clipboardNode: {
        node: this._domNodes.clipboardNode,
        events: {
          copy: Ve.bind(this),
          cut: De.bind(this),
          keydown: Ke.bind(this),
          paste: $o.bind(this),
          select: ei.bind(this),
          focusIOS: Fe.bind(this),
        },
      },
      document: { node: document, events: { mousedown: si.bind(this) } },
      eventAreaNode: {
        node: this._domNodes.eventAreaNode,
        events: {
          contextmenu: Ei.bind(this),
          mousedown: cs.bind(this),
          mouseleave: ds.bind(this),
          mousemove: as.bind(this),
          dblclick: Vi.bind(this),
          touchstart_passive: _s.bind(this),
          touchend_passive: us.bind(this),
        },
      },
      scrollAreaNode: {
        node: this._domNodes.scrollAreaNode,
        events: {
          scroll: Pi.bind(this),
          scroll_debounced: kt(function (t) {
            Ai.call(this);
          }, 250).bind(this),
        },
      },
      selectionHeadHandleTouchNode: {
        node: this._domNodes.selectionHeadHandleTouchNode,
        events: { touchstart: vs.bind(this) },
      },
      selectionTailHandleTouchNode: {
        node: this._domNodes.selectionTailHandleTouchNode,
        events: { touchstart: ys.bind(this) },
      },
      colResizeHandleTouchNode: {
        node: this._domNodes.colResizeHandleTouchNode,
        events: { touchstart: xs.bind(this) },
      },
      valueEditorNode: {
        node: this._domNodes.valueEditorNode,
        events: { input: Ns.bind(this), mousedown: Cs.bind(this) },
      },
    };
  }
  function bs() {
    (this._domNodes.componentNode.style.width = this._componentWidth + "px"),
      (this._domNodes.componentNode.style.height =
        this._componentHeight + "px"),
      (this._domNodes.viewportNode.style.width = this._componentWidth + "px"),
      (this._domNodes.viewportNode.style.height = this._componentHeight + "px"),
      (this._domNodes.headerBackgroundsNode.style.width =
        this._componentWidth + "px"),
      (this._domNodes.headerBackgroundsNode.style.height =
        this._componentHeight + "px"),
      (this._domNodes.cellBackgroundColorsNode.style.width =
        this._componentWidth + "px"),
      (this._domNodes.cellBackgroundColorsNode.style.height =
        this._componentHeight + "px"),
      (this._domNodes.gridLinesNode.style.width = this._componentWidth + "px"),
      (this._domNodes.gridLinesNode.style.height =
        this._componentHeight + "px"),
      (this._domNodes.cellValuesNode.style.width = this._componentWidth + "px"),
      (this._domNodes.cellValuesNode.style.height =
        this._componentHeight + "px"),
      "outerLinesNode" in this._domNodes &&
        ((this._domNodes.outerLinesNode.style.width =
          this._componentWidth + "px"),
        (this._domNodes.outerLinesNode.style.height =
          this._componentHeight + "px"));
    for (var t = 0; t < this._domNodes.cellValuesNode.children.length; t++)
      this._domNodes.cellValuesNode.children[t].style.height =
        this._componentHeight + "px";
    (this._domNodes.rowLinesNode.style.width = this._componentWidth + "px"),
      (this._domNodes.colLinesNode.style.height = this._componentHeight + "px"),
      Hs.call(this),
      (this._domNodes.cellValuesNode.firstChild.style.height =
        this._wholeViewportHeight + "px"),
      (this._domNodes.cellValuesNode.firstChild.lastChild.style.height =
        this._wholeViewportHeight - mt.call(this) + "px");
    for (t = 0; t < this._colStore.length; t++)
      this._colStore[t].node &&
        ((this._colStore[t].node.style.height =
          this._wholeViewportHeight + "px"),
        (this._colStore[t].node.lastChild.style.height =
          this._wholeViewportHeight - mt.call(this) + "px"));
    (this._domNodes.colHeaderBackgroundNode.style.width =
      this._componentWidth + "px"),
      (this._domNodes.rowHeaderBackgroundNode.style.height =
        this._componentHeight + "px"),
      (this._domNodes.scrollAreaNode.style.width = this._componentWidth + "px"),
      (this._domNodes.scrollAreaNode.style.height =
        this._componentHeight + "px"),
      (this._domNodes.scrollSurfaceNode.style.width = this._scrollWidth + "px"),
      (this._domNodes.scrollSurfaceNode.style.height =
        this._scrollHeight + "px"),
      Wt.call(this);
  }
  var Hs = function () {
    var t = Math.ceil(this._outerViewportHeight / this._actualRowHeight),
      e = this._domNodes.rowLinesNode.children.length - this.showColHeaders;
    if (t > e) {
      for (
        var o = mt.call(this) + e * this._actualRowHeight, i = B(), s = 0;
        s < t - e;
        s++
      ) {
        var l = K("div", {
            class: "dgxl-rowLine",
            style: {
              position: "absolute",
              left: 0,
              right: 0,
              height: 0,
              "border-bottom": "thin solid #555",
              top: o + "px",
            },
          }),
          n = K("div", {
            class: "dgxl-rowLineHeaderTip",
            style: {
              position: "absolute",
              left: 0,
              top: 0,
              width: vt.call(this) + 1 + "px",
              "border-bottom": "thin solid #000",
            },
          });
        l.appendChild(n), i.appendChild(l), (o += this._actualRowHeight);
      }
      this._domNodes.rowLinesNode.appendChild(i);
    } else
      for (
        ;
        this._domNodes.rowLinesNode.children.length - this.showColHeaders > t;

      )
        this._domNodes.rowLinesNode.removeChild(
          this._domNodes.rowLinesNode.lastChild
        );
  };
  function Ts() {
    for (
      var t = mt.call(this), e = 0;
      e < this._domNodes.rowLinesNode.children.length;
      e++
    )
      (this._domNodes.rowLinesNode.children[e].style.top = t + "px"),
        (t += this._actualRowHeight);
  }
  function Ls(t, e) {
    void 0 === t && (t = {}),
      this.constructor.contextMenu.isOpen() &&
        this.constructor.contextMenu.close();
    var o = this._actualRowHeight;
    Pt.call(this),
      bs.call(this),
      zt.call(this, this._viewportPosition.x),
      It.call(this, this._viewportPosition.y),
      o != this._actionRowHeight && Ts.call(this),
      Ho.call(this),
      this.events.dispatch("containerresize", t);
  }
  function Ps(t, e) {
    var o = this._actualRowHeight;
    Pt.call(this),
      bs.call(this),
      It.call(this, this._viewportPosition.y),
      So.call(this),
      o != this._actualRowHeight && Ts.call(this);
  }
  function ks(t) {
    t.contextMenu.close(),
      t.item.method.call(this),
      Go.call(this),
      this.events.dispatch("contextmenuitemselect", t);
  }
  function Ms() {
    Wo.call(this, "traverseSingleCell");
  }
  function Rs() {
    Wo.call(this, "traverseMultiCell");
  }
  function As(t) {
    void 0 === t && (t = {}),
      t.contextMenu.execClose(),
      this.events.dispatch("contextmenuclose", t),
      this._isActive &&
        (Go.call(this), Le.call(this) ? Ms.call(this) : Rs.call(this));
  }
  function Is(t) {
    var e = this;
    t.contextMenuTouch.close(),
      t.item.method.call(this),
      setTimeout(function () {
        Go.call(e);
      }, 0),
      this.events.dispatch("contextmenutouchitemselect", t);
  }
  function zs(t, e) {
    var o = this;
    void 0 === t && (t = {}),
      t.contextMenuTouch.execClose(),
      this.events.dispatch("contextmenutouchclose", t),
      this._isIOS &&
        setTimeout(function () {
          o._domNodes.clipboardNode.blur();
        }, 250);
  }
  function Os() {
    Es.call(this),
      Vs.call(this),
      Ds.call(this),
      Fs.call(this),
      Bs.call(this),
      Ws.call(this),
      Ks.call(this);
  }
  function Es() {
    (this._domNodes.componentNode._handleContextMenuItemSelect = ks.bind(this)),
      (this._domNodes.componentNode._handleContextMenuClose = As.bind(this)),
      (this._domNodes.componentNode._handleContextMenuTouchItemSelect =
        Is.bind(this)),
      (this._domNodes.componentNode._handleContextMenuTouchClose =
        zs.bind(this));
  }
  function Vs() {
    (this._domNodes.containerNode._resizeSensor.onResize = Ls.bind(this)),
      (this._domNodes.textMeterNode._resizeSensor.onResize = Ps.bind(this));
  }
  function Ds() {
    Ki.call(this, "scrollAreaNode", "scroll"),
      Ki.call(this, "scrollAreaNode", "scroll_debounced"),
      Ki.call(this, "eventAreaNode", "mousedown"),
      Ki.call(this, "eventAreaNode", "mousemove"),
      Ki.call(this, "eventAreaNode", "mouseleave"),
      Ki.call(this, "eventAreaNode", "dblclick");
  }
  function Fs() {
    Ki.call(this, "eventAreaNode", "touchstart_passive"),
      Ki.call(this, "selectionHeadHandleTouchNode", "touchstart"),
      Ki.call(this, "selectionTailHandleTouchNode", "touchstart"),
      Ki.call(this, "colResizeHandleTouchNode", "touchstart");
  }
  function Ks() {
    Ki.call(this, "valueEditorNode", "input");
  }
  function Bs() {
    Ki.call(this, "eventAreaNode", "contextmenu");
  }
  function Ws() {
    Ki.call(this, "clipboardNode", "copy"),
      Ki.call(this, "clipboardNode", "cut"),
      Ki.call(this, "clipboardNode", "paste"),
      Ki.call(this, "clipboardNode", "select"),
      Ki.call(this, "clipboardNode", "keydown"),
      this._isIOS && Ki.call(this, "clipboardNode", "focusIOS");
  }
  function Gs() {
    var t = this;
    (this._domNodes.containerNode._resizeSensor = new Mt(
      this._domNodes.containerNode,
      this
    )),
      (this._domNodes.textMeterNode._resizeSensor = new Mt(
        this._domNodes.textMeterNode,
        this
      )),
      It.call(this, this._viewportPosition.y),
      zt.call(this, this._viewportPosition.x),
      Vt.call(this),
      ve.call(this),
      Ss.call(this),
      Os.call(this),
      this.instantActivate && this.setCellCursorPosition({ x: 0, y: 0 }),
      bo.call(this),
      setTimeout(function () {
        t.events.dispatch("ready", {});
      }, 0);
  }
  function Xs(t, e) {
    var o = this;
    void 0 === t && (t = null),
      void 0 === e && (e = {}),
      (this._containerId = t),
      (this._componentId = this.constructor.instances.length),
      D.call(this, e),
      "loading" == document.readyState
        ? document.addEventListener("DOMContentLoaded", function () {
            it.call(o);
          })
        : it.call(this),
      "complete" == document.readyState
        ? (Pt.call(this), Gs.call(this))
        : window.addEventListener("load", function () {
            Pt.call(o), Gs.call(o);
          }),
      this.constructor.instances.push(this);
  }
  function Ys(t) {
    void 0 === t && (t = null), null != t && this._setCellColors(t, null);
  }
  function js(t, e, o, i) {
    for (var s = 0; s < t.length; s++)
      for (var l = 0; l < e.length; l++)
        void 0 !== o[s][l] &&
          (this._cellStore[t[s] - 1][e[l] - 1].color = o[s][l]);
    Ho.call(this);
  }
  function Us(t, e, o, i, s) {
    void 0 === i && (i = !0), void 0 === s && (s = null);
    var l = Do.call(this),
      n = null,
      r = [],
      h = function (t, e, o, i, s) {
        if (
          (void 0 === i && (i = null),
          void 0 === s && (s = null),
          this.events.dispatch("_beforecellcolorchange", {
            rowIds: t,
            colIds: e,
            changes: o,
          }))
        ) {
          qo.call(this),
            null != i && i.call(this),
            null != s && (n = Do.call(this));
          var l = 0,
            h = function () {
              var i = performance.now(),
                n = [],
                c = e,
                d = [];
              if (null != s)
                do {
                  n.push(t[l]), d.push(o[l]);
                  for (var a = [], u = 0; u < c.length; u++)
                    a.push(this._cellStore[t[l] - 1][c[u] - 1].color || null);
                  r.push(a), l++;
                } while (l <= t.length - 1 && performance.now() - i < 25);
              else
                do {
                  n.push(t[l]), d.push(o[l]), l++;
                } while (l <= t.length - 1 && performance.now() - i < 25);
              js.call(this, n, c, d),
                l < t.length - 1
                  ? setTimeout(h, 75)
                  : (this.events.dispatch("_cellcolorchange", {
                      rowIds: t,
                      colIds: e,
                      changes: o,
                    }),
                    null != s && s.call(this));
            }.bind(this);
          h();
        }
      };
    if (i)
      var c = function () {
        this.undoManager.add({
          desc: "setCellColors",
          undo: function () {
            h.call(this, t, e, r, function () {
              Uo.call(this, l);
            });
          },
          redo: function () {
            h.call(this, t, e, o, function () {
              Uo.call(this, n);
            });
          },
        });
      };
    else c = null;
    h.call(this, t, e, o, s, c);
  }
  function qs(t, e, o, i) {
    if (
      (void 0 === t && (t = null),
      void 0 === e && (e = null),
      void 0 === o && (o = !1),
      void 0 === i && (i = !1),
      null != t &&
        (Lo(t) &&
          (t = [
            { x: t.x, y: t.y },
            { x: t.x, y: t.y },
          ]),
        Po(t)))
    ) {
      (t = Io.call(this, t)), R(e) || (e = To(t, e));
      var s = zo.call(this, t, e, o),
        l = i
          ? function () {
              var t = [
                {
                  x: this._colList.indexOf(s.colIds[0]),
                  y: this._rowList.indexOf(s.rowIds[0]),
                },
                {
                  x: this._colList.indexOf(s.colIds[s.colIds.length - 1]),
                  y: this._rowList.indexOf(s.rowIds[s.rowIds.length - 1]),
                },
              ];
              this.selectCells(t);
            }
          : null;
      Us.call(this, s.rowIds, s.colIds, s.values, !0, l);
    }
  }
  function Zs(t) {
    void 0 === t && (t = null),
      null != t && this.setCellValues(t, null, !1, !1);
  }
  function Js(t, e, o) {
    ze.call(this, "fill", null);
    for (
      var i = this.getCellRangeData(t), s = Me(t), l = [], n = [], r = s[0].x;
      r <= s[1].x;
      r++
    )
      n.push(this._colList[r]);
    for (var h = s[0].y; h <= s[1].y; h++) l.push(this._rowList[h]);
    var c = [];
    if ("right" == e)
      for (var d = 0; d < i.length; d++) c.push({ series: i[d] });
    else if ("left" == e)
      for (d = 0; d < i.length; d++) c.push({ series: i[d].reverse() });
    else if ("down" == e)
      for (r = 0; r < i[0].length; r++) {
        var a = [];
        for (h = 0; h < i.length; h++) a.push(i[h][r]);
        c.push({ series: a });
      }
    else if ("up" == e)
      for (r = 0; r < i[0].length; r++) {
        for (a = [], h = 0; h < i.length; h++) a.push(i[h][r]);
        c.push({ series: a.reverse() });
      }
    if ((Qs(c), "right" == e))
      var u = [
        { x: s[1].x + 1, y: s[0].y },
        { x: Math.min(this._colList.length - 1, s[1].x + o), y: s[1].y },
      ];
    else if ("left" == e)
      u = [
        { x: Math.max(0, s[0].x - o), y: s[0].y },
        { x: s[0].x - 1, y: s[1].y },
      ];
    else if ("down" == e)
      u = [
        { x: s[0].x, y: s[1].y + 1 },
        { x: s[1].x, y: Math.min(this._rowList.length - 1, s[1].y + o) },
      ];
    else if ("up" == e)
      u = [
        { x: s[0].x, y: Math.max(0, s[0].y - o) },
        { x: s[1].x, y: s[0].y - 1 },
      ];
    var p = u[1].y - u[0].y + 1,
      _ = u[1].x - u[0].x + 1,
      g = [];
    if ("right" == e)
      for (h = 0; h < p; h++) {
        g.push([]);
        for (r = 0; r < _; r++) {
          var f = 1 + Math.floor(r / c[h].groups.length),
            m = r % c[h].groups.length;
          if (A(c[h].groups[m])) {
            var v = m - c[h].groups[m].startIndex + c[h].groups[m].size * f,
              y = c[h].groups[m].base + v * c[h].groups[m].increment;
            (y = Math.round(100 * y) / 100), g[h].push(y);
          } else g[h].push(c[h].groups[m]);
        }
      }
    else if ("left" == e)
      for (h = 0; h < p; h++) {
        g.push([]);
        for (r = 0; r < _; r++) {
          (f = 1 + Math.floor(r / c[h].groups.length)),
            (m = r % c[h].groups.length);
          if (A(c[h].groups[m])) {
            (v = m - c[h].groups[m].startIndex + c[h].groups[m].size * f),
              (y = c[h].groups[m].base + v * c[h].groups[m].increment);
            (y = Math.round(100 * y) / 100), g[h].unshift(y);
          } else g[h].unshift(c[h].groups[m]);
        }
      }
    else if ("down" == e)
      for (h = 0; h < p; h++) {
        g.push([]);
        for (r = 0; r < _; r++) {
          (f = 1 + Math.floor(h / c[r].groups.length)),
            (m = h % c[r].groups.length);
          if (A(c[r].groups[m])) {
            (v = m - c[r].groups[m].startIndex + c[r].groups[m].size * f),
              (y = c[r].groups[m].base + v * c[r].groups[m].increment);
            (y = Math.round(100 * y) / 100), g[h].push(y);
          } else g[h].push(c[r].groups[m]);
        }
      }
    else if ("up" == e)
      for (h = 0; h < p; h++) {
        g.unshift([]);
        for (r = 0; r < _; r++) {
          (f = 1 + Math.floor(h / c[r].groups.length)),
            (m = h % c[r].groups.length);
          if (A(c[r].groups[m])) {
            (v = m - c[r].groups[m].startIndex + c[r].groups[m].size * f),
              (y = c[r].groups[m].base + v * c[r].groups[m].increment);
            (y = Math.round((100 * y) / 100)), g[0].push(y);
          } else g[0].push(c[r].groups[m]);
        }
      }
    var x = zo.call(this, u, g, !1);
    if ("right" == e)
      var N = x.rowIdsToSelect,
        w = n.concat(x.colIdsToSelect);
    else if ("left" == e)
      (N = x.rowIdsToSelect), (w = x.colIdsToSelect.concat(n));
    else if ("down" == e)
      (N = l.concat(x.rowIdsToSelect)), (w = x.colIdsToSelect);
    else if ("up" == e)
      (N = x.rowIdsToSelect.concat(l)), (w = x.colIdsToSelect);
    Zo.call(this, x.rowIds, x.colIds, x.values, !0, function () {
      var e = [
        { x: this._colList.indexOf(w[0]), y: this._rowList.indexOf(N[0]) },
        {
          x: this._colList.indexOf(w[w.length - 1]),
          y: this._rowList.indexOf(N[N.length - 1]),
        },
      ];
      if (Ue(this._cellCursorPosition, t)) var o = null;
      else o = { x: e[0].x, y: e[0].y };
      jo.call(this, e, o);
    });
  }
  var Qs = function (t) {
    for (var e = 0; e < t.length; e++) t[e].groups = o(t[e].series);
    function o(t) {
      for (var e, o, s, l = [], n = null, r = 0; r < t.length; r++)
        (e =
          "" !== (s = t[r]) &&
          null !== s &&
          !isNaN(s) &&
          isFinite(s) &&
          Math.floor(s) === Number(s)
            ? "number"
            : "string"),
          null == n
            ? (o = [t[r]])
            : e == n
            ? o.push(t[r])
            : ("number" == n && o.length && (o = i(o, r - o.length)),
              Array.prototype.push.apply(l, o),
              (o = [t[r]])),
          (n = e);
      return (
        o.length &&
          ("number" == n && o.length && (o = i(o, r - o.length)),
          Array.prototype.push.apply(l, o)),
        l
      );
    }
    function i(t, e) {
      for (var o = null, i = null, s = 0; s < t.length - 1; s++) {
        if (((o = t[s + 1] - t[s]), s > 0 && o != i)) {
          o = null;
          break;
        }
        i = o;
      }
      if (null != o) {
        var l = {
            base: Number(t[0]),
            increment: o,
            startIndex: e,
            size: t.length,
          },
          n = [];
        for (s = 0; s < t.length; s++) n.push(l);
      }
      return n || t;
    }
  };
  function $s(t, e) {
    void 0 === e && (e = "document");
    var o = t;
    if ("document" == e) var i = { left: 0, right: this._colList.length - 1 };
    else if ("viewport" == e)
      i = {
        left: this._viewportPosition.x,
        right: this._viewportPosition.x + (this._colView.length - 1),
      };
    var s = o < i.left,
      l = o > i.right;
    return s && (o = i.left), l && (o = i.right), o;
  }
  function tl(t, e) {
    return (
      void 0 === e && (e = "document"),
      null == t ? null : [$s.call(this, t[0], e), $s.call(this, t[1], e)]
    );
  }
  function el(t, e) {
    qo.call(this);
    for (var o = 0; o < t.length; o++)
      (this.getColFromStore(t[o]).deleted = !0),
        this._colList.splice(this._colList.indexOf(t[o]), 1);
  }
  function ol(t, e) {
    void 0 === e && (e = null), qo.call(this);
    for (var o = [], i = this._colStore._lastId, s = 0; s < t; s++)
      i++,
        this._colStore.push({
          id: i,
          field: void 0,
          title: void 0,
          width: this.defaultColWidth,
          align: this.defaultColAlign,
          node: void 0,
        }),
        o.push(i);
    this._colStore._lastId = i;
    for (var l = 0; l < this._rowStore.length; l++)
      for (s = 0; s < o.length; s++)
        O.call(this, this._rowStore[l].id, o[s], null);
    if (e) n = this._colList.indexOf(e) + 1;
    else var n = 0;
    this._colList.splice.apply(this._colList, [n, 0].concat(o));
    for (s = 0; s < o.length; s++)
      Et.call(this, this._colList.indexOf(o[s]), o[s]);
    return o;
  }
  function il(t, e) {
    void 0 === e && (e = null), qo.call(this);
    for (var o = 0; o < t.length; o++)
      delete this.getColFromStore(t[o]).deleted;
    if (e) i = this._colList.indexOf(e) + 1;
    else var i = 0;
    this._colList.splice.apply(this._colList, [i, 0].concat(t));
  }
  function sl(t, e) {
    if (
      (void 0 === t && (t = !1),
      void 0 === e && (e = !1),
      t && this.showColHeaders)
    )
      for (var o = 0; o < this._colList.length; o++) {
        var i = this._colList[o],
          s = (h = this._colStore[i - 1]).node.firstChild.firstChild,
          l = Ot.call(this, o),
          n = this.colHeaderLabelFunction.call(this, o, i, h.field, h.title, l);
        s.innerHTML = String(n).replace(/\n/g, "↵").replace(/\t/g, "");
      }
    if (e && this.showColHeaders && this.showSortIndicator) {
      var r;
      for (o = 0; o < this._colList.length; o++) {
        i = this._colList[o];
        for (
          var h,
            c = (h = this._colStore[i - 1]).node.firstChild.lastChild,
            d = 0;
          d < this._sortState.length;
          d++
        )
          if (((r = !1), this._sortState[d][0] == i)) {
            "asc" == this._sortState[d][1]
              ? (c.textContent = "↑")
              : (c.textContent = "↓"),
              (r = !0);
            break;
          }
        r || (c.textContent = "");
      }
    }
    zt.call(this, this._viewportPosition.x),
      It.call(this, this._viewportPosition.y),
      Lt.call(this),
      bs.call(this),
      Ho.call(this),
      (k(b) in this && this[k(b)]) || Mi.call(this),
      this.events.dispatch("documentchange", {});
  }
  function ll(t, e, o, i) {
    void 0 === o && (o = !0), void 0 === i && (i = null);
    var s = { colIds: t };
    if (this.events.dispatch("beforecoldelete", s)) {
      var l,
        n = Do.call(this);
      if ((el.call(this, t), this._colList.length)) r = null;
      else var r = ol.call(this, 1);
      sl.call(this, !0),
        null != i && i.call(this),
        (l = Do.call(this)),
        o &&
          this.undoManager.add({
            desc: "deleteCols",
            undo: function () {
              il.call(this, t, e),
                null != r && el.call(this, r),
                sl.call(this, !0),
                Uo.call(this, n);
            },
            redo: function () {
              el.call(this, t),
                this._colList.length || il.call(this, r),
                sl.call(this, !0),
                Uo.call(this, l);
            },
          }),
        this.events.dispatch("coldelete", s);
    }
  }
  function nl(t) {
    if ((void 0 === t && (t = null), null != t)) {
      var e = Me(t);
      if (0 == (e = tl.call(this, e, "document"))[0]) var o = 0;
      else o = this._colList[e[0] - 1];
      for (var i = [], s = e[0]; s <= e[1]; s++) i.push(this._colList[s]);
      ll.call(this, i, o, !0, function () {
        Uo.call(this, this._prevSelection);
      });
    }
  }
  function rl(t, e, o, i) {
    void 0 === o && (o = !0), void 0 === i && (i = null);
    var s = { amount: t, targetId: e };
    if (this.events.dispatch("beforecolinsert", s)) {
      var l,
        n = Do.call(this),
        r = ol.call(this, t, e);
      sl.call(this, !0),
        null != i && i.call(this, r),
        (l = Do.call(this)),
        o &&
          this.undoManager.add({
            desc: "insertCols",
            undo: function () {
              el.call(this, r), sl.call(this, !0), Uo.call(this, n);
            },
            redo: function () {
              il.call(this, r, e), sl.call(this, !0), Uo.call(this, l);
            },
          }),
        (s.insertedIds = r),
        this.events.dispatch("colinsert", s);
    }
  }
  function hl(t) {
    M(t) || (t = [t, t]);
    var e = t[0],
      o = t[t.length - 1];
    return [this._colList.indexOf(e), this._colList.indexOf(o)];
  }
  function cl(t, e) {
    if (
      (void 0 === t && (t = 1),
      void 0 === e && (e = this._colList.length),
      0 == e)
    )
      var o = 0;
    else o = this._colList[Math.min(this._colList.length, e) - 1];
    rl.call(this, t, o, !0, function (t) {
      this.selectCols(hl.call(this, t));
    });
  }
  function dl(t, e) {
    void 0 === e && (e = null), qo.call(this);
    for (var o = 0; o < t.length; o++)
      this._colList.splice(this._colList.indexOf(t[o]), 1);
    if (e) i = this._colList.indexOf(e) + 1;
    else var i = 0;
    this._colList.splice.apply(this._colList, [i, 0].concat(t));
  }
  function al(t, e, o, i, s) {
    void 0 === i && (i = !0), void 0 === s && (s = null);
    var l = { colIds: t, targetId: o };
    if (this.events.dispatch("beforecolmove", l)) {
      var n,
        r = Do.call(this);
      dl.call(this, t, o),
        sl.call(this, !0),
        null != s && s.call(this),
        (n = Do.call(this)),
        i &&
          this.undoManager.add({
            desc: "moveCols",
            undo: function () {
              dl.call(this, t, e), sl.call(this, !0), Uo.call(this, r);
            },
            redo: function () {
              dl.call(this, t, o), sl.call(this, !0), Uo.call(this, n);
            },
          }),
        this.events.dispatch("colmove", l);
    }
  }
  function ul(t, e) {
    if (
      (void 0 === t && (t = null),
      void 0 === e && (e = null),
      null != t && null != e)
    ) {
      var o = Me(t);
      if (
        ((o = tl.call(this, o, "document")),
        !(e < 0 || (e >= o[0] && e <= o[1] + 1)))
      ) {
        if (0 == o[0]) var i = 0;
        else i = this._colList[o[0] - 1];
        if (0 == e) var s = 0;
        else s = this._colList[Math.min(this._colList.length, e) - 1];
        for (var l = [], n = o[0]; n <= o[1]; n++) l.push(this._colList[n]);
        al.call(this, l, i, s, !0, function () {
          this.selectCols(hl.call(this, l));
        });
      }
    }
  }
  function pl(t, e) {
    var o = this;
    requestAnimationFrame(function () {
      for (var i = 0; i < t.length; i++)
        null != o.getColFromStore(t[i]).node &&
          (o.getColFromStore(t[i]).node.style.width = e[i] + "px");
    });
  }
  function _l(t, e) {
    qo.call(this);
    for (var o = 0; o < t.length; o++)
      void 0 !== e[o] && (this._colStore[t[o] - 1].width = Math.max(e[o], 32));
    pl.call(this, t, e);
  }
  function gl(t, e, o, i) {
    void 0 === o && (o = !0), void 0 === i && (i = null);
    var s = { colIds: t, changeStore: e };
    if (this.events.dispatch("beforecolresize", s)) {
      for (var l, n = Do.call(this), r = [], h = 0; h < t.length; h++)
        r.push(this._colStore[t[h] - 1].width);
      _l.call(this, t, e),
        sl.call(this),
        null != i && i.call(this),
        (l = Do.call(this)),
        o &&
          this.undoManager.add({
            desc: "resizeCols",
            undo: function () {
              _l.call(this, t, r), sl.call(this), Uo.call(this, n);
            },
            redo: function () {
              _l.call(this, t, e), sl.call(this), Uo.call(this, l);
            },
          }),
        this.events.dispatch("colresize", s);
    }
  }
  function fl(t, e) {
    if (
      (void 0 === t && (t = null),
      void 0 === e && (e = null),
      null != t && null != e)
    ) {
      var o = Me(t);
      o = tl.call(this, o, "document");
      for (
        var i = [], s = [], l = Math.max(Math.round(e), 32), n = o[0];
        n <= o[1];
        n++
      )
        i.push(this._colList[n]), s.push(l);
      gl.call(this, i, s, this.undoableColResize);
    }
  }
  function ml(t) {
    if ((void 0 === t && (t = null), null != t)) {
      for (
        var e = Me(t),
          o = [],
          i = [],
          s = (e = tl.call(this, e, "document"))[0];
        s <= e[1];
        s++
      ) {
        o.push(this._colList[s]);
        for (var l = 0, n = 0; n < this._rowList.length; n++) {
          var r = this.getCellFromStore(
            this._rowList[n],
            this._colList[s]
          ).value;
          if (null != r) {
            var h = String(r).replace(/\n/g, "↵").replace(/\t/g, " "),
              c = this._textWidthMeterCanvasContext.measureText(h).width;
            c > l && (l = c);
          }
        }
        l += 2 * this.cellPadding;
        var d = Math.max(Math.round(l), 32);
        i.push(d);
      }
      gl.call(this, o, i, this.undoableColResize);
    }
  }
  function vl(t, e) {
    void 0 === e && (e = "document");
    var o = t;
    if ("document" == e) var i = { top: 0, bottom: this._rowList.length - 1 };
    else if ("viewport" == e)
      i = {
        top: this._viewportPosition.y,
        bottom: this._viewportPosition.y + (this._rowView.length - 1),
      };
    var s = o < i.top,
      l = o > i.bottom;
    return s && (o = i.top), l && (o = i.bottom), o;
  }
  function yl(t, e) {
    return (
      void 0 === e && (e = "document"),
      null == t ? null : [vl.call(this, t[0], e), vl.call(this, t[1], e)]
    );
  }
  function xl(t) {
    qo.call(this);
    for (var e = 0; e < t.length; e++)
      (this.getRowFromStore(t[e]).deleted = !0),
        this._rowList.splice(this._rowList.indexOf(t[e]), 1);
  }
  function Nl(t, e) {
    void 0 === e && (e = null), qo.call(this);
    for (var o = [], i = this._rowStore._lastId, s = 0; s < t; s++)
      i++, this._rowStore.push({ id: i, title: void 0 }), o.push(i);
    this._rowStore._lastId = i;
    for (var l = 0; l < this._colStore.length; l++)
      for (s = 0; s < o.length; s++)
        O.call(this, o[s], this._colStore[l].id, null);
    if (e) n = this._rowList.indexOf(e) + 1;
    else var n = 0;
    return this._rowList.splice.apply(this._rowList, [n, 0].concat(o)), o;
  }
  function wl(t, e) {
    void 0 === e && (e = null), qo.call(this);
    for (var o = 0; o < t.length; o++)
      delete this.getRowFromStore(t[o]).deleted;
    if (e) i = this._rowList.indexOf(e) + 1;
    else var i = 0;
    this._rowList.splice.apply(this._rowList, [i, 0].concat(t));
  }
  function Cl(t, e, o, i) {
    void 0 === o && (o = !0), void 0 === i && (i = null);
    var s = { rowIds: t };
    if (this.events.dispatch("beforerowdelete", s)) {
      var l,
        n = Do.call(this);
      if ((xl.call(this, t), this._rowList.length)) r = null;
      else var r = Nl.call(this, 1);
      sl.call(this),
        null != i && i.call(this),
        (l = Do.call(this)),
        o &&
          this.undoManager.add({
            desc: "deleteRows",
            undo: function () {
              wl.call(this, t, e),
                null != r && xl.call(this, r),
                sl.call(this),
                Uo.call(this, n);
            },
            redo: function () {
              xl.call(this, t),
                this._rowList.length || wl.call(this, r),
                sl.call(this),
                Uo.call(this, l);
            },
          }),
        this.events.dispatch("rowdelete", s);
    }
  }
  function Sl(t) {
    if ((void 0 === t && (t = null), null != t)) {
      var e = Me(t);
      if (0 == (e = yl.call(this, e, "document"))[0]) var o = 0;
      else o = this._rowList[e[0] - 1];
      for (var i = [], s = e[0]; s <= e[1]; s++) i.push(this._rowList[s]);
      Cl.call(this, i, o, !0, function () {
        Uo.call(this, this._prevSelection);
      });
    }
  }
  function bl(t, e, o, i) {
    void 0 === o && (o = !0), void 0 === i && (i = null);
    var s = { amount: t, targetId: e };
    if (this.events.dispatch("beforerowinsert", s)) {
      var l,
        n = Do.call(this),
        r = Nl.call(this, t, e);
      r &&
        (sl.call(this),
        null != i && i.call(this, r),
        (l = Do.call(this)),
        o &&
          this.undoManager.add({
            desc: "insertRows",
            undo: function () {
              xl.call(this, r), sl.call(this), Uo.call(this, n);
            },
            redo: function () {
              wl.call(this, r, e), sl.call(this), Uo.call(this, l);
            },
          }),
        (s.insertedIds = r),
        this.events.dispatch("rowinsert", s));
    }
  }
  function Hl(t) {
    var e = t[0],
      o = t[t.length - 1];
    return [this._rowList.indexOf(e), this._rowList.indexOf(o)];
  }
  function Tl(t, e) {
    if (
      (void 0 === t && (t = 1),
      void 0 === e && (e = this._rowList.length),
      0 == e)
    )
      var o = 0;
    else o = this._rowList[Math.min(this._rowList.length, e) - 1];
    bl.call(this, t, o, !0, function (t) {
      this.selectRows(Hl.call(this, t));
    });
  }
  function Ll(t, e) {
    void 0 === e && (e = null), qo.call(this);
    for (var o = 0; o < t.length; o++)
      this._rowList.splice(this._rowList.indexOf(t[o]), 1);
    if (e) i = this._rowList.indexOf(e) + 1;
    else var i = 0;
    this._rowList.splice.apply(this._rowList, [i, 0].concat(t));
  }
  function Pl(t, e, o, i, s) {
    void 0 === i && (i = !0), void 0 === s && (s = null);
    var l = { rowIds: t, targetId: o };
    if (this.events.dispatch("beforerowmove", l)) {
      var n,
        r = Do.call(this);
      Ll.call(this, t, o),
        sl.call(this),
        null != s && s.call(this),
        (n = Do.call(this)),
        i &&
          this.undoManager.add({
            desc: "moveRows",
            undo: function () {
              Ll.call(this, t, e), sl.call(this), Uo.call(this, r);
            },
            redo: function () {
              Ll.call(this, t, o), sl.call(this), Uo.call(this, n);
            },
          }),
        this.events.dispatch("rowmove", l);
    }
  }
  function kl(t, e) {
    if (
      (void 0 === t && (t = null),
      void 0 === e && (e = null),
      null != t && null != e)
    ) {
      var o = Me(t);
      if (
        ((o = yl.call(this, o, "document")),
        !(e < 0 || (e >= o[0] && e <= o[1] + 1)))
      ) {
        if (0 == o[0]) var i = 0;
        else i = this._rowList[o[0] - 1];
        if (0 == e) var s = 0;
        else s = this._rowList[Math.min(this._rowList.length, e) - 1];
        for (var l = [], n = o[0]; n <= o[1]; n++) l.push(this._rowList[n]);
        Pl.call(this, l, i, s, !0, function () {
          this.selectRows(Hl.call(this, l));
        });
      }
    }
  }
  function Ml() {
    if (!this._isActive) {
      for (var t = 0; t < this.constructor.instances.length; t++)
        this.constructor.instances[t] != this &&
          this.constructor.instances[t].deactivate();
      (this._isActive = !0),
        this._domNodes.componentNode.classList.add("dgxl-isActive"),
        this.deactivateOnClickOutside && Ki.call(this, "document", "mousedown"),
        null == this.getCellCursorPosition() &&
          this.setCellCursorPosition({ x: 0, y: 0 }),
        this.events.dispatch("activate", {});
    }
  }
  function Rl() {
    if (this._isActive) {
      if (
        ((this._isActive = !1),
        this._domNodes.componentNode.classList.remove("dgxl-isActive"),
        this._activeKeyActionSet)
      ) {
        for (
          var t = 0;
          t < this._keyActionSets[this._activeKeyActionSet].length;
          t++
        ) {
          var e = this._keyActionSets[this._activeKeyActionSet][t],
            o = this._keyActionPresets[e];
          this.keys.off(o.keys, o.action, o.repeat);
        }
        this._activeKeyActionSet = void 0;
      }
      this.deselectAll(), this.events.dispatch("deactivate", {});
    }
  }
  function Al() {
    return this._cellCursorPosition;
  }
  function Il(t, e, o) {
    if (
      (void 0 === t && (t = null),
      void 0 === e && (e = !0),
      void 0 === o && (o = !0),
      Lo.call(this, t) && null != t)
    ) {
      var i = { cellCursorPosition: ko.call(this, t, "document") };
      e
        ? jo.call(
            this,
            [
              { x: i.cellCursorPosition.x, y: i.cellCursorPosition.y },
              { x: i.cellCursorPosition.x, y: i.cellCursorPosition.y },
            ],
            i.cellCursorPosition,
            o
          )
        : jo.call(this, null, i.cellCursorPosition, o);
    }
  }
  function zl(t) {
    void 0 === t && (t = null),
      null != t &&
        null != this._cellCursorPosition &&
        this.setCellCursorPosition({
          x: this._cellCursorPosition.x + t.x,
          y: this._cellCursorPosition.y + t.y,
        });
  }
  function Ol(t) {
    if (
      (void 0 === t && (t = null),
      null != t && null != this._cellCursorPosition)
    ) {
      var e = !1;
      if (Le.call(this)) {
        var o = {
          x: this._cellCursorPosition.x + t.x,
          y: this._cellCursorPosition.y + t.y,
        };
        e = !0;
      } else {
        var i = this._cellCursorPosition.x + t.x,
          s = this._cellCursorPosition.y + t.y,
          l = this.getNormalizedCellSelection();
        i > l[1].x
          ? ((i = l[0].x), s < l[1].y ? s++ : (s = l[0].y))
          : i < l[0].x && ((i = l[1].x), s > l[0].y ? s-- : (s = l[1].y)),
          s > l[1].y
            ? ((s = l[0].y), i < l[1].x ? i++ : (i = l[0].x))
            : s < l[0].y && ((s = l[1].y), i > l[0].x ? i-- : (i = l[1].x));
        o = { x: i, y: s };
      }
      this.setCellCursorPosition(o, e);
    }
  }
  function El() {
    var t = this._cellCursorPosition.y - this._viewportPosition.y;
    t < 0 && (t = 0);
    var e = this._viewportPosition.y + (this._rowView.length - 1);
    this.setViewportPosition({ x: this._viewportPosition.x, y: e }),
      this.setCellCursorPosition(
        { x: this._cellCursorPosition.x, y: e + t },
        !0,
        !1
      );
  }
  function Vl() {
    if (0 != this._viewportPosition.y) {
      var t = this._cellCursorPosition.y - this._viewportPosition.y;
      t < 0 && (t = 0);
      for (
        var e = 0, o = this._viewportPosition.y;
        e < this._innerViewportHeight && -1 != o;

      )
        (e += this.rowHeight), o--;
      this.setViewportPosition({ x: this._viewportPosition.x, y: o + 1 }),
        this.setCellCursorPosition(
          { x: this._cellCursorPosition.x, y: o + 1 + t },
          !0,
          !1
        );
    }
  }
  function Dl() {
    null != this.getCellCursorPosition() &&
      this.setCellCursorPosition({
        x: this.getCellCursorPosition().x,
        y: this._rowList.length - 1,
      });
  }
  function Fl() {
    null != this.getCellCursorPosition() &&
      this.setCellCursorPosition({ x: this.getCellCursorPosition().x, y: 0 });
  }
  function Kl() {
    null != this.getCellCursorPosition() &&
      this.setCellCursorPosition({
        x: this._colList.length - 1,
        y: this._rowList.length - 1,
      });
  }
  function Bl() {
    null != this.getCellCursorPosition() &&
      this.setCellCursorPosition({ x: 0, y: 0 });
  }
  function Wl() {
    null != this.getCellCursorPosition() &&
      this.setCellCursorPosition({
        x: this._colList.length - 1,
        y: this.getCellCursorPosition().y,
      });
  }
  function Gl() {
    null != this.getCellCursorPosition() &&
      this.setCellCursorPosition({ x: 0, y: this.getCellCursorPosition().y });
  }
  function Xl() {
    var t = document.createElement("textArea");
    (t.value = " all"),
      t.setAttribute("readonly", !0),
      t.addEventListener(
        "copy",
        this._domNodes.componentNode._listeners.clipboardNode.events.copy
      ),
      document.body.appendChild(t);
    var e = document.createRange();
    e.selectNodeContents(t);
    var o = window.getSelection();
    o.removeAllRanges(),
      o.addRange(e),
      t.setSelectionRange(0, 999999),
      document.execCommand("copy"),
      document.body.removeChild(t);
  }
  function Yl() {
    if (null != this.getCellSelection())
      if (
        (Go.call(this, !0),
        (this._domNodes.clipboardNode._actualCommand = "copy"),
        this._isIOS)
      )
        Xl.call(this);
      else document.execCommand("copy");
  }
  function jl() {
    null != this.getCellSelection() &&
      (Go.call(this, !0),
      (this._domNodes.clipboardNode._actualCommand = "cut"),
      this._isIOS ? Xl.call(this) : document.execCommand("copy"));
  }
  function Ul() {
    var t = this;
    null != this.getCellSelection() &&
      (this.enableClipboardInteraction(),
      "clipboard" in navigator &&
      "function" == typeof navigator.clipboard.readText
        ? navigator.clipboard
            .readText()
            .then(function (e) {
              "" != e && Qo.call(t, { text: e }, null);
            })
            .catch(function (t) {})
        : this.isIE
        ? document.execCommand("paste")
        : alert("paste not available..."));
  }
  function ql(t, e) {
    var o = this._cellStore[t - 1][e - 1];
    return "parsedValue" in o ? o.parsedValue : null === o.value ? "" : o.value;
  }
  function Zl(t) {
    void 0 === t && (t = {});
    ke({}, t);
    for (var e = "", o = 0; o < this._rowList.length; o++) {
      for (var i = 0; i < this._colList.length; i++)
        (e += ql.call(this, this._rowList[o], this._colList[i])),
          i < this._colList.length - 1 && (e += ",");
      e += "\n";
    }
    Jl.call(this, e);
  }
  var Jl = function (t) {
    var e = new Blob([t], { type: "text/csv", name: "DataGridXLData.csv" });
    if (this._isIE) navigator.msSaveBlob(e, "DataGridXLData.csv");
    else {
      var o = K("a", {
        class: "dgxl-downloadLink",
        href: URL.createObjectURL(e),
        download: "DataGridXLData.csv",
      });
      (o.textContent = "Click here to download"),
        this._domNodes.componentNode.appendChild(o),
        o.click(),
        this._domNodes.componentNode.removeChild(o);
    }
  };
  function Ql(t) {
    void 0 === t && (t = {});
    var e = ke({ useColTitles: !1, whitespace: 2, includeDataField: !1 }, t);
    if (e.includeDataField) var o = (i = { data: [] }).data;
    else {
      var i;
      o = i = [];
    }
    if (e.useColTitles)
      for (var s = 0; s < this._rowList.length; s++) {
        o.push({});
        for (var l = 0; l < this._colList.length; l++) {
          var n = this.getColFromStore(this._colList[l]).title || "COL" + l;
          o[s][n] = ql.call(this, this._rowList[s], this._colList[l]);
        }
      }
    else
      for (s = 0; s < this._rowList.length; s++) {
        o.push([]);
        for (l = 0; l < this._colList.length; l++)
          o[s].push(ql.call(this, this._rowList[s], this._colList[l]));
      }
    var r = JSON.stringify(i, null, e.whitespace);
    $l.call(this, r);
  }
  var $l = function (t) {
    var e = new Blob([t], {
      type: "application/json",
      name: "DataGridXLData.json",
    });
    if (this._isIE) navigator.msSaveBlob(e, "DataGridXLData.json");
    else {
      var o = K("a", {
        class: "dgxl-downloadLink",
        href: URL.createObjectURL(e),
        download: "DataGridXLData.json",
      });
      (o.textContent = "Click here to download"),
        this._domNodes.componentNode.appendChild(o),
        o.click(),
        this._domNodes.componentNode.removeChild(o);
    }
  };
  function tn(t) {
    if (null == t) return [[]];
    for (var e = Me(t), o = [], i = 0, s = e[0].y; s <= e[1].y; s++) {
      o.push([]);
      for (var l = e[0].x; l <= e[1].x; l++) {
        var n =
          this._cellStore[this._rowList[s] - 1][this._colList[l] - 1].value;
        o[i].push(n);
      }
      i++;
    }
    return o;
  }
  function en(t) {
    if (null == t) return "";
    for (var e = "", o = Me(t), i = o[0].y; i <= o[1].y; i++) {
      for (var s = o[0].x; s <= o[1].x; s++)
        (e +=
          this._cellStore[this._rowList[i] - 1][this._colList[s] - 1].value ||
          ""),
          s < o[1].x && (e += "\t");
      i < o[1].y && (e += "\n");
    }
    return "" == e && (e += "\n"), e;
  }
  function on(t) {
    if ((void 0 === t && (t = null), null != t)) {
      var e = !1;
      if (
        (Lo(t) &&
          ((t = [
            { x: t.x, y: t.y },
            { x: t.x, y: t.y },
          ]),
          (e = !0)),
        Po(t))
      )
        return e
          ? ql.call(this, this._rowList[t[0].y], this._colList[t[0].x])
          : this.getCellRangeData(t);
    }
  }
  function sn(t) {
    if ((void 0 === t && (t = null), null == t)) var e = this._dataFormat;
    var o = [];
    if ("objectCollection" == e)
      for (var i = 0; i < this._rowList.length; i++) {
        for (var s = {}, l = 0; l < this._colList.length; l++) {
          s[(n = this._colStore[this._colList[l] - 1]).field] =
            this._cellStore[this._rowList[i] - 1][n.id - 1].value;
        }
        o.push(s);
      }
    else if ("arrayCollection" == e)
      for (i = 0; i < this._rowList.length; i++) {
        for (s = [], l = 0; l < this._colList.length; l++) {
          var n = this._colStore[this._colList[l] - 1];
          s[l] = this._cellStore[this._rowList[i] - 1][n.id - 1].value;
        }
        o.push(s);
      }
    return o;
  }
  function ln() {
    (this._rowList = []),
      (this._colList = []),
      (this._rowStore = []),
      delete this._rowStore._lastId,
      (this._colStore = []),
      delete this._colStore._lastId,
      (this._cellStore = []);
  }
  function nn(t, e) {
    if (
      (void 0 === t && (t = null),
      void 0 === e && (e = null),
      (null != t || null != e) && (I(t) || R(t)))
    ) {
      for (
        ln.call(this),
          this.undoManager.clear(),
          E.call(this, t, e),
          zt.call(this, this._viewportPosition.x),
          It.call(this, this._viewportPosition.y),
          Lt.call(this),
          bs.call(this),
          Vt.call(this);
        this._domNodes.cellValuesNode.children.length > 1;

      )
        this._domNodes.cellValuesNode.removeChild(
          this._domNodes.cellValuesNode.lastChild
        );
      null != this.getCellSelection() &&
        ((this._cellSelection = [
          { x: 0, y: 0 },
          { x: 0, y: 0 },
        ]),
        (this._cellCursorPosition = { x: 0, y: 0 })),
        Ho.call(this);
    }
  }
  function rn() {
    var t = ["inline", "opened"];
    if (this._isEditorOpen) {
      (this._isEditorOpen = !1),
        (this._domNodes.valueEditorNode.value = ""),
        (this._domNodes.valueEditorNode.style.display = "none"),
        this._domNodes.valueEditorNode.blur(),
        Le.call(this) ? Ms.call(this) : Rs.call(this),
        Go.call(this);
      for (var e = 0; e < t.length; e++)
        this._domNodes.componentNode.classList.remove("dgxl-editMode-" + t[e]);
    }
  }
  function hn() {
    if ("_coords" in this._domNodes.valueEditorNode) {
      var t = this._domNodes.valueEditorNode.value,
        e = JSON.parse(this._domNodes.valueEditorNode._coords);
      this.closeEditor(), this.setCellValues(e, t, !1, !1);
    }
  }
  function cn(t) {
    if ((void 0 === t && (t = "opened"), null != this.getCellSelection())) {
      if (
        -1 != ["inline", "opened"].indexOf(t) &&
        null != this.getCellCursorPosition() &&
        !this._isEditorOpen
      ) {
        "inline" == t && Ki.call(this, "valueEditorNode", "mousedown"),
          (this._domNodes.valueEditorNode._coords = JSON.stringify(
            this._cellCursorPosition
          )),
          (this._domNodes.valueEditorNode._mode = t);
        var e = Yo.call(this, this._cellCursorPosition);
        this.moveViewportPosition(e),
          (this._domNodes.valueEditorNode.style.borderColor =
            this.getThemeSetting(t + "EditorBorderColor"));
        var o = $e.call(this, this._cellCursorPosition, "viewport");
        if (
          ((this._domNodes.valueEditorNode.style.left = o.x + "px"),
          (this._domNodes.valueEditorNode.style.top = o.y + "px"),
          (this._domNodes.valueEditorNode.style.height =
            this.rowHeight + 1 + "px"),
          "opened" == t &&
            (this._domNodes.valueEditorNode.value = this.getCellValues(
              this._cellCursorPosition
            )),
          No.call(this),
          (this._domNodes.valueEditorNode.style.display = "block"),
          this._domNodes.valueEditorNode.focus(),
          "opened" == t && (this._isIE || this._isIOS || this._isMacOS))
        ) {
          var i = this._domNodes.valueEditorNode.value;
          (this._domNodes.valueEditorNode.value = ""),
            (this._domNodes.valueEditorNode.value = i);
        }
        Wo.call(this, "edit" + P(t)), (this._isEditorOpen = !0);
      }
    }
  }
  function dn(t) {
    return t in this.locale && null !== this.locale[t]
      ? this.locale[t]
      : t in this._defaultLocale && null !== this._defaultLocale[t]
      ? this._defaultLocale[t]
      : t;
  }
  function an() {
    var t = this;
    (this._rowSelection = null),
      (this._colSelection = null),
      (this._cellSelection = null),
      (this._cellCursorPosition = null),
      this._isEditorOpen && this.closeEditorAndSave(),
      this.showColHeaders && Bo.call(this),
      requestAnimationFrame(function () {
        bo.call(t);
      });
    var e = this.getCellCursorPosition(),
      o = this.getCellSelection();
    (this._prevSelection && Ko(this._prevSelection.cellRange, o)) ||
      this.events.dispatch("cellselectionchange", { cellSelection: o }),
      (this._prevSelection && Fo(this._prevSelection.cellCursorPosition, e)) ||
        this.events.dispatch("cellcursorpositionchange", {
          cellCursorPosition: e,
        }),
      (this._prevSelection = Do.call(this));
  }
  function un(t) {
    null == this.getNormalizedColSelection()
      ? null == this.getNormalizedRowSelection()
        ? null == this.getNormalizedCellSelection() || gn.call(this, t)
        : _n.call(this, t)
      : pn.call(this, t);
  }
  var pn = function (t) {
      if ("up" != t && "down" != t) {
        var e,
          o = this.getColSelection(),
          i = this.getNormalizedColSelection(),
          s = this.getCellCursorPosition();
        "right" == t
          ? s.x == i[0]
            ? o[1] >= o[0]
              ? (jo.call(
                  this,
                  [
                    { x: o[0], y: 0 },
                    { x: o[1] + 1, y: this._rowList.length - 1 },
                  ],
                  null,
                  !1,
                  "col"
                ),
                (e = 1))
              : (jo.call(
                  this,
                  [
                    { x: o[0] + 1, y: 0 },
                    { x: o[1], y: this._rowList.length - 1 },
                  ],
                  null,
                  !1,
                  "col"
                ),
                (e = 0))
            : o[1] >= o[0]
            ? (jo.call(
                this,
                [
                  { x: o[0] + 1, y: 0 },
                  { x: o[1], y: this._rowList.length - 1 },
                ],
                null,
                !1,
                "col"
              ),
              (e = 0))
            : (jo.call(
                this,
                [
                  { x: o[0], y: 0 },
                  { x: o[1] + 1, y: this._rowList.length - 1 },
                ],
                null,
                !1,
                "col"
              ),
              (e = 1))
          : "left" == t &&
            (s.x == i[1]
              ? o[1] >= o[0]
                ? (jo.call(
                    this,
                    [
                      { x: o[0] - 1, y: 0 },
                      { x: o[1], y: this._rowList.length - 1 },
                    ],
                    null,
                    !1,
                    "col"
                  ),
                  (e = 0))
                : (jo.call(
                    this,
                    [
                      { x: o[0], y: 0 },
                      { x: o[1] - 1, y: this._rowList.length - 1 },
                    ],
                    null,
                    !1,
                    "col"
                  ),
                  (e = 1))
              : o[1] >= o[0]
              ? (jo.call(
                  this,
                  [
                    { x: o[0], y: 0 },
                    { x: o[1] - 1, y: this._rowList.length - 1 },
                  ],
                  null,
                  !1,
                  "col"
                ),
                (e = 1))
              : (jo.call(
                  this,
                  [
                    { x: o[0] - 1, y: 0 },
                    { x: o[1], y: this._rowList.length - 1 },
                  ],
                  null,
                  !1,
                  "col"
                ),
                (e = 0))),
          this.moveViewportPosition(
            Yo.call(this, { x: this.getColSelection()[e], y: 0 }, "x")
          );
      }
    },
    _n = function (t) {
      if ("left" != t && "right" != t) {
        var e,
          o = this.getRowSelection(),
          i = this.getNormalizedRowSelection(),
          s = this.getCellCursorPosition();
        "down" == t
          ? s.y == i[0]
            ? o[1] >= o[0]
              ? (jo.call(
                  this,
                  [
                    { x: 0, y: o[0] },
                    { x: this._colList.length - 1, y: o[1] + 1 },
                  ],
                  null,
                  !1,
                  "row"
                ),
                (e = 1))
              : (jo.call(
                  this,
                  [
                    { x: 0, y: o[0] + 1 },
                    { x: this._colList.length - 1, y: o[1] },
                  ],
                  null,
                  !1,
                  "row"
                ),
                (e = 0))
            : o[1] >= o[0]
            ? (jo.call(
                this,
                [
                  { x: 0, y: o[0] + 1 },
                  { x: this._colList.length - 1, y: o[1] },
                ],
                null,
                !1,
                "row"
              ),
              (e = 0))
            : (jo.call(
                this,
                [
                  { x: 0, y: o[0] },
                  { x: this._colList.length - 1, y: o[1] + 1 },
                ],
                null,
                !1,
                "row"
              ),
              (e = 1))
          : "up" == t &&
            (s.y == i[1]
              ? o[1] >= o[0]
                ? (jo.call(
                    this,
                    [
                      { x: 0, y: o[0] - 1 },
                      { x: this._colList.length - 1, y: o[1] },
                    ],
                    null,
                    !1,
                    "row"
                  ),
                  (e = 0))
                : (jo.call(
                    this,
                    [
                      { x: 0, y: o[0] },
                      { x: this._colList.length - 1, y: o[1] - 1 },
                    ],
                    null,
                    !1,
                    "row"
                  ),
                  (e = 1))
              : o[1] >= o[0]
              ? (jo.call(
                  this,
                  [
                    { x: 0, y: o[0] },
                    { x: this._colList.length - 1, y: o[1] - 1 },
                  ],
                  null,
                  !1,
                  "row"
                ),
                (e = 1))
              : (jo.call(
                  this,
                  [
                    { x: 0, y: o[0] - 1 },
                    { x: this._colList.length - 1, y: o[1] },
                  ],
                  null,
                  !1,
                  "row"
                ),
                (e = 0))),
          this.moveViewportPosition(
            Yo.call(this, { x: 0, y: this.getRowSelection()[e] }, "y")
          );
      }
    },
    gn = function (t) {
      var e,
        o,
        i = this.getCellSelection(),
        s = this.getNormalizedCellSelection(),
        l = this.getCellCursorPosition();
      "right" == t
        ? ((e = "x"),
          l.x == s[0].x
            ? i[1].x >= i[0].x
              ? (jo.call(
                  this,
                  [
                    { x: i[0].x, y: i[0].y },
                    { x: i[1].x + 1, y: i[1].y },
                  ],
                  null,
                  !1
                ),
                (o = 1))
              : (jo.call(
                  this,
                  [
                    { x: i[0].x + 1, y: i[0].y },
                    { x: i[1].x, y: i[1].y },
                  ],
                  null,
                  !1
                ),
                (o = 0))
            : i[1].x >= i[0].x
            ? (jo.call(
                this,
                [
                  { x: i[0].x + 1, y: i[0].y },
                  { x: i[1].x, y: i[1].y },
                ],
                null,
                !1
              ),
              (o = 0))
            : (jo.call(
                this,
                [
                  { x: i[0].x, y: i[0].y },
                  { x: i[1].x + 1, y: i[1].y },
                ],
                null,
                !1
              ),
              (o = 1)))
        : "left" == t
        ? ((e = "x"),
          l.x == s[1].x
            ? i[1].x >= i[0].x
              ? (jo.call(
                  this,
                  [
                    { x: i[0].x - 1, y: i[0].y },
                    { x: i[1].x, y: i[1].y },
                  ],
                  null,
                  !1
                ),
                (o = 0))
              : (jo.call(
                  this,
                  [
                    { x: i[0].x, y: i[0].y },
                    { x: i[1].x - 1, y: i[1].y },
                  ],
                  null,
                  !1
                ),
                (o = 1))
            : i[1].x >= i[0].x
            ? (jo.call(
                this,
                [
                  { x: i[0].x, y: i[0].y },
                  { x: i[1].x - 1, y: i[1].y },
                ],
                null,
                !1
              ),
              (o = 1))
            : (jo.call(
                this,
                [
                  { x: i[0].x - 1, y: i[0].y },
                  { x: i[1].x, y: i[1].y },
                ],
                null,
                !1
              ),
              (o = 0)))
        : "down" == t
        ? ((e = "y"),
          l.y == s[0].y
            ? i[1].y >= i[0].y
              ? (jo.call(
                  this,
                  [
                    { x: i[0].x, y: i[0].y },
                    { x: i[1].x, y: i[1].y + 1 },
                  ],
                  null,
                  !1
                ),
                (o = 1))
              : (jo.call(
                  this,
                  [
                    { x: i[0].x, y: i[0].y + 1 },
                    { x: i[1].x, y: i[1].y },
                  ],
                  null,
                  !1
                ),
                (o = 0))
            : i[1].y >= i[0].y
            ? (jo.call(
                this,
                [
                  { x: i[0].x, y: i[0].y + 1 },
                  { x: i[1].x, y: i[1].y },
                ],
                null,
                !1
              ),
              (o = 0))
            : (jo.call(
                this,
                [
                  { x: i[0].x, y: i[0].y },
                  { x: i[1].x, y: i[1].y + 1 },
                ],
                null,
                !1
              ),
              (o = 1)))
        : "up" == t &&
          ((e = "y"),
          l.y == s[1].y
            ? i[1].y >= i[0].y
              ? (jo.call(
                  this,
                  [
                    { x: i[0].x, y: i[0].y - 1 },
                    { x: i[1].x, y: i[1].y },
                  ],
                  null,
                  !1
                ),
                (o = 0))
              : (jo.call(
                  this,
                  [
                    { x: i[0].x, y: i[0].y },
                    { x: i[1].x, y: i[1].y - 1 },
                  ],
                  null,
                  !1
                ),
                (o = 1))
            : i[1].y >= i[0].y
            ? (jo.call(
                this,
                [
                  { x: i[0].x, y: i[0].y },
                  { x: i[1].x, y: i[1].y - 1 },
                ],
                null,
                !1
              ),
              (o = 1))
            : (jo.call(
                this,
                [
                  { x: i[0].x, y: i[0].y - 1 },
                  { x: i[1].x, y: i[1].y },
                ],
                null,
                !1
              ),
              (o = 0))),
        this.moveViewportPosition(Yo.call(this, this.getCellSelection()[o], e));
    };
  function fn() {
    return this._cellSelection;
  }
  function mn() {
    return Me(this._cellSelection);
  }
  function vn(t) {
    if ((void 0 === t && (t = !0), t))
      var e = { x: this._viewportPosition.x, y: this._viewportPosition.y };
    else e = null;
    jo.call(
      this,
      [
        { x: 0, y: 0 },
        { x: this._colList.length - 1, y: this._rowList.length - 1 },
      ],
      e
    ),
      this.constructor.contextMenu.isOpen() &&
        this.constructor.contextMenu.close();
  }
  function yn(t, e, o) {
    if (
      (void 0 === t && (t = null),
      void 0 === e && (e = !0),
      void 0 === o && (o = !0),
      null != t)
    ) {
      if (Po(t))
        var i = [
          ko.call(this, t[0], "document"),
          ko.call(this, t[1], "document"),
        ];
      else {
        if (!Lo(t)) return;
        i = [ko.call(this, t, "document"), ko.call(this, t, "document")];
      }
      var s = { x: i[0].x, y: i[0].y };
      !e && Ue(this._cellCursorPosition, i) && (s = null),
        jo.call(this, i, s, o);
    }
  }
  function xn() {
    return this._colSelection;
  }
  function Nn() {
    return Me(this._colSelection);
  }
  function wn(t, e, o) {
    if (
      (void 0 === t && (t = null),
      void 0 === e && (e = !0),
      void 0 === o && (o = !0),
      null != t)
    ) {
      if (M(t))
        var i = $s.call(this, t[0], "document"),
          s = $s.call(this, t[1], "document");
      else
        (i = $s.call(this, t, "document")), (s = $s.call(this, t, "document"));
      var l = [
          { x: i, y: 0 },
          { x: s, y: this._rowList.length - 1 },
        ],
        n = { x: i, y: this._viewportPosition.y };
      !e && Ue(this._cellCursorPosition, l) && (n = null),
        jo.call(this, l, n, o, "col");
    }
  }
  function Cn() {
    return this._rowSelection;
  }
  function Sn() {
    return Me(this._rowSelection);
  }
  function bn(t, e, o) {
    if (
      (void 0 === t && (t = null),
      void 0 === e && (e = !0),
      void 0 === o && (o = !0),
      null != t)
    ) {
      if (M(t))
        var i = vl.call(this, t[0], "document"),
          s = vl.call(this, t[1], "document");
      else
        (i = vl.call(this, t, "document")), (s = vl.call(this, t, "document"));
      var l = [
          { x: 0, y: i },
          { x: this._colList.length - 1, y: s },
        ],
        n = { x: this._viewportPosition.x, y: i };
      !e && Ue(this._cellCursorPosition, l) && (n = null),
        jo.call(this, l, n, o, "row");
    }
  }
  function Hn(t) {
    return void 0 === this._rowStore[t - 1] ? null : this._rowStore[t - 1];
  }
  function Tn(t) {
    return void 0 === this._colStore[t - 1] ? null : this._colStore[t - 1];
  }
  function Ln(t, e) {
    return this._cellStore[t - 1] && this._cellStore[t - 1][e - 1]
      ? this._cellStore[t - 1][e - 1]
      : null;
  }
  function Pn(t) {
    if (A(t)) {
      (this.theme = t),
        (this._domNodes.componentNode.style.backgroundColor =
          this.getThemeSetting("documentColor")),
        (this._domNodes.valueEditorNode.style.backgroundColor =
          this.getThemeSetting("documentColor")),
        (this._domNodes.fillHandleNode.style.backgroundColor =
          this.getThemeSetting("documentColor")),
        (this._domNodes.colHeaderBackgroundNode.style.backgroundColor =
          this.getThemeSetting("colHeaderBackgroundColor")),
        (this._domNodes.colHeaderHighlightNode.style.backgroundColor =
          this.getThemeSetting("colHeaderHighlightBackgroundColor")),
        (this._domNodes.colHeaderSelectedNode.style.backgroundColor =
          this.getThemeSetting("colHeaderSelectedBackgroundColor"));
      for (
        var e = this.getNormalizedColSelection(), o = 0;
        o < this._colStore.length;
        o++
      )
        this._colStore[o].node.lastChild.style.color =
          this.getThemeSetting("textColor");
      if (this.showColHeaders)
        for (o = 0; o < this._colStore.length; o++)
          null != e &&
          this._colList.indexOf(this._colStore[o].id) >= e[0] &&
          this._colList.indexOf(this._colStore[o].id) <= e[1]
            ? ((this._colStore[o].node.firstChild.firstChild.style.color =
                this.getThemeSetting("colHeaderSelectedTextColor")),
              (this._colStore[o].node.firstChild.lastChild.style.color =
                this.getThemeSetting("colHeaderSelectedTextColor")))
            : ((this._colStore[o].node.firstChild.firstChild.style.color =
                this.getThemeSetting("colHeaderTextColor")),
              (this._colStore[o].node.firstChild.lastChild.style.color =
                this.getThemeSetting("colHeaderTextColor")));
      (this._domNodes.rowHeaderBackgroundNode.style.backgroundColor =
        this.getThemeSetting("rowHeaderBackgroundColor")),
        (this._domNodes.rowHeaderHighlightNode.style.backgroundColor =
          this.getThemeSetting("rowHeaderHighlightBackgroundColor")),
        (this._domNodes.rowHeaderSelectedNode.style.backgroundColor =
          this.getThemeSetting("rowHeaderSelectedBackgroundColor")),
        this.showRowHeaders &&
          (this._domNodes.cellValuesNode.children[0].lastChild.style.color =
            this.getThemeSetting("rowHeaderTextColor"));
      var i = this._domNodes.componentNode.getElementsByClassName(
        "dgxl-selectedRowRange"
      );
      i.length &&
        (i[0].style.color = this.getThemeSetting("rowHeaderSelectedTextColor")),
        (this._domNodes.valueEditorNode.style.color =
          this.getThemeSetting("textColor")),
        (this._domNodes.blankSheetRightNode.style.backgroundColor =
          this.getThemeSetting("sheetColor")),
        (this._domNodes.blankSheetBottomNode.style.backgroundColor =
          this.getThemeSetting("sheetColor")),
        (this._domNodes.gridLinesNode.style.opacity =
          this.getThemeSetting("gridLineOpacity"));
      for (o = 0; o < this._colLines.length; o++)
        0 == o &&
          (this._colLines[o].node.previousSibling.style.borderColor =
            this.getThemeSetting("gridLineHeaderColor")),
          (this._colLines[o].node.style.borderColor =
            this.getThemeSetting("gridLineColor")),
          (this._colLines[o].node.firstChild.style.borderColor =
            this.getThemeSetting("gridLineHeaderColor"));
      var s =
        this._domNodes.componentNode.getElementsByClassName("dgxl-rowLine");
      for (o = 0; o < s.length; o++)
        0 == o
          ? (s[o].style.borderColor = this.getThemeSetting(
              "gridLineHeaderColor"
            ))
          : ((s[o].style.borderColor = this.getThemeSetting("gridLineColor")),
            (s[o].firstChild.style.borderColor = this.getThemeSetting(
              "gridLineHeaderColor"
            )));
      if (
        ((this._domNodes.cellSelectionBorderNode.style.borderColor =
          this.getThemeSetting("cellSelectionBorderColor")),
        (this._domNodes.cellSelectionNode.style.backgroundColor =
          this.getThemeSetting("cellSelectionBackgroundColor")),
        (this._domNodes.cellCursorNode.style.borderColor =
          this.getThemeSetting("cellCursorColor")),
        (this._domNodes.fillHandleInnerNode.style.backgroundColor =
          this.getThemeSetting("fillHandleColor")),
        (this._domNodes.copyRangeNode.style.borderColor = this.getThemeSetting(
          "copyRangeBorderColor"
        )),
        (this._domNodes.cutRangeNode.style.borderColor = this.getThemeSetting(
          "cutRangeBorderColor"
        )),
        (this._domNodes.fillRangeNode.style.borderColor = this.getThemeSetting(
          "fillRangeBorderColor"
        )),
        this._domNodes.valueEditorNode._mode &&
          (this._domNodes.valueEditorNode.style.borderColor =
            this.getThemeSetting(
              this._domNodes.valueEditorNode._mode + "EditorBorderColor"
            )),
        this.constructor.contextMenu.isOpen())
      ) {
        (this.constructor.contextMenu._domNodes.containerNode.firstChild.style.backgroundColor =
          this.getThemeSetting("contextMenuBackgroundColor")),
          (this.constructor.contextMenu._domNodes.containerNode.firstChild.style.color =
            this.getThemeSetting("contextMenuTextColor"));
        this.constructor.contextMenu._domNodes.containerNode.getElementsByClassName(
          "dgxl-contextMenuItem-highlight"
        );
        highlightedItems.length &&
          (highlightedItems[0].style.backgroundColor = this.getThemeSetting(
            "contextMenuItemHighLightBackgroundColor"
          ));
      }
      (this._domNodes.colMoveGuideNode.style.backgroundColor =
        this.getThemeSetting("colMoveGuideColor")),
        (this._domNodes.rowMoveGuideNode.style.backgroundColor =
          this.getThemeSetting("rowMoveGuideColor")),
        (this._domNodes.colMoveGhostNode.style.backgroundColor =
          this.getThemeSetting("colMoveGhostColor")),
        (this._domNodes.rowMoveGhostNode.style.backgroundColor =
          this.getThemeSetting("rowMoveGhostColor")),
        (this._domNodes.colResizeHintNode.style.backgroundColor =
          this.getThemeSetting("colResizeGuideHandleColor")),
        (this._domNodes.colResizeGuideNode.style.borderColor =
          this.getThemeSetting("colResizeGuideLineColor")),
        (this._domNodes.colResizeGuideNode.firstChild.style.backgroundColor =
          this.getThemeSetting("colResizeGuideHandleColor")),
        (this._domNodes.horizontalScrollbarNode.style.backgroundColor =
          this.getThemeSetting("scrollbarBackgroundColor")),
        (this._domNodes.verticalScrollbarNode.style.backgroundColor =
          this.getThemeSetting("scrollbarBackgroundColor"));
    }
  }
  function kn(t) {
    return this.theme[t] || this._defaultTheme[t];
  }
  function Mn() {
    this.constructor.contextMenu.isOpen() &&
      this.constructor.contextMenu.close(),
      this.undoManager.hasUndo() && this.undoManager.undo();
  }
  function Rn() {
    this.constructor.contextMenu.isOpen() &&
      this.constructor.contextMenu.close(),
      this.undoManager.hasRedo() && this.undoManager.redo();
  }
  function An() {
    return G(this._viewportPosition);
  }
  function In(t) {
    null != this._viewportPosition &&
      ((0 == t.x && 0 == t.y) ||
        this.setViewportPosition({
          x: this._viewportPosition.x + t.x,
          y: this._viewportPosition.y + t.y,
        }));
  }
  function zn() {
    this._isIOS ||
      (this._domNodes.clipboardNode.focus(),
      this._domNodes.clipboardNode.setSelectionRange(0, 1),
      this._domNodes.clipboardNode.removeAttribute("readonly"),
      F(this._domNodes.clipboardNode, { "user-select": "auto" }));
  }
  function On() {
    this._isIOS || F(this._domNodes.clipboardNode, { "user-select": "none" });
  }
  function En() {
    var t = this;
    if (this.showColHeaders)
      for (var e = 0; e < this._colList.length; e++) {
        var o = this._colList[e],
          i = (r = this._colStore[o - 1]).node.firstChild.firstChild,
          s = Ot.call(this, e),
          l = this.colHeaderLabelFunction.call(this, e, o, r.field, r.title, s);
        i.innerHTML = String(l).replace(/\n/g, "↵").replace(/\t/g, "");
      }
    if (this.showColHeaders && this.showSortIndicator) {
      var n;
      for (e = 0; e < this._colList.length; e++) {
        o = this._colList[e];
        for (
          var r,
            h = (r = this._colStore[o - 1]).node.firstChild.lastChild,
            c = 0;
          c < this._sortState.length;
          c++
        )
          if (((n = !1), this._sortState[c][0] == o)) {
            "asc" == this._sortState[c][1]
              ? (h.textContent = "↑")
              : (h.textContent = "↓"),
              (n = !0);
            break;
          }
        n || (h.textContent = "");
      }
    }
    requestAnimationFrame(function () {
      bo.call(t);
    });
  }
  function Vn(t) {
    if (!this._sortState.length) {
      this._rowOrderStore = [];
      for (var e = 0; e < this._rowList.length; e++)
        this._rowOrderStore[this._rowList[e] - 1] = this._rowList.length - e;
    }
    var o,
      i = [];
    for (e = 0; e < this._rowList.length; e++) {
      for (var s = [], l = 0; l < t.length; l++)
        null ===
          (o = this._cellStore[this._rowList[e] - 1][t[l][0] - 1].value) &&
          (o = ""),
          s.push(String(o));
      i.push({ values: s, id: this._rowList[e] });
    }
    var n = "";
    for (l = 0; l < t.length; l++)
      (n += t[l].join("-")), l < t.length - 1 && (n += "_");
    if (!(n in this._sortFunctions)) {
      var r = "return ";
      for (l = 0; l < t.length; l++)
        l > 0 && (r += " || "),
          (r += "("),
          (r += "a.values[" + l + "] === b.values[" + l + "] ? 0 : ("),
          (r += "a.values[" + l + "] == '' ? 1 : ("),
          (r += "b.values[" + l + "] == '' ? -1 : ("),
          "asc" == t[l][1]
            ? (r +=
                "a.values[0].localeCompare(b.values[0], undefined, { numeric: true, sensitivity: 'base' })")
            : "desc" == t[l][1] &&
              (r +=
                "b.values[0].localeCompare(a.values[0], undefined, { numeric: true, sensitivity: 'base' })"),
          (r += ")"),
          (r += ")"),
          (r += ")"),
          (r += ")");
      (r += ";"), (this._sortFunctions[n] = new Function("a,b", r));
    }
    i.sort(this._sortFunctions[n]);
    var h = [];
    for (l = 0; l < i.length; l++) h.push(i[l].id);
    (this._rowList = h), (this._sortState = t);
  }
  function Dn(t) {
    for (var e, o = [], i = 0; i < this._rowList.length; i++)
      (e = this._rowOrderStore[this._rowList[i] - 1] || 0),
        o.push({ value: e, id: this._rowList[i] });
    o.sort(this._sortFunctions.reset);
    t = [];
    for (var s = 0; s < o.length; s++) t.push(o[s].id);
    (this._rowList = t), (this._sortState = []), (this._rowOrderStore = []);
  }
  function Fn(t, e, o) {
    void 0 === e && (e = !0), void 0 === o && (o = null);
    var i,
      s = this._sortState.slice(0),
      l = Do.call(this);
    Vn.call(this, t),
      sl.call(this, !1, !0),
      null != o && o.call(this),
      (i = Do.call(this)),
      e &&
        this.undoManager.add({
          desc: "Sort",
          undo: function () {
            s.length ? Vn.call(this, s) : Dn.call(this),
              sl.call(this, !1, !0),
              Uo.call(this, l);
          },
          redo: function () {
            Vn.call(this, t), sl.call(this, !1, !0), Uo.call(this, i);
          },
        });
  }
  function Kn(t, e) {
    void 0 === t && (t = null), void 0 === e && (e = null);
    var o = ["asc", "desc"];
    if (null !== t) {
      var i = this._colList[t],
        s = "asc";
      if (null === e)
        this._sortState.length &&
          1 == this._sortState.length &&
          this._sortState[0][0] == i &&
          (s = o[+!o.indexOf(this._sortState[0][1])]);
      else {
        if (!(o.indexOf(e) > -1)) return;
        s = e;
      }
      var l = [[i, s]];
      Fn.call(this, l, !0, function () {});
    }
  }
  function Bn(t, e) {
    if (
      (void 0 === t && (t = !0),
      void 0 === e && (e = null),
      this._rowOrderStore.length && this._sortState.length)
    ) {
      var o,
        i = this._sortState.slice(0),
        s = Do.call(this);
      Dn.call(this),
        sl.call(this, !1, !0),
        null != e && e.call(this),
        (o = Do.call(this)),
        t &&
          this.undoManager.add({
            desc: "Clear Sort",
            undo: function () {
              Vn.call(this, i), sl.call(this, !1, !0), Uo.call(this, s);
            },
            redo: function () {
              Dn.call(this), sl.call(this, !1, !0), Uo.call(this, o);
            },
          });
    }
  }
  function Wn() {
    this._sortState.length && Bn.call(this, !0, function () {});
  }
  var Gn = function (i, s) {
    void 0 === i && (i = null),
      void 0 === s && (s = {}),
      (this._isIE = u()),
      (this._isMacOS = e()),
      (this._isIOS =
        (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) ||
        ("MacIntel" === navigator.platform && navigator.maxTouchPoints > 1)),
      (this._isTouchDevice = window.matchMedia("(pointer: coarse)").matches),
      (this._isImageRenderingSupported = !u()),
      this._nativeScrollbarWidth,
      this._nativeScrollbarHeight,
      this._actualRowHeight,
      this._containerWidth,
      this._containerHeight,
      this._componentWidth,
      this._componentHeight,
      this._wholeDocumentWidth,
      this._wholeDocumentHeight,
      this._outerDocumentWidth,
      this._outerDocumentHeight,
      this._innerDocumentWidth,
      this._innerDocumentHeight,
      this._wholeViewportWidth,
      this._wholeViewportHeight,
      this._outerViewportWidth,
      this._outerViewportHeight,
      this._innerViewportWidth,
      this._innerViewportHeight,
      this._hoverArea,
      this._currentDragAction,
      (this._copyRange = null),
      (this._cutRange = null),
      (this._fillRange = null),
      (this._scrollLeft = 0),
      (this._scrollTop = 0),
      (this._viewportPosition = { x: 0, y: 0 }),
      this._prevSelection,
      (this._cellCursorPosition = null),
      (this._cellSelection = null),
      (this._colSelection = null),
      (this._rowSelection = null),
      (this._rowStore = []),
      (this._colStore = []),
      (this._cellStore = []),
      (this._rowOrderStore = []),
      (this._rowList = []),
      (this._colList = []),
      (this._sortState = []),
      (this._sortFunctions = {
        reset: new Function("a,b", "return b.value - a.value;"),
      }),
      (this._rowView = []),
      (this._colView = []),
      (this._rowViewOverflow = 0),
      (this._colViewOverflow = 0),
      (this._domNodes = {}),
      (this._contextMenuItemPresets = p),
      (this._contextMenuTouchItemPresets = _),
      (this._keyActionPresets = m),
      (this._keyActionSets = v),
      (this._headerLabelSeriesPresets = y),
      (this._headerLabelSeries = x),
      (this._defaultTheme = C),
      (this._defaultLocale = S),
      (this._editorFontFamily = "sans-serif"),
      (this._editorFontSize = 14),
      (this._isActive = !1),
      (this._isEditorOpen = !1),
      (this._activeKeyActionSet = void 0),
      (this.events = new t(this)),
      (this.keys = new o(this)),
      (this.undoManager = new c(this)),
      (this.allowCellEdit = !0),
      (this.allowCellFill = !0),
      (this.cellFillDirection = "xy"),
      (this.allowCopy = !0),
      (this.allowCut = !0),
      (this.allowPaste = !0),
      (this.delayedCut = !0),
      (this.allowColDelete = !0),
      (this.allowColInsert = !0),
      (this.allowColMove = !0),
      (this.allowColResize = !0),
      (this.undoableColResize = !1),
      (this.allowRowDelete = !0),
      (this.allowRowInsert = !0),
      (this.allowRowMove = !0),
      (this.allowSort = !1),
      (this.showSortIndicator = !1),
      (this.deactivateOnClickOutside = !0),
      (this.instantActivate = !1),
      (this.colHeaderHeight = 38),
      (this.colHeaderLabelFunction = N),
      (this.colHeaderLabelPrefix = ""),
      (this.colHeaderLabelSuffix = ""),
      (this.colHeaderLabelType = "letters"),
      (this.defaultColAlign = "left"),
      (this.defaultColHeaderLabelAlign = "left"),
      (this.defaultColWidth = 112),
      (this.showColHeaders = !0),
      (this.rowHeaderLabelAlign = "center"),
      (this.rowHeaderLabelFunction = w),
      (this.rowHeaderLabelPrefix = ""),
      (this.rowHeaderLabelSuffix = ""),
      (this.rowHeaderLabelType = "numbers"),
      (this.rowHeaderWidth = 56),
      (this.rowHeight = 30),
      (this.showRowHeaders = !0),
      (this.contextMenuItems = g),
      (this.contextMenuTouchItems = f),
      (this.locale = {}),
      (this.theme = {}),
      (this.cellPadding = 8),
      (this.includeOuterBorder = !0),
      (this.boldSelectedHeaders = !1),
      (this.showRowZebraStripes = !1),
      Xs.call(this, i, s);
  };
  return (
    (Gn.prototype._clearCellColors = function (t) {
      Ys.call(this, t);
    }),
    (Gn.prototype._setCellColors = function (t, e, o, i) {
      qs.call(this, t, e, o, i);
    }),
    (Gn.prototype.clearCellValues = function (t) {
      Zs.call(this, t);
    }),
    (Gn.prototype.setCellValues = function (t, e, o, i) {
      Jo.call(this, t, e, o, i);
    }),
    (Gn.prototype.copy = function () {
      Yl.call(this);
    }),
    (Gn.prototype.cut = function () {
      jl.call(this);
    }),
    (Gn.prototype.paste = function () {
      Ul.call(this);
    }),
    (Gn.prototype.deleteCols = function (t) {
      nl.call(this, t);
    }),
    (Gn.prototype.insertCols = function (t, e) {
      cl.call(this, t, e);
    }),
    (Gn.prototype.moveCols = function (t, e) {
      ul.call(this, t, e);
    }),
    (Gn.prototype.resizeCols = function (t, e) {
      fl.call(this, t, e);
    }),
    (Gn.prototype.resizeColsToFit = function (t) {
      ml.call(this, t);
    }),
    (Gn.prototype.deleteRows = function (t) {
      Sl.call(this, t);
    }),
    (Gn.prototype.insertRows = function (t, e) {
      Tl.call(this, t, e);
    }),
    (Gn.prototype.moveRows = function (t, e) {
      kl.call(this, t, e);
    }),
    (Gn.prototype.activate = function () {
      Ml.call(this);
    }),
    (Gn.prototype.deactivate = function () {
      Rl.call(this);
    }),
    (Gn.prototype.downloadDataAsCSV = function (t) {
      void 0 === t && (t = {}), Zl.call(this, t);
    }),
    (Gn.prototype.downloadDataAsJSON = function (t) {
      void 0 === t && (t = {}), Ql.call(this, t);
    }),
    (Gn.prototype.getCellRangeData = function (t) {
      return tn.call(this, t);
    }),
    (Gn.prototype.getCellRangeText = function (t) {
      return en.call(this, t);
    }),
    (Gn.prototype.getCellValues = function (t) {
      return on.call(this, t);
    }),
    (Gn.prototype.getData = function () {
      return sn.call(this);
    }),
    (Gn.prototype.setData = function (t, e) {
      nn.call(this, t, e);
    }),
    (Gn.prototype.closeEditor = function () {
      rn.call(this);
    }),
    (Gn.prototype.closeEditorAndSave = function () {
      hn.call(this);
    }),
    (Gn.prototype.openEditor = function (t) {
      cn.call(this, t);
    }),
    (Gn.prototype.getLocaleSetting = function (t) {
      return dn.call(this, t);
    }),
    (Gn.prototype.deselectAll = function () {
      an.call(this);
    }),
    (Gn.prototype.modifySelection = function (t) {
      un.call(this, t);
    }),
    (Gn.prototype.getCellCursorPosition = function () {
      return Al.call(this);
    }),
    (Gn.prototype.setCellCursorPosition = function (t, e, o) {
      Il.call(this, t, e, o);
    }),
    (Gn.prototype.moveCellCursor = function (t) {
      zl.call(this, t);
    }),
    (Gn.prototype.moveCellCursorInside = function (t) {
      Ol.call(this, t);
    }),
    (Gn.prototype.moveCellCursorOneViewportDown = function () {
      El.call(this);
    }),
    (Gn.prototype.moveCellCursorOneViewportUp = function () {
      Vl.call(this);
    }),
    (Gn.prototype.moveCellCursorToColEnd = function () {
      Dl.call(this);
    }),
    (Gn.prototype.moveCellCursorToColStart = function () {
      Fl.call(this);
    }),
    (Gn.prototype.moveCellCursorToDocumentEnd = function () {
      Kl.call(this);
    }),
    (Gn.prototype.moveCellCursorToDocumentStart = function () {
      Bl.call(this);
    }),
    (Gn.prototype.moveCellCursorToRowEnd = function () {
      Wl.call(this);
    }),
    (Gn.prototype.moveCellCursorToRowStart = function () {
      Gl.call(this);
    }),
    (Gn.prototype.getCellSelection = function () {
      return fn.call(this);
    }),
    (Gn.prototype.getNormalizedCellSelection = function () {
      return mn.call(this);
    }),
    (Gn.prototype.selectAll = function (t) {
      vn.call(this, t);
    }),
    (Gn.prototype.selectCells = function (t, e, o) {
      yn.call(this, t, e, o);
    }),
    (Gn.prototype.getColSelection = function () {
      return xn.call(this);
    }),
    (Gn.prototype.getNormalizedColSelection = function () {
      return Nn.call(this);
    }),
    (Gn.prototype.selectCols = function (t, e, o) {
      wn.call(this, t, e, o);
    }),
    (Gn.prototype.getNormalizedRowSelection = function () {
      return Sn.call(this);
    }),
    (Gn.prototype.getRowSelection = function () {
      return Cn.call(this);
    }),
    (Gn.prototype.selectRows = function (t, e, o) {
      bn.call(this, t, e, o);
    }),
    (Gn.prototype.getCellFromStore = function (t, e) {
      return Ln.call(this, t, e);
    }),
    (Gn.prototype.getColFromStore = function (t) {
      return Tn.call(this, t);
    }),
    (Gn.prototype.getRowFromStore = function (t) {
      return Hn.call(this, t);
    }),
    (Gn.prototype.getThemeSetting = function (t) {
      return kn.call(this, t);
    }),
    (Gn.prototype.setTheme = function (t) {
      Pn.call(this, t);
    }),
    (Gn.prototype.redo = function () {
      Rn.call(this);
    }),
    (Gn.prototype.undo = function () {
      Mn.call(this);
    }),
    (Gn.prototype.getViewportPosition = function () {
      return An.call(this);
    }),
    (Gn.prototype.setViewportPosition = function (t) {
      Li.call(this, t);
    }),
    (Gn.prototype.moveViewportPosition = function (t) {
      In.call(this, t);
    }),
    (Gn.prototype.fillCells = function (t, e, o) {
      Js.call(this, t, e, o);
    }),
    (Gn.prototype.redraw = function () {
      En.call(this);
    }),
    (Gn.prototype.enableClipboardInteraction = function () {
      zn.call(this);
    }),
    (Gn.prototype.disableClipboardInteraction = function () {
      On.call(this);
    }),
    (Gn.prototype.sort = function (t, e) {
      Kn.call(this, t, e);
    }),
    (Gn.prototype.clearSort = function () {
      Wn.call(this);
    }),
    (Gn.instances = []),
    (Gn._domNodes = {}),
    (Gn._clipboardObject = null),
    (Gn.createEmptyData = function (t, e) {
      for (var o = [], i = 0; i < t; i++) {
        o.push([]);
        for (var s = 0; s < e; s++) o[i].push(null);
      }
      return o;
    }),
    (Gn.createDummyData = function (t, e) {
      for (var o = [], i = 0; i < t; i++) {
        o.push([]);
        for (var s = 0; s < e; s++) o[i].push(i + 1 + ";" + (s + 1));
      }
      return o;
    }),
    (Gn.areCoordsEqual = Fo),
    Gn
  );
});
